<template>
  <div class="diagram">
    <div ref="diagramMain" class="diagram-main">
      <!-- <input type="file" id="XmlFile" style="display:none;" @change="loadXmlData" accept="text/xml, application/xml" /> -->
      <input
        id="JsonFile"
        type="file"
        style="display: none"
        accept="application/json"
        @change="loadJsonData"
      />
      <diagram-sidebar
        v-if="lf"
        class="diagram-sidebar"
        :lf="lf"
        :all-group="group"
        :is-hidden="isHidden"
        :refresh-a-i-agent="refreshAIAgent"
        :new-tab="newTab"
        :role="role"
        @dragInNode="$_dragInNode"
        @addAIAgent="$_addAIAgent"
        @openAnalyse="openAnalyse"
        @openJobReception="openJobReception"
        @openNewAnalyse="openNewAnalyse"
        @generateNode="$_generateNode"
        @openBackground="openBackground"
        @getBackground="getBackground"
        @setRefreshAIAgent="setRefreshAIAgent"
        @getIsHidden="getIsHidden"
        @getNewDataAll="getNewDataAll"
        @getClassName="getClassName"
        @clearIncreasingTrenTime="clearIncreasingTrenTime"
      />
      <div
        ref="container"
        class="diagram-container"
        :style="isAnalyse ? 'overflow-y: auto;' : ''"
        @mouseover="handleMouseover"
      >
        <div
          :style="
            !isAnalyse && !isNewAnalyse ? 'display:flex;height: 100%;' : 'display:none;'
          "
        >
          <div class="diagram-wrapper">
            <!-- <div v-if="user_group_flag" class="user_group_flag" @mouseover="user_group_mouseover">
              <el-icon><Avatar /></el-icon>
            </div> -->
            <div v-if="!isProjection" class="user_group">
              <div
                v-for="item of user_group"
                :key="item.userId"
                class="user_group_avatar"
                :title="item.userName != '' ? item.userName : '未知'"
              >
                {{ item.userName != "" ? item.userName.slice(0, 1) : "未" }}
                <div class="point"></div>
              </div>
            </div>
            <div
              v-if="top_menu && isFullscreen"
              class="top_menu"
              @mouseover="top_menu_icon_mouseover"
            >
              <el-icon size="16"><ArrowDown /></el-icon>
            </div>
            <div
              v-else
              :style="
                sidebarWidth > 1600
                  ? 'position: absolute;display: flex;justify-content: center;width: 100%;z-index: 1031;'
                  : 'position: absolute;display: flex;justify-content: center;width: 100%;flex-direction: column;align-items: center;z-index: 1031;'
              "
              class="diagram-toolbar-main"
              @mouseover="top_menu_mouseover"
              @mouseleave="top_menu_mouseleave"
            >
              <diagram-toolbar
                v-if="lf"
                class="diagram-toolbar"
                :lf="lf"
                :active-edges="activeEdges"
                :linetype="linetype"
                :last_node_id="last_node_id"
                :is-selection-select="isSelectionSelect"
                @changeNodeFillColor="$_changeNodeFill"
                @exportData="$_exportData"
                @importData="$_importData"
                @getTransformSize="getTransformSize"
                @changeLinetype="changeLinetype"
                @changeSelectionSelect="changeSelectionSelect"
                @draw="onBeginDraw"
              />
              <ButtonToolbar
                :group="group"
                :lf="lf"
                :sidebar-width="sidebarWidth"
                @full="full"
              />
            </div>
            <div ref="diagram" class="lf-diagram"></div>
            <img src="../assets/delete_nor.png" class="delete" style="display: none" />
            <DrawBoard v-if="isDrawing" ref="drawBoard" class="draw-board" :transform="lf.getTransform()" :presets="darwPresets" @close="onDrawDone" />
            <div class="DiagramRBToolbarDiv">
              <keep-alive>
                <div v-show="chat_room_switch">
                  <component
                    :is="'chatRoom'"
                    ref="chatroom"
                    class="chat_room_div"
                    :all-group="group"
                    :badge_number="badge_number"
                    :lf="lf"
                    @close="handle_chat_room_switch"
                    @badge_number="handle_badge_number"
                    @p_card="p_card"
                    @geneMarkdownCard="geneMarkdownCard"
                  ></component>
                </div>
              </keep-alive>
              <el-badge
                :value="badge_number"
                :title="languageData.chat_room"
                :max="99"
                :hidden="chatroom_message_swich"
              >
                <svg
                  class="chat_room_icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  @click="handle_chat_room_switch(chat_room_switch)"
                >
                  <circle
                    cx="24"
                    cy="24"
                    r="23"
                    fill="white"
                    stroke="#3681FC"
                    stroke-width="2"
                  />
                  <g filter="url(#filter0_ii_2037_14561)">
                    <path
                      d="M38 20.4307C38 19.6168 37.3402 18.957 36.5263 18.957H20.9053C20.0914 18.957 19.4316 19.6168 19.4316 20.4307V31.3017C19.4316 32.1156 20.0914 32.7754 20.9053 32.7754H29.0059L34.0316 36.6195C34.5165 36.9903 35.2161 36.6446 35.2161 36.0342V32.7754H36.5263C37.3402 32.7754 38 32.1156 38 31.3017V20.4307Z"
                      fill="#AECCFE"
                    />
                  </g>
                  <g filter="url(#filter1_dii_2037_14561)">
                    <path
                      d="M10 12.4737C10 11.6598 10.6598 11 11.4737 11H32.1053C32.9192 11 33.5789 11.6598 33.5789 12.4737V27.0734C33.5789 27.8873 32.9192 28.5471 32.1053 28.5471H21.4211L14.7196 33.6729C14.2347 34.0438 13.5351 33.6981 13.5351 33.0877V28.5471H11.4737C10.6598 28.5471 10 27.8873 10 27.0734V12.4737Z"
                      fill="#3681FC"
                    />
                  </g>
                  <g filter="url(#filter2_d_2037_14561)">
                    <path
                      d="M24.9901 24.6088V14.5371H26.5168V24.6088H24.9901Z"
                      fill="white"
                    />
                    <path
                      d="M18.1375 21.0029H21.0803L19.6227 16.6026H19.5951L18.1375 21.0029ZM22.2961 24.6088L21.5155 22.3568H17.6954L16.9217 24.6088H15.3053L18.9665 14.5371H20.2444L23.9056 24.6088H22.2961Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_ii_2037_14561"
                      x="18.2526"
                      y="17.7781"
                      width="21.5158"
                      height="20.7628"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1.76842" dy="1.76842" />
                      <feGaussianBlur stdDeviation="1.47368" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_2037_14561"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="-1.17895" dy="-1.17895" />
                      <feGaussianBlur stdDeviation="1.47368" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="effect1_innerShadow_2037_14561"
                        result="effect2_innerShadow_2037_14561"
                      />
                    </filter>
                    <filter
                      id="filter1_dii_2037_14561"
                      x="8.52632"
                      y="9.52632"
                      width="28.8842"
                      height="28.1314"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1.17895" dy="1.17895" />
                      <feGaussianBlur stdDeviation="1.32632" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2037_14561"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2037_14561"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1.76842" dy="1.76842" />
                      <feGaussianBlur stdDeviation="1.47368" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_2037_14561"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="-1.17895" dy="-1.17895" />
                      <feGaussianBlur stdDeviation="1.47368" />
                      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="effect2_innerShadow_2037_14561"
                        result="effect3_innerShadow_2037_14561"
                      />
                    </filter>
                    <filter
                      id="filter2_d_2037_14561"
                      x="12.9474"
                      y="11.5897"
                      width="17.1062"
                      height="15.966"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="0.589474" />
                      <feGaussianBlur stdDeviation="1.47368" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0745098 0 0 0 0 0.0974118 0 0 0 0 0.647059 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2037_14561"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2037_14561"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </el-badge>
              <div class="flex_x" style="justify-content: flex-end">
                <DiagramRBToolbar
                  v-if="lf"
                  :lf="lf"
                  :is-silent-mode="isSilentMode"
                  :is-show-mode="isShowMode"
                  :transform="transformSize"
                  :is-change-rate="isChangeRate"
                  @getTransformSize="getTransformSize"
                  @changeRate="changeRate"
                  @setIsSilentMode="setIsSilentMode"
                />
              </div>
            </div>
          </div>

          <PromptsPanel
            :is-prompts-list="isPromptsList"
            @changeisPromptsList="changeisPromptsList"
            @changePrompts="changePrompts"
          />

          <div
            style="
              position: fixed;
              right: 0;
              display: flex;
              flex-direction: row;
              height: 100%;
            "
          >
            <MyGroup
              :teach_id="user.userId"
              :all-group="group"
              :theme="theme"
              :active-nodes="activeNodes"
              :active-edges="activeEdges"
              :is-show-group="isShowGroup"
              @close="close_mygroup"
              @getData="getData"
              @changeSelectionSelect="changeSelectionSelect"
              @getGroup="getGroup"
              @getUserGroup="getUserGroup"
              @changeRate="changeRate"
              @changeIsShowGroup="changeIsShowGroup"
              @setIsSilentMode="setIsSilentModeNew"
              @setIsShowMode="setIsShowMode"
            ></MyGroup>
            <!-- 右侧属性面板 -->
            <PropertyPanel
              v-if="activeNodes.length > 0 || activeEdges.length > 0"
              class="diagram-panel"
              :lf="lf"
              :only-edge="activeNodes.length === 0"
              :elements-style="properties"
              :icon-list="iconList"
              :image-list="imageList"
              :video-list="videoList"
              :audio-list="audioList"
              :file-list="fileList"
              @setStyle="$_setStyle"
              @setIconList="$_setIconList"
              @setImageList="$_setImageList"
              @setVideoList="$_setVideoList"
              @setAudioList="$_setAudioList"
              @setFileList="$_setFileList"
              @setZIndex="$_setZIndex"
              @info="getImageInfo"
              @getSource="getSourceInfo"
              @iconInfo="getIconInfo"
              @title="getTitle"
              @showFile="showFile"
              @changeSelect="changeSelect"
              @changeisPromptsList="changeisPromptsList"
            />
          </div>
        </div>

        <div id="whiteBoard">
          <el-dialog
            :model-value="isBackgroundNew"
            width="60%"
            :show-close="false"
            :close-on-press-escape="false"
          >
            <template #header>
              <span style="width: 100%; position: relative">
                <el-button
                  type="primary"
                  size="small"
                  round
                  :title="languageData.replace"
                  @click="getBackgroundVal"
                >
                  {{ languageData.replace }}
                </el-button>

                <button
                  v-if="!fullscreen"
                  type="button"
                  class="max"
                  style="top: 4px; right: 20px"
                >
                  <img
                    v-if="hoverMax"
                    src="../assets/max_pre.png"
                    width="16"
                    height="16"
                    @mouseout="blurMax"
                    @click="clickMax"
                  />
                  <img
                    v-else
                    src="../assets/max_nor.png"
                    width="16"
                    height="16"
                    @mouseover="focusMax"
                  />
                </button>
                <button
                  v-else-if="fullscreen"
                  type="button"
                  class="max"
                  style="top: 4px; right: 20px"
                >
                  <img
                    v-if="hoverRecovery"
                    src="../assets/recovery_pre.png"
                    width="16"
                    height="16"
                    @mouseout="blurRecovery"
                    @click="clickRecovery"
                  />
                  <img
                    v-else
                    src="../assets/recovery_nor.png"
                    width="16"
                    height="16"
                    @mouseover="focusRecovery"
                  />
                </button>

                <button type="button" class="close" style="top: 4px; right: 0">
                  <img
                    v-if="hoverClose"
                    src="../assets/close_pre.png"
                    width="16"
                    height="16"
                    @mouseout="blurClose"
                    @click="handleClose"
                  />
                  <img
                    v-else
                    src="../assets/close_nor.png"
                    width="16"
                    height="16"
                    @mouseover="focusClose"
                  />
                </button>
              </span>
            </template>
            <span
              style="
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
              "
            >
              <iframe
                id="backgroundIframe"
                :src="iframe_url"
                style="
                  width: 100%;
                  height: 75vh;
                  border: none;
                  border-bottom-left-radius: 12px;
                  border-bottom-right-radius: 12px;
                "
              ></iframe>
            </span>
          </el-dialog>
        </div>

        <div id="background">
          <el-dialog
            :model-value="isBackground"
            width="30%"
            :show-close="false"
            :close-on-press-escape="false"
          >
            <template #header>
              <span style="width: 100%; position: relative">
                <span class="el-dialog__title">{{ languageData.tip120 }}</span>
                <button type="button" class="close" style="top: 4px; right: 0">
                  <img
                    v-if="hoverClose"
                    src="../assets/close_pre.png"
                    width="16"
                    height="16"
                    @mouseout="blurClose"
                    @click="handleCloseNew"
                  />
                  <img
                    v-else
                    src="../assets/close_nor.png"
                    width="16"
                    height="16"
                    @mouseover="focusClose"
                  />
                </button>
              </span>
            </template>
            <span
              style="
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: space-evenly;
                  align-items: center;
                  flex-direction: row;
                  width: 100%;
                "
              >
                <el-button type="primary" @click="selectFile">
                  {{ languageData.select_local_file }}
                </el-button>

                <el-button @click="openBackgroundNew">
                  {{ languageData.tip119 }}
                </el-button>
              </div>
              <input
                id="FileNew"
                type="file"
                style="display: none"
                accept="image/*"
                @change="uploadFile"
              />
            </span>
          </el-dialog>
        </div>

        <div
          :style="
            isAnalyse && !isNewAnalyse && !isBackground
              ? 'display:flex;height: 100%;'
              : 'display:none;'
          "
        >
          <div class="diagram-wrapper" style="margin-top: 0px; width: 100%">
            <div
              style="
                background: #ffffff;
                height: 80px;
                padding-top: 6px;
                padding-left: 30px;
                padding-right: 30px;
                border-bottom: #efefef solid 1px;
                color: #555555;
                font-size: 12px;
              "
            >
              <div style="">
                <div style="line-height: 20px">{{ languageData.nodeFiltering }}：</div>
                <el-radio-group
                  v-model="checked_isParticipate"
                  size="small"
                  @change="doFilter"
                >
                  <el-radio-button value="" label="">
                    {{ languageData.all }}
                  </el-radio-button>
                  <el-radio-button :value="false" :label="false">
                    {{ languageData.responsibleTasks }}
                  </el-radio-button>
                  <el-radio-button :value="true" :label="true">
                    {{ languageData.participatingTasks }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div
              style="
                width: 200px;
                height: 200px;
                position: absolute;
                bottom: 1%;
                z-index: 999;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  height: 100%;
                  width: 100%;
                "
              >
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 10px;
                    margin-left: 30px;
                  "
                >
                  <div
                    style="
                      width: 30px;
                      height: 30px;
                      border-radius: 15px;
                      background: #22314f;
                      margin-right: 15px;
                    "
                  ></div>
                  <span>{{ languageData.projectName }}</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 10px;
                    margin-left: 30px;
                  "
                >
                  <div
                    style="
                      width: 30px;
                      height: 30px;
                      border-radius: 15px;
                      background: #60416a;
                      margin-right: 15px;
                    "
                  ></div>
                  <span>{{ languageData.student }}</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 10px;
                    margin-left: 30px;
                  "
                >
                  <div
                    style="
                      width: 30px;
                      height: 30px;
                      border-radius: 15px;
                      background: #8cbbd7;
                      margin-right: 15px;
                    "
                  ></div>
                  <span>{{ languageData.responsibleTasks }}</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 10px;
                    margin-left: 30px;
                  "
                >
                  <div
                    style="
                      width: 30px;
                      height: 30px;
                      border-radius: 15px;
                      background: #aed6f3;
                      margin-right: 15px;
                    "
                  ></div>
                  <span>{{ languageData.participatingTasks }}</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    width: 100%;
                    margin-left: 30px;
                  "
                >
                  <div
                    style="
                      width: 30px;
                      height: 2px;
                      background: #ff0000;
                      margin-right: 15px;
                    "
                  ></div>
                  <span>{{ languageData.collaborate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!isAnalyse && isNewAnalyse && !isBackground"
          id="newAnalyse"
          v-loading="newAnalyseLoading"
          :element-loading-text="newAnalyseLoadingText"
          :style="
            !isAnalyse && isNewAnalyse && !isBackground
              ? 'display:flex;width:100%;height: 100%;background:#FFFFFF;flex-direction:column;'
              : ''
          "
        >
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane :label="languageData.whole" name="all">
              <div
                class="flex_x_sb"
                style="width: 90vw; padding: 20px 10px; margin-bottom: 20px"
              >
                <div class="echarts_item">
                  <div id="p_r_d" class="echarts_content"></div>
                </div>
                <div class="echarts_item">
                  <div id="lfc" class="echarts_content"></div>
                </div>
                <div class="echarts_item">
                  <div id="top6" class="echarts_content"></div>
                </div>
                <div class="echarts_item">
                  <div id="group_achievement" class="echarts_content"></div>
                </div>
                <div id="global_relationship_div" class="echarts_item">
                  <div
                    style="
                      margin-top: 20px;
                      position: absolute;
                      top: 20px;
                      left: 15px;
                      z-index: 2;
                      width: 120px;
                    "
                  >
                    <el-select
                      v-model="checkboxGroupValue"
                      placeholder="请选择"
                      @change="getcheckboxGroup"
                    >
                      <el-option
                        v-for="item in cities"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div id="global_relationship" class="echarts_content"></div>
                </div>
                <div class="echarts_item" style="border: none">
                  <div id="Increasing_trend" class="echarts_content"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="languageData.collaborate_new" name="collaborate">
              <div
                v-loading="groupLoading"
                style="width: 100%; height: 100%"
                :element-loading-text="newAnalyseLoadingText"
              >
                <div style="width: 100%; display: flex; justify-content: flex-end">
                  <el-select
                    v-if="selectGroupPageNum.length > 1"
                    v-model="selectGroupPage"
                    :placeholder="languageData.selectTip"
                    style="margin-right: 30px"
                    @change="selectPages"
                  >
                    <el-option
                      v-for="item in selectGroupPageNum"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  v-if="!groupLoading"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 20px 10px;
                    margin-bottom: 20px;
                  "
                >
                  <template v-for="(item, index) in selectStudentList" :key="index">
                    <div
                      style="
                        width: 25%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        justify-content: space-between;
                      "
                    >
                      <div
                        style="
                          color: #909399;
                          display: flex;
                          align-items: center;
                          width: calc(100% - 30px);
                        "
                      >
                        {{ item.name }} (<span
                          :title="item.allName"
                          class="gropu_all_name"
                          >{{ item.allName }}</span
                        >)
                      </div>
                      <div class="pie_share_group_chart">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.groupShare }}
                        </div>
                        <div
                          :id="'pie_share_group_' + item.id"
                          style="
                            width: calc(100%);
                            height: 420px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div class="relational_graph_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.personnelRelations }}
                        </div>
                        <div
                          :id="'relational_graph_' + item.id"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div class="relational_graph_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.heatRelations }}
                        </div>
                        <div
                          :id="'heat_' + item.id"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div class="relational_graph_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.resourceClass }}
                        </div>
                        <div
                          :id="'resource_class_group_' + item.id"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div class="relational_graph_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.character }}
                        </div>
                        <div
                          :id="'character_' + item.id"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="languageData.student_new" name="student">
              <div
                v-loading="personageLoading"
                style="width: 100%; height: 100%"
                :element-loading-text="newAnalyseLoadingText"
              >
                <div style="width: 100%; display: flex; justify-content: flex-end">
                  <el-select
                    v-if="group.length > 1"
                    v-model="select_group_value"
                    clearable
                    :placeholder="languageData.select_group_value"
                    style="margin-right: 30px"
                    @change="select_group"
                  >
                    <el-option
                      v-for="item in group"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="all_student.length > 1"
                    v-model="select_personage_value"
                    :placeholder="languageData.select_personage_value"
                    style="margin-right: 30px"
                    @change="select_personage"
                  >
                    <el-option
                      v-for="item in all_student"
                      :key="item.userid"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-if="selectStudentPageNum.length > 1"
                    v-model="selectStudentPage"
                    :placeholder="languageData.selectTip"
                    style="margin-right: 30px"
                    @change="selectPage"
                  >
                    <el-option
                      v-for="item in selectStudentPageNum"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 20px 10px;
                    margin-bottom: 20px;
                  "
                >
                  <template v-for="(item, index) in selectStudentList" :key="index">
                    <div style="" class="user_class">
                      <div
                        style="
                          color: #909399;
                          display: flex;
                          align-items: center;
                          width: calc(100% - 30px);
                        "
                      >
                        <div
                          class="user_avatar"
                          :title="item.name != '' ? item.name : '未知'"
                        >
                          {{ item.name != "" ? item.name.slice(0, 1) : "未" }}
                        </div>
                        {{ item.name != "" ? item.name : "未知" }}
                      </div>
                      <div class="radar_chart">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.personalImage }}
                        </div>
                        <div
                          :id="'radar_' + item.userid"
                          style="
                            width: calc(100%);
                            height: 280px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>

                      <div class="columnar_chart">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.personalProfile }}
                        </div>
                        <div
                          :id="'columnar_' + item.userid"
                          style="
                            width: calc(100%);
                            height: 420px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>

                      <div class="stacked_area_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.resourceContribution }}
                        </div>
                        <div
                          :id="'resource_contribution_' + item.userid"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div class="stacked_area_chart" style="margin-bottom: 15px">
                        <div style="width: 100%; text-align: center">
                          {{ languageData.icfc }}
                        </div>
                        <div
                          :id="'icfc_' + item.userid"
                          style="
                            width: calc(100%);
                            height: 400px;
                            margin: 0 auto;
                            background-color: #fff;
                          "
                        ></div>
                      </div>
                      <div
                        class="personger_kanban"
                        style="margin-bottom: 15px; display: none"
                      >
                        <div class="personger_user">
                          <span>user</span>
                        </div>
                        <div class="personger_card">
                          <h4 style="background-color: #3681fc">
                            {{ languageData.start }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -5px">
                          <h4 style="background-color: #3681fc">
                            {{ languageData.stage }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -10px">
                          <h4 style="background-color: #3681fc">
                            {{ languageData.task }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -15px">
                          <h4 style="background-color: #f284b2">
                            {{ languageData.select }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -20px">
                          <h4 style="background-color: #6266bc">
                            {{ languageData.card }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -25px">
                          <h4 style="background-color: #8ebdb0">
                            {{ languageData.aiCard }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -30px">
                          <h4 style="background-color: #6292bc">
                            {{ languageData.thinkingCard }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -35px">
                          <h4 style="background-color: #f284b2">
                            {{ languageData.whiteboard_card }}
                          </h4>
                          <div style="min-height: 50px">5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -40px">
                          <h4 style="background-color: #1d51b6">
                            {{ languageData.map_card }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                        <div class="personger_card" style="top: -45px">
                          <h4 style="background-color: #3681fc">
                            {{ languageData.camera_card }}
                          </h4>
                          <div>5555555asdafasfasfasfa</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="languageData.achievement"
              name="achievement"
              style="height: 100%"
            >
              <div
                v-loading="projectOutcomeEchartsLoading"
                class="resultStyle"
                style="width: calc(100% - 20px)"
                :element-loading-text="newAnalyseLoadingText"
              >
                <div style="width: 100%; text-align: center">
                  {{ languageData.Project_outcome }}
                </div>
                <div class="result_map_chart" style="margin-bottom: 15px">
                  <RelationGraph
                    ref="seeksRelationGraph"
                    :options="graphOptions"
                    :on-node-click="onNodeClick"
                    :on-line-click="onLineClick"
                  />
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane :label="languageData.timeMachine" name="timeMachine" style="height: 100%;width:100%;">
              <div style="height:100%" v-if="logData.length>0">
                <TimeMachine :CardData="logData" :group="group"/>
              </div>
            </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>
    <AddImageDialog
      :dialog-visible="imageDialogVisible"
      :title="title"
      @info="getImageInfo"
      @setStyle="$_setStyle"
      @setImageList="$_setImageList"
    ></AddImageDialog>
    <ImportDialog
      :dialog-visible="importDialogVisible"
      @info="getImportInfo"
      @saveGraph="$_importGraph"
    ></ImportDialog>
    <ExportDialog
      :dialog-visible="exportDialogVisible"
      @info="getExportInfo"
      @saveGraph="$_saveGraph"
    ></ExportDialog>
    <ShowDialog
      :user-id="user.userId"
      :show="Show"
      :is-share="false"
      :dialog-visible="showDialogVisible"
      :list="showList"
      :session-name="session_name"
      @info="getShowInfo"
    ></ShowDialog>
    <FormworkDialog
      :dialog-visible="FormworkDialogVisible"
      @info="getSourceInfo"
      @setStyle="$_setStyle"
    ></FormworkDialog>
    <AddIconDialog
      :dialog-visible="iconDialogVisible"
      @info="getIconInfo"
      @setStyle="$_setStyle"
      @setIconList="$_setIconList"
    ></AddIconDialog>

    <AIAgentDialog
      :id="agentId"
      :dialog-visible="AIAgentDialogVisible"
      @info="getAIAgentInfo"
      @saveAIAgent="saveAIAgent"
    ></AIAgentDialog>

    <MonitorDialog
      :dialog-visible="monitorDialogVisible"
      :all-group="group"
      @info="getMonitorInfo"
    ></MonitorDialog>
    <div v-show="MessageDialog_flag">
      <MessageDialog
        :data="MessageDialog_message"
        :lf="lf"
        class="MessageDialog"
        @close="close_messageDialog"
      >
      </MessageDialog>
    </div>
    <ChangeThinkingDialog
      v-if="lf"
      :dialog-visible="showThinkingDialogVisible"
      :list="showList"
      :lf="lf"
      @info="getShowThinkingInfo"
    >
    </ChangeThinkingDialog>
    <WhiteboardDialog
      v-if="lf"
      :dialog-visible="showWhiteboardDialogVisible"
      :list="showList"
      :lf="lf"
      @info="getWhiteboardInfo"
    >
    </WhiteboardDialog>
    <div id="map">
      <el-dialog
        :model-value="showMapDialogVisible"
        width="95%"
        :show-close="false"
        :close-on-press-escape="false"
        :before-close="handleMapClose"
      >
        <template #header>
          <div style="width: 100%; position: relative">
            <span class="el-dialog__title">{{ languageData.setMap }}</span>
            <button type="button" class="close" style="top: 4px; right: 0">
              <img
                v-if="hoverClose"
                src="../assets/close_pre.png"
                width="16"
                height="16"
                @mouseout="blurClose"
                @click="handleMapClose"
              />
              <img
                v-else
                src="../assets/close_nor.png"
                width="16"
                height="16"
                @mouseover="focusClose"
              />
            </button>
          </div>
        </template>
        <MapDialog :list="showList" :lf="lf" @info="getMapInfo"> </MapDialog>
      </el-dialog>
    </div>
    <div id="camera">
      <el-dialog
        v-if="showCameraDialog"
        :model-value="showCameraDialog"
        width="40%"
        :show-close="false"
        :close-on-press-escape="false"
        :before-close="handleCameraClose"
        destroy-on-close
      >
        <template #header>
          <div style="width: 100%; position: relative">
            <span class="el-dialog__title">{{ languageData.setCamera }}</span>
            <button type="button" class="close" style="top: 4px; right: 0">
              <img
                v-if="hoverClose"
                src="../assets/close_pre.png"
                width="16"
                height="16"
                @mouseout="blurClose"
                @click="handleCameraClose"
              />
              <img
                v-else
                src="../assets/close_nor.png"
                width="16"
                height="16"
                @mouseover="focusClose"
              />
            </button>
          </div>
        </template>
        <CameraDialog :list="showList" :lf="lf" @info="getCameraInfo"> </CameraDialog>
      </el-dialog>
    </div>
    <div id="sendCard">
      <el-dialog
        :model-value="showSendDialogVisible"
        width="30%"
        :show-close="false"
        :close-on-press-escape="false"
        :before-close="handleSendClose"
      >
        <template #header>
          <span style="width: 100%; position: relative">
            <span class="el-dialog__title">{{ languageData.tip21 }}</span>
            <button type="button" class="close" style="top: 4px; right: 0">
              <img
                v-if="hoverClose"
                src="../assets/close_pre.png"
                width="16"
                height="16"
                @mouseout="blurClose"
                @click="handleSendClose"
              />
              <img
                v-else
                src="../assets/close_nor.png"
                width="16"
                height="16"
                @mouseover="focusClose"
              />
            </button>
          </span>
        </template>
        <span
          style="
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          "
        >
          <el-checkbox
            v-model="checkAll"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
            >{{ languageData.tip75 }}</el-checkbox
          >
          <div style="margin: 5px 0"></div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
            "
          >
            <el-checkbox-group v-model="sendRadio" @change="handleCheckedCitiesChange">
              <template v-for="(item, index) in group" :key="index">
                <el-checkbox
                  v-if="item.id != active_group_id"
                  :label="item.id"
                  style="margin-right: 8px; margin-bottom: 10px"
                >
                  {{ item.name }}</el-checkbox
                >
              </template>
            </el-checkbox-group>
          </div>
        </span>
        <template #footer>
          <span class="dialog-footer">
            <el-button
              type="primary"
              size="small"
              :title="languageData.cancel"
              @click="handleSendClose"
              >{{ languageData.cancel }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              :title="languageData.confirmSend"
              @click="selectGroup"
              >{{ languageData.confirmSend }}</el-button
            >
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { handleResize } from "@logicflow/core";
import { forEach } from 'lodash-es'
import LogicFlow from "@logicflow/core";
import {
  SelectionSelect,
  Snapshot,
  DynamicGroup,
  DndPanel,
  BpmnElement,
  Menu,
  // ProximityConnect,
} from "@logicflow/extension";
import "@logicflow/core/lib/style/index.css";
// import "@logicflow/extension/lib/style/index.css";
import "medium-editor/dist/css/themes/beagle.min.css"
import "medium-editor/dist/css/themes/beagle.min.css"
import "vanilla-picker/dist/vanilla-picker.csp.css"
import "../style.css"
import DiagramToolbar from "./toolbar/DiagramToolbar.vue";
import DiagramSidebar from "./sidebar/DiagramSidebar.vue";
import DiagramRBToolbar from "./toolbar/DiagramRBToolbar.vue";
import PropertyPanel from "./sidebar/PropertyPanel.vue";
import AIAgentDialog from "./dialog/AIAgentDialog.vue";
import AddImageDialog from "./dialog/AddImageDialog.vue";
import ExportDialog from "./dialog/ExportDialog.vue";
import ImportDialog from "./dialog/ImportDialog.vue";
import MessageDialog from "./dialog/MessageDialog.vue";
import ShowDialog from "./dialog/ShowDialog.vue";
import FormworkDialog from "./dialog/FormworkDialog.vue";
import AddIconDialog from "./dialog/AddIconDialog.vue";
import ChangeThinkingDialog from "./dialog/ChangeThinkingDialog.vue";
import WhiteboardDialog from "./dialog/WhiteboardDialog.vue";
import MapDialog from "./dialog/MapDialog.vue";
import ChatRoom from "./chat_room/ChatRoomNew.vue";
import MyGroup from "./my_group/MyGroup.vue";
import MonitorDialog from "./dialog/MonitorDialog.vue";
import PromptsPanel from "./sidebar/PromptsPanel.vue";
import ButtonToolbar from "./toolbar/ButtonToolbar.vue";
import DrawBoard from "./DrawBoard/index.vue";
import { registerCustomElement } from "./node";
import MarkdownIt from "markdown-it";
import bg from "../assets/bg.png";
import { ElLoading as Loading } from "element-plus";
import RelationGraph from "relation-graph-vue3";
import $ from "jquery";
import { v4 as uuidv4 } from "uuid";
import {
  debounce,
  replaceAllCardId,
  replace_all_x,
  find_min_x,
  find_max_x,
  replace_all_y,
  find_min_y,
  find_max_y,
} from "../tools/utils";
import * as echarts from "echarts";
import CameraDialog from "./dialog/CameraDialog.vue";
import { EleResize } from "../tools/utils"; // 图表自适应
import Dagre from "../plugins/Dagre";
import SelectDagre from "../plugins/SelectDagre";
// import Highlight from "../plugins/Highlight";
import MiniMap from "../plugins/MiniMap";
import FakeProgress from "fake-progress";
import { initState, destoryApp } from "../tools/spriteUtilities";
// import EchartsCourseTime from './echarts/echartsCourseTime.vue'
// import TimeMachine from './echarts/timeMachine.vue'
import { getLfProperties } from "./config";

export default {
  name: "Diagram",
  components: {
    DiagramToolbar,
    DiagramSidebar,
    DiagramRBToolbar,
    PropertyPanel,
    AddImageDialog,
    ImportDialog,
    ExportDialog,
    ShowDialog,
    FormworkDialog,
    AddIconDialog,
    ChangeThinkingDialog,
    WhiteboardDialog,
    RelationGraph,
    ChatRoom,
    MyGroup,
    MapDialog,
    CameraDialog,
    MonitorDialog,
    MessageDialog,
    PromptsPanel,
    // EchartsCourseTime,
    AIAgentDialog,
    ButtonToolbar,
    // TimeMachine
    DrawBoard,
  },
  props: {
    data: { type: Object, default: undefined },
    group: { type: Array, default: undefined },
    role: { type: Boolean, default: false },
    groupUsers: { type: Array, default: undefined },
    theme: { type: String, default: undefined },
    // groupDatas: Array
  },
  emits: ["login", "full"],
  data() {
    return {
      y_coordinate: 0,
      pre_node_id: [],
      AIAgentDialogVisible: false,
      refreshAIAgent: false,
      isKeyBoardDelete: true,
      agentId: "",
      hoverMax: false,
      hoverRecovery: false,
      fullscreen: false,
      backgroundImage: "",
      last_node_id: "",
      fake: new FakeProgress({
        timeConstant: 5000,
        autoStart: true,
      }),
      groupDatas: [],
      newDataAll: {},
      className: "",
      courseId: "",
      groupData: {},
      user: {
        userId: "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
        userName: "james",
      },
      is_mygroup: false,
      linetype: "pro-line",
      top_menu: false,
      isHidden: true,
      sidebarWidth: 200,
      newTab: false,
      diagramWidth: 0,
      diagramHeight: 0,
      lf: null,
      network: true, //默认有网
      filename: "",
      languageData: {},
      user_group: [],
      stageData: [],
      taskData: [],
      user_group_flag: true,
      activeNodes: [],
      activeEdges: [],
      properties: {},
      showList: [],
      showThinkingDialogVisible: false,
      showWhiteboardDialogVisible: false,
      showMapDialogVisible: false,
      showSendDialogVisible: false,
      sendNodes: [],
      sendEdges: [],
      checkAll: false,
      sendRadio: [],
      isIndeterminate: true,
      hoverClose: false,
      username: "",
      size: "small",
      iconList: [],
      imageList: [],
      videoList: [],
      audioList: [],
      fileList: [],
      imageDialogVisible: false,
      iconDialogVisible: false,
      monitorDialogVisible: false,
      FormworkDialogVisible: false,
      importDialogVisible: false,
      exportDialogVisible: false,
      showDialogVisible: false,
      isJobReception: false,
      isAnalyse: false,
      isNewAnalyse: false,
      isBackground: false,
      isBackgroundNew: false,
      activeName: "all",
      backGround: "",
      newBackground: "",
      checked_isParticipate: "",
      title: "",
      // demoname: '---',
      isShowCodePanel: false,
      isFullscreen: false,
      isProjection: false,
      isExistLogout: false,
      transformSize: 100,
      isDeleteNode: false,
      isResizeNode: false,
      isAutomatic: false,
      isChangeRate: false,
      graphOptions: {
        allowShowMiniToolBar: true,
        allowSwitchLineShape: false,
        allowSwitchJunctionPoint: false,
        defaultLineShape: 1,
        defaultJunctionPoint: "border",
        // moveToCenterWhenRefresh: true,
        // backgrounImageNoRepeat: false,
        // defaultExpandHolderPosition: 'right',
        // 这里可以参考"Graph 图谱"中的参数进行设置
        // layouts: [
        //   {
        //     'label': '自动布局',
        //     'layoutName': 'force',
        //     'layoutClassName': 'seeks-layout-force'
        //   }
        // ],
        moveToCenterWhenRefresh: true,
        backgrounImageNoRepeat: true,
        useAnimationWhenRefresh: true,
        zoomToFitWhenRefresh: true,
        layouts: [
          {
            label: "中心",
            layoutName: "center",
            layoutClassName: "seeks-layout-center",
            // "distance_coefficient": 1,
            // 'label': '自动布局',
            // 'layoutName': 'force',
            // 'layoutClassName': 'seeks-layout-force'
          },
        ],
      },
      chat_room_switch: false,
      badge_number: 0,
      chatroom_message_swich: true,
      chatroom_message_swich_child: true,
      selectStudentPageNum: [],
      selectStudentPage: "第1页",
      selectGroupPageNum: [],
      selectGroupPage: "第1页",
      selectStudentList: [],
      select_personage_value: null,
      select_group_value: null,
      all_student: [],
      logData: [],
      analyserUserData: [],
      speechesTimes: 0,
      showCameraDialog: false,
      active_group_id: "",
      resultGroupData: [],
      icfc_data: [],
      newAnalyseLoading: true,
      personageLoading: true,
      groupLoading: true,
      projectOutcomeEchartsLoading: true,
      MessageDialog_flag: false,
      MessageDialog_message: {},
      addNodeCard: [],
      updateNodeCard: [],
      deleteNodeCard: [],
      addEdgesLines: [],
      deleteEdgesLines: [],
      updateEdgesLines: [],
      isExistError: false,
      IncreasingTrenTime: "",
      cities: ["上海", "北京", "广州", "深圳"],
      checkboxGroupValue: "all",
      isShowGroup: false,
      isPromptsList: false,
      prompts: "",
      isSelectionSelect: false,
      resourceClassObj: [],
      iframe_url: "",
      Show: true,
      Time: null,
      isDrawing: false,
      darwPresets: [],
      isSilentMode: false,
      isShowMode: true,
      isGroup: false,
      session_name: "协同建构",
    };
  },
  computed: {
    newAnalyseLoadingText() {
      return String(parseInt(this.fake.progress * 100) + "%");
    },
  },
  watch: {
    backGround(newVal) {
      if (newVal != "") {
        let loadingInstance = Loading.service({ fullscreen: true });
        let blob = this.dataURLtoBlob(newVal);
        // 拿到文件名
        let fileName = uuidv4() + ".png";
        // 2，在转为 file类型
        let file1 = this.blobToFile(blob, fileName);
        this.uploadImage(file1, loadingInstance);
      }
    },
    groupData(newVal) {
      destoryApp();
      localStorage.setItem("background", newVal.backgroundUrl);
      try {
        let nodeIds = [];
        for (let i = 0; i < newVal.nodes.length; i++) {
          nodeIds.push(newVal.nodes[i].id);
        }
        let edges = [];
        for (let i = 0; i < newVal.edges.length; i++) {
          if (
            nodeIds.indexOf(newVal.edges[i].sourceNodeId) != -1 &&
            nodeIds.indexOf(newVal.edges[i].targetNodeId) != -1
          ) {
            edges.push(newVal.edges[i]);
          }
        }
        newVal.edges = edges;
        this.isAutomatic = false;
        this.lf.history.undos = [];
        this.lf.history.redos = [];
        this.lf.graphModel.graphDataToModel(newVal);
        this.initLogicFlow(newVal);
        // this.lf.options.grid = newVal.backgroundUrl != "" ? false : true
        // this.lf.options.background = {
        //   backgroundImage: 'url(' + newVal.backgroundUrl + ')',
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'cover',
        //   backgroundColor: '#F2F2F2'
        // };
        // this.lf.render(newVal)
      } catch {
        this.isAutomatic = false;
        // let data = {
        //   nodes: newVal.nodes,
        //   edges: [],
        //   backgroundUrl: newVal.backgroundUrl
        // }
        // this.lf.graphModel.graphDataToModel(newVal)
        this.initLogicFlow(newVal);
      }
    },
    "$store.state.group_member_active": {
      handler(newVal) {
        this.user_group = newVal;
      },
      immediate: true
    },
  },
  created() {},
  mounted() {
    window.loginout = this.$_loginout;
    this.sidebarWidth = window.innerWidth;
    //获取用户信息
    if (
      window.location.href.includes("localhost") ||
      window.location.href.includes("192.168")
    ) {
      this.user.userId = "1cf9dc4b-d95f-11ea-af4c-52540005ab01";
    } else {
      if (top.US.userInfo) {
        this.user.userId = top.US.userInfo.userid;
        this.user.userName = top.US.userInfo.username;
        this.$store.commit("set_user", this.user);
      }
    }
    if (window.location.href.indexOf("cocorobo.cn") != -1) {
      this.iframe_url = "//iwb.cocorobo.cn/";
      this.languageData = this.zhHansLanguage;
    } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
      this.iframe_url = "//iwb.cocorobo.hk/";
      this.languageData = this.zhHantLanguage;
    } else if (window.location.href.indexOf("cocorobo.com") != -1) {
      this.iframe_url = "//iwb.cocorobo.com/";
      this.languageData = this.enLanguage;
    } else {
      this.iframe_url = "//iwb.cocorobo.cn/";
      this.languageData = this.zhHansLanguage;
    }

    if (window.location.href.indexOf("?cid=") != -1) {
      this.isExistLogout = false;
    } else {
      this.isExistLogout = true;
    }
    this.cities = [
      {
        value: "all",
        label: this.languageData.all,
      },
      {
        value: "create",
        label: this.languageData.create,
      },
      {
        value: "edit",
        label: this.languageData.edit,
      },
      {
        value: "studentTip6",
        label: this.languageData.studentTip6,
      },
      {
        value: "deleteGraps",
        label: this.languageData.deleteGraps,
      },
    ];
    this.checkboxGroup = [
      this.languageData.create,
      this.languageData.edit,
      this.languageData.studentTip6,
      this.languageData.deleteGraps,
    ];
    this.active_group_id = localStorage.getItem("roomId");
    this.user_group = this.$store.state.group_member_active;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "./aws-sdk-2.235.1.min.js";
    script.async = "async";
    script.onload = function () {
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
    };
    document.body.appendChild(script);

    let that = this;
    let data = that.data;
    let nodeIds = [];
    for (let i = 0; i < data.nodes.length; i++) {
      nodeIds.push(data.nodes[i].id);
    }
    let edges = [];
    for (let i = 0; i < data.edges.length; i++) {
      if (
        nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 &&
        nodeIds.indexOf(data.edges[i].targetNodeId) != -1
      ) {
        edges.push(data.edges[i]);
      }
    }
    data.edges = edges;
    that.initLogicFlow(data);
    this.get_select_CSCLDataByID();
    if (window.location.href.indexOf("cocorobo.cn") != -1) {
      document.domain = "cocorobo.cn";
    } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
      document.domain = "cocorobo.hk";
    } else if (window.location.href.indexOf("cocorobo.com") != -1) {
      document.domain = "cocorobo.com";
    }
    window.addEventListener("message", function (e) {
      //e.data.type update和delete
      //info 更变的数据
      let type = e.data.type;
      let info = e.data.info;
      let currentData = that.lf.getGraphData();
      if (type == "update" && info.roomId == that.active_group_id) {
        let index = [];
        if (info.nodes.length != 0) {
          for (let i = 0; i < info.nodes.length; i++) {
            for (let j = 0; j < currentData.nodes.length; j++) {
              if (currentData.nodes[j].id == info.nodes[i].id) {
                //修改卡片
                info.nodes[i].properties.is_show_user = true;
                info.nodes[i].properties.user_name = e.data.info.userName;
                that.lf.graphModel
                  .getNodeModelById(info.nodes[i].id)
                  .setProperties(info.nodes[i].properties);
                // if (info.nodes[i].properties && info.nodes[i].properties.width && info.nodes[i].properties.height) {
                //   that.lf.graphModel.updateAttributes(info.nodes[i].id, {
                //     // isSelected: true,
                //     isHitable: false,
                //     draggable: false,
                //     width: info.nodes[i].properties.width,
                //     height: info.nodes[i].properties.height,
                //     x: info.nodes[i].x,
                //     y: info.nodes[i].y,
                //     zIndex: info.nodes[i].zIndex
                //   })
                // }
                if (
                  info.nodes[i].properties.nodeSize &&
                  info.nodes[i].properties.nodeSize.width &&
                  info.nodes[i].properties.nodeSize.height
                ) {
                  that.lf.graphModel.updateAttributes(info.nodes[i].id, {
                    // isSelected: true,
                    isHitable: false,
                    draggable: false,
                    width: info.nodes[i].properties.nodeSize.width,
                    height: info.nodes[i].properties.nodeSize.height,
                    x: info.nodes[i].x,
                    y: info.nodes[i].y,
                    zIndex: info.nodes[i].zIndex,
                  });
                } else {
                  that.lf.graphModel.updateAttributes(info.nodes[i].id, {
                    // isSelected: true,
                    isHitable: false,
                    draggable: false,
                    x: info.nodes[i].x,
                    y: info.nodes[i].y,
                    zIndex: info.nodes[i].zIndex,
                  });
                }
                index.push(j);
                break;
              }
            }
          }
          if (index.length == 0) {
            //新增卡片
            for (let j = 0; j < info.nodes.length; j++) {
              that.isAutomatic = false;
              that.lf.graphModel.addNode(info.nodes[j]);
              info.nodes[j].properties.is_show_user = true;
              info.nodes[j].properties.user_name = e.data.info.userName;
              that.lf.graphModel
                .getNodeModelById(info.nodes[j].id)
                .setProperties(info.nodes[j].properties);
              that.lf.graphModel.updateAttributes(info.nodes[j].id, {
                // isSelected: true,
                isHitable: false,
                draggable: false,
              });
            }
            that.MessageDialog_message = {
              name: info.userName,
              length: info.nodes.length,
              id: info.nodes[0].id,
            };
            that.MessageDialog_flag = true;
            if (info.userId == that.group[0].creator.userid) {
              //老师加的卡片
            } else {
              setTimeout(() => {
                that.MessageDialog_flag = false;
              }, 3000);
            }
          }
        }
        if (info.edges.length != 0) {
          if (info.edges.length == currentData.edges.length) {
            for (let i = 0; i < info.edges.length; i++) {
              if (info.edges[i].type.indexOf("pro-red") == -1) {
                that.lf.setDefaultEdgeType(info.edges[i].type);
                that.linetype = info.edges[i].type;
                break;
              }
            }
          } else {
            for (let i = 0; i < info.edges.length; i++) {
              if (
                info.edges[i].type.indexOf("pro-red") == -1 &&
                info.edges[i].type.indexOf("pro-green") == -1
              ) {
                that.lf.setDefaultEdgeType(info.edges[i].type);
                that.linetype = info.edges[i].type;
              }
              if (info.edges[i].type.indexOf("pro-red") != -1) {
                that.lf.setDefaultEdgeType(info.edges[i].type.replace("pro-red", "pro"));
                that.linetype = info.edges[i].type.replace("pro-red", "pro");
              }
              if (info.edges[i].type.indexOf("pro-green") != -1) {
                that.lf.setDefaultEdgeType(
                  info.edges[i].type.replace("pro-green", "pro")
                );
                that.linetype = info.edges[i].type.replace("pro-green", "pro");
              }
              if (info.edges[i].type.indexOf("pro-dashed") != -1) {
                that.lf.setDefaultEdgeType(
                  info.edges[i].type.replace("pro-dashed", "pro")
                );
                that.linetype = info.edges[i].type.replace("pro-dashed", "pro");
              }
            }
          }
          for (let i = 0; i < info.edges.length; i++) {
            for (let j = 0; j < currentData.edges.length; j++) {
              if (currentData.edges[j].id == info.edges[i].id) {
                // currentData.edges[j] = info.edges[i]
                // info.nodes[i].properties.is_show_user = true;
                // info.nodes[i].properties.user_name = e.data.info.userName;
                if (info.nodes.length == 0) {
                  that.lf.graphModel
                    .getEdgeModelById(info.edges[i].id)
                    .setProperties(info.edges[i].properties);
                  that.lf.graphModel.changeEdgeType(info.edges[i].id, info.edges[i].type);
                  if (info.edges[i].pointsList) {
                    that.lf.graphModel
                      .getEdgeModelById(info.edges[i].id)
                      .updateStartPoint(info.edges[i].startPoint);
                    that.lf.graphModel
                      .getEdgeModelById(info.edges[i].id)
                      .updateEndPoint(info.edges[i].endPoint);
                    that.lf.graphModel.getEdgeModelById(info.edges[i].id).pointsList =
                      info.edges[i].pointsList;
                    that.lf.graphModel.getEdgeModelById(info.edges[i].id).initPoints();
                    that.lf.graphModel.updateAttributes(info.edges[i].id, {
                      // isSelected: true,
                      isHitable: false,
                      draggable: false,
                      type: info.edges[i].type,
                      // pointsList: info.edges[i].pointsList,
                      // startPoint: info.edges[i].startPoint,
                      // endPoint: info.edges[i].endPoint,
                      zIndex: 1,
                    });
                  } else {
                    that.lf.graphModel.updateAttributes(info.edges[i].id, {
                      // isSelected: true,
                      isHitable: false,
                      draggable: false,
                      type: info.edges[i].type,
                      startPoint: info.edges[i].startPoint,
                      endPoint: info.edges[i].endPoint,
                      zIndex: 1,
                    });
                  }
                } else {
                  // for (let k = 0; k < info.nodes.length; k++) {
                  //   let nodeModel = that.lf.getNodeModelById(info.nodes[k].id)
                  //   let anchors = nodeModel.anchors
                  //   let outgoingEdgeModel = that.lf.getNodeOutgoingEdge(info.nodes[k].id);
                  //   for (let m = 0; m < outgoingEdgeModel.length; m++) {
                  //     for (let n = 0; n < anchors.length; n++) {
                  //       if (outgoingEdgeModel[m].sourceAnchorId == anchors[n].id) {
                  //         let edge = that.lf.getEdgeModelById(outgoingEdgeModel[m].id)
                  //         // edge.startPoint.x = anchors[n].x
                  //         // edge.startPoint.y = anchors[n].y
                  //         // edge = that.lf.getEdgeModelById(outgoingEdgeModel[m].id)
                  //         let edgeData = edge.getData()
                  //         edgeData.startPoint.x = anchors[n].x
                  //         edgeData.startPoint.y = anchors[n].y
                  //         edgeData.zIndex = 1
                  //         that.lf.graphModel.getEdgeModelById(outgoingEdgeModel[m].id).setProperties(edgeData.properties);
                  //         if(edgeData.pointsList) {
                  //           edgeData.pointsList = []
                  //         }
                  //         // that.isDeleteNode = true
                  //         // that.lf.deleteEdge(outgoingEdgeModel[m].id)
                  //         // that.isDeleteNode = false
                  //         // that.isAutomatic = false
                  //         // that.lf.addEdge(edgeData)

                  //         if(edgeData.pointsList) {
                  //           that.lf.graphModel.updateAttributes(edgeData.id, {
                  //             // isSelected: true,
                  //             isHitable: false,
                  //             draggable: false,
                  //             type: edgeData.type,
                  //             pointsList: edgeData.pointsList,
                  //             startPoint: edgeData.startPoint,
                  //             endPoint: edgeData.endPoint,
                  //             zIndex: edgeData.zIndex
                  //           })
                  //         }
                  //         else{
                  //           that.lf.graphModel.updateAttributes(edgeData.id, {
                  //             // isSelected: true,
                  //             isHitable: false,
                  //             draggable: false,
                  //             type: edgeData.type,
                  //             startPoint: edgeData.startPoint,
                  //             endPoint: edgeData.endPoint,
                  //             zIndex: edgeData.zIndex
                  //           })
                  //         }
                  //         break
                  //       }
                  //     }
                  //   }
                  //   let incomingEdgeModel = that.lf.getNodeIncomingEdge(info.nodes[k].id);
                  //   for (let m = 0; m < incomingEdgeModel.length; m++) {
                  //     for (let n = 0; n < anchors.length; n++) {
                  //       if (incomingEdgeModel[m].targetAnchorId == anchors[n].id) {
                  //         let edge = that.lf.getEdgeModelById(incomingEdgeModel[m].id)
                  //         // edge.endPoint.x = anchors[n].x
                  //         // edge.endPoint.y = anchors[n].y
                  //         // edge = that.lf.getEdgeModelById(incomingEdgeModel[m].id)
                  //         let edgeData = edge.getData()
                  //         edgeData.endPoint.x = anchors[n].x
                  //         edgeData.endPoint.y = anchors[n].y
                  //         edgeData.zIndex = 1
                  //         that.lf.graphModel.getEdgeModelById(incomingEdgeModel[m].id).setProperties(edgeData.properties);
                  //         if(edgeData.pointsList) {
                  //           edgeData.pointsList = []
                  //         }
                  //         // that.isDeleteNode = true
                  //         // that.lf.deleteEdge(incomingEdgeModel[m].id)
                  //         // that.isDeleteNode = false
                  //         // that.isAutomatic = false
                  //         // that.lf.addEdge(edgeData)

                  //         if(edgeData.pointsList) {
                  //           that.lf.graphModel.updateAttributes(edgeData.id, {
                  //             // isSelected: true,
                  //             isHitable: false,
                  //             draggable: false,
                  //             type: info.edges[i].type,
                  //             pointsList: edgeData.pointsList,
                  //             startPoint: edgeData.startPoint,
                  //             endPoint: edgeData.endPoint,
                  //             zIndex: edgeData.zIndex
                  //           })
                  //         }
                  //         else{
                  //           that.lf.graphModel.updateAttributes(edgeData.id, {
                  //             // isSelected: true,
                  //             isHitable: false,
                  //             draggable: false,
                  //             type: info.edges[i].type,
                  //             startPoint: edgeData.startPoint,
                  //             endPoint: edgeData.endPoint,
                  //             zIndex: edgeData.zIndex
                  //           })
                  //         }
                  //         break
                  //       }
                  //     }
                  //   }
                  //   // that.isDeleteNode = true
                  //   // that.lf.deleteEdge(info.edges[i].id)
                  //   // that.isDeleteNode = false
                  //   // that.isAutomatic = false
                  //   // that.lf.addEdge(info.edges[i].id)
                  // }

                  that.lf.graphModel
                    .getEdgeModelById(info.edges[i].id)
                    .setProperties(info.edges[i].properties);
                  if (info.edges[i].pointsList) {
                    that.lf.graphModel
                      .getEdgeModelById(info.edges[i].id)
                      .updateStartPoint(info.edges[i].startPoint);
                    that.lf.graphModel
                      .getEdgeModelById(info.edges[i].id)
                      .updateEndPoint(info.edges[i].endPoint);
                    that.lf.graphModel.getEdgeModelById(info.edges[i].id).pointsList =
                      info.edges[i].pointsList;
                    that.lf.graphModel.getEdgeModelById(info.edges[i].id).initPoints();
                    that.lf.graphModel.updateAttributes(info.edges[i].id, {
                      // isSelected: true,
                      isHitable: false,
                      draggable: false,
                      type: info.edges[i].type,
                      // pointsList: info.edges[i].pointsList,
                      // startPoint: info.edges[i].startPoint,
                      // endPoint: info.edges[i].endPoint,
                      zIndex: info.edges[i].zIndex,
                    });
                  } else {
                    that.lf.graphModel.updateAttributes(info.edges[i].id, {
                      // isSelected: true,
                      isHitable: false,
                      draggable: false,
                      type: info.edges[i].type,
                      startPoint: info.edges[i].startPoint,
                      endPoint: info.edges[i].endPoint,
                      zIndex: info.edges[i].zIndex,
                    });
                  }
                }
                index.push(j);
                break;
              }
            }
          }
          if (index.length == 0) {
            for (let j = 0; j < info.edges.length; j++) {
              // currentData.edges.push(info.edges[j])
              // that.lf.graphModel.addEdge(info.edges[j]);
              that.isAutomatic = false;
              that.lf.graphModel.addEdge(info.edges[j]);
              that.lf.graphModel.updateAttributes(info.edges[j].id, {
                // isSelected: true,
                isHitable: false,
                draggable: false,
              });
            }
          }
        }
        if (info.backgroundUrl != localStorage.getItem("background")) {
          currentData = that.lf.getGraphData();
          currentData.backgroundUrl = info.backgroundUrl;
          localStorage.setItem("background", info.backgroundUrl);
          // that.isDeleteNode = true
          // console.log(currentData)
          // that.lf.graphModel.clearData();
          // that.isAutomatic = false
          // that.lf.graphModel.graphDataToModel(currentData);
          // that.isDeleteNode = false
          that.initLogicFlow(currentData);
          // that.lf.options.grid = currentData.backgroundUrl != "" ? false : true
          // that.lf.options.background = {
          //   backgroundImage: 'url(' + currentData.backgroundUrl + ')',
          //   backgroundRepeat: 'no-repeat',
          //   backgroundSize: 'cover',
          //   backgroundColor: '#F2F2F2'
          // };
          // that.lf.graphModel.partial = false
          // that.lf.render(currentData)
          // that.lf.graphModel.partial = true
        }
        // that.isDeleteNode = true
        // that.lf.graphModel.graphDataToModel(currentData);
        // that.isDeleteNode = false
        if (info.nodes.length != 0 && info.type != 1) {
          // for (let i = 0; i < info.nodes.length; i++) {
          //   that.lf.graphModel.updateAttributes(info.nodes[i].id, {
          //     // isSelected: true,
          //     isHitable: false,
          //     draggable: false
          //   })
          // }
          setTimeout(() => {
            for (let i = 0; i < info.nodes.length; i++) {
              info.nodes[i].properties.is_show_user = false;
              that.lf.graphModel
                .getNodeModelById(info.nodes[i].id)
                .setProperties(info.nodes[i].properties);
              that.lf.graphModel.updateAttributes(info.nodes[i].id, {
                // isSelected: true,
                isHitable: true,
                draggable: true,
              });
            }
          }, 10000);
        }
        if (info.edges.length != 0 && info.type != 1) {
          // for (let i = 0; i < info.edges.length; i++) {
          //   that.lf.graphModel.updateAttributes(info.edges[i].id, {
          //     // isSelected: true,
          //     isHitable: false,
          //     draggable: false
          //   })
          // }
          setTimeout(() => {
            for (let i = 0; i < info.edges.length; i++) {
              that.lf.graphModel
                .getEdgeModelById(info.edges[i].id)
                .setProperties(info.edges[i].properties);
              that.lf.graphModel.updateAttributes(info.edges[i].id, {
                // isSelected: true,
                isHitable: true,
                draggable: true,
              });
            }
          }, 10000);
        }
      }
      if (type == "delete" && info.roomId == that.active_group_id) {
        let nodes = currentData.nodes;
        let edges = currentData.edges;
        if (info.edges.length != 0) {
          for (let i = 0; i < info.edges.length; i++) {
            for (let j = 0; j < edges.length; j++) {
              if (edges[j].id == info.edges[i].id) {
                edges.splice(j, 1);
                that.isDeleteNode = true;
                that.lf.deleteEdge(info.edges[i].id);
                that.isDeleteNode = false;
                break;
              }
            }
          }
        }
        if (info.nodes.length != 0) {
          for (let i = 0; i < info.nodes.length; i++) {
            for (let j = 0; j < nodes.length; j++) {
              if (nodes[j].id == info.nodes[i].id) {
                nodes.splice(j, 1);
                that.isDeleteNode = true;
                that.lf.deleteNode(info.nodes[i].id);
                that.isDeleteNode = false;
                break;
              }
            }
          }
          that.$message({
            showClose: true,
            message:
              info.userName +
              that.languageData.tip31 +
              info.nodes.length +
              that.languageData.tip30,
            type: "error",
          });
        }
        // currentData.nodes = nodes
        // currentData.edges = edges
        // currentData.backgroundUrl = info.backgroundUrl
        // localStorage.setItem("background", info.backgroundUrl)
        // that.isDeleteNode = true
        // // console.log(currentData)
        // that.lf.graphModel.clearData();
        // that.lf.graphModel.graphDataToModel(currentData);
        // that.isDeleteNode = false
        // that.initLogicFlow(currentData)
      }
      //操作变为绿色
      if (type == "delete" || type == "update") {
        that.group.forEach((item, index) => {
          item.group_member.forEach((item2, index2) => {
            if (item2.userid == info.userId) {
              let groupNew = that.group;
              groupNew[index].group_member[index2].state = 2;
              that.$store.commit("set_group", []);
              that.$store.commit("set_group", groupNew);
            }
          });
        });
      }
      if (type == "addUser") {
        let user_group = that.user_group;
        let user = info.userinfo;
        let isAdd = true;
        for (let i = 0; i < user_group.length; i++) {
          if (user_group[i].userId == user.userId) {
            isAdd = false;
            break;
          }
        }
        if (isAdd) {
          //判断上线的人是否为创建者
          if (user.userId == that.group[0].creator.userid) {
            that.$message({
              showClose: true,
              message: info.userinfo.userName + that.languageData.tip32,
              type: "success",
            });
            user_group.push(user);
            return;
          }
          //判断是否为创建者
          if (that.group[0].creator.userid == that.group[0].group_member[0].userid) {
            that.group.forEach((item, index) => {
              item.group_member.forEach((item2, index2) => {
                if (item2.userid == user.userId) {
                  let groupNew = that.group;
                  groupNew[index].group_member[index2].state = 1;
                  that.$store.commit("set_group", []);
                  that.$store.commit("set_group", groupNew);
                }
              });
            });
          }
          for (let i = 0; i < that.group.length; i++) {
            if (that.group[i].id == that.active_group_id) {
              for (let j = 0; j < that.group[i].group_member.length; j++) {
                if (that.group[i].group_member[j].userid == user.userId) {
                  let groupNew = that.group;
                  groupNew[i].group_member[j].state = 1;
                  that.$store.commit("set_group", []);
                  that.$store.commit("set_group", groupNew);
                  that.$message({
                    showClose: true,
                    message: info.userinfo.userName + that.languageData.tip32,
                    type: "success",
                  });
                  user_group.push(user);
                }
              }
              break;
            }
          }
          let obj = {};
          user_group.forEach((item, index) => {
            if (Object.prototype.hasOwnProperty.call(obj, item.userId)) {
              // 若重复则删除该项
              user_group.splice(index, 1);
            } else {
              // 不重复则存入obj
              obj[item.userId] = item.userName;
            }
          });
          that.user_group = user_group;
          console.log(user_group)
          localStorage.setItem("user", JSON.stringify(user_group));
          that.$store.commit("set_group_member_active", []);
          that.$store.commit("set_group_member_active", user_group);
        }
      }
      if (type == "delUser") {
        let user_group = that.user_group;
        let user = info.userinfo;
        if (user.userId == that.group[0].creator.userid) {
          //判断下线的人是否为创建者
          let index = user_group.findIndex((item) => {
            return item.userId == user.userId;
          });
          that.$message({
            showClose: true,
            message: info.userinfo.userName + that.languageData.tip33,
            type: "error",
          });
          user_group.splice(index, 1);
          return;
        }
        for (let i = 0; i < user_group.length; i++) {
          if (user_group[i].userId == user.userId) {
            that.$message({
              showClose: true,
              message: info.userinfo.userName + that.languageData.tip33,
              type: "error",
            });
            user_group.splice(i, 1);
            break;
          }
        }
        that.group.forEach((item, index) => {
          item.group_member.forEach((item2, index2) => {
            if (item2.userid == user.userId) {
              let groupNew = that.group;
              groupNew[index].group_member[index2].state = 0;
              that.$store.commit("set_group", []);
              that.$store.commit("set_group", groupNew);
            }
          });
        });
        that.user_group = user_group;
        console.log(user_group)
        localStorage.setItem("user", JSON.stringify(user_group));
        that.$store.commit("set_group_member_active", []);
        that.$store.commit("set_group_member_active", user_group);
      }
      if (type == "clean" && info.roomId == that.active_group_id) {
        that.lf.graphModel.clearData();
        that.$message({
          showClose: true,
          message: info.userName + that.languageData.tip34,
        });
      }
    });

    let networkMessage = null;
    // 检测断网
    window.addEventListener("offline", () => {
      this.network = false;
      localStorage.setItem("network", false);
      localStorage.setItem(
        "offlineUpdateData",
        JSON.stringify({
          backgroundUrl: "",
          edges: [],
          nodes: [],
        })
      );
      localStorage.setItem(
        "offlineDeleteData",
        JSON.stringify({
          backgroundUrl: "",
          edges: [],
          nodes: [],
        })
      );
      networkMessage = this.$message({
        message: this.languageData.notNetworkTip,
        type: "info",
        duration: 0,
        offset: 50,
      });
    });
    // 检测断网重连
    window.addEventListener("online", () => {
      this.network = true;
      networkMessage.close();
      localStorage.setItem("network", true);
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: this.languageData.networkTip,
      });
      this.getcscl(localStorage.getItem("roomId"), loadingInstance);
    });
  },
  methods: {
    full(value) {
      this.$emit("full", value);
    },
    geneTask(name, themeId, loadingInstance) {
      let that = this;
      let message = "";
      if (window.location.href.indexOf("cocorobo.cn") != -1) {
        message = "课程名称：" + name + "，并以相同的语言回复";
      } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
        message = "課程名稱：" + name + "，並以相同的語言回覆";
      } else if (window.location.href.indexOf("cocorobo.com") != -1) {
        message = "Course Name:" + name + " and reply in the same language";
      } else {
        message = "课程名称：" + name + "，并以相同的语言回复";
      }
      let config = {
        method: "post",
        url: "https://gpt4.cocorobo.cn/ai_agent_park_chat",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          assistant_id: "asst_amHWwINGQvuoOCjWFCQooWbf",
          message: message,
          userId: this.user.userId,
          session_name: "协同建构",
          isCocoNote: 1,
          uid: "",
        },
      };
      this.$ajax(config)
        .then((response) => {
          console.log(response);
          that.generateTask(
            response.data.FunctionResponse.message,
            themeId,
            loadingInstance
          );
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
    geneResourse(title, name, themeId, loadingInstance) {
      let that = this;
      let message = "";
      if (window.location.href.indexOf("cocorobo.cn") != -1) {
        message = "<单一任务描述>：" + name + "，并以相同的语言回复";
      } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
        message = "<單一任務描述>：" + name + "，並以相同的語言回覆";
      } else if (window.location.href.indexOf("cocorobo.com") != -1) {
        message = "<Single Task Description>:" + name + " and reply in the same language";
      } else {
        message = "<单一任务描述>：" + name + "，并以相同的语言回复";
      }
      let config = {
        method: "post",
        url: "https://gpt4.cocorobo.cn/ai_agent_park_chat",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          assistant_id: "asst_YBf7z9iXgOeGWrHbELSoJ0jn",
          message: message,
          userId: this.user.userId,
          session_name: "协同建构",
          isCocoNote: 1,
          uid: "",
        },
      };
      this.$ajax(config)
        .then((response) => {
          console.log(response);
          that.generateResourse(
            response.data.FunctionResponse.message,
            title,
            themeId,
            loadingInstance
          );
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
    generateTask(ai_result, themeId, loadingInstance) {
      let that = this;
      let newNodes = [];
      let newEdges = [];
      let replace_x = find_min_y(that.lf.getNodeModelById(themeId).anchors).x;
      let startPointy = find_max_y(that.lf.getNodeModelById(themeId).anchors).y;
      let a = replace_x - 400;
      let x_coordinate = 400;
      that.startPointy = startPointy;
      that.y_coordinate += 500;
      var pattern = new RegExp(this.languageData.taskTip2 + ".*：");
      var patternEn = new RegExp(this.languageData.taskTip2 + ".*:");
      //任务卡片
      let taskContent = "";
      let taskArr = [];
      if (window.location.href.indexOf("cocorobo.cn") != -1) {
        taskContent = ai_result.split("任务一：")[1];
        taskArr = taskContent.replace("\n", "").split(pattern);
      } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
        taskContent = ai_result.split("任務一：")[1];
        taskArr = taskContent.replace("\n", "").split(pattern);
      } else if (window.location.href.indexOf("cocorobo.com") != -1) {
        try {
          taskContent = ai_result.split("Task 1:")[1];
          taskArr = taskContent.replace("\n", "").split(patternEn);
        }
        catch {
          taskContent = ai_result.split("Task One:")[1];
          taskArr = taskContent.replace("\n", "").split(patternEn);
        }
      } else {
        taskContent = ai_result.split("任务一：")[1];
        taskArr = taskContent.replace("\n", "").split(pattern);
      }
      taskArr.forEach((item, index) => {
        if (index % 2 == 0) {
          //偶数
          //卡片
          let pre_node_id = that.pre_node_id.at(-1);
          let id = uuidv4();
          that.pre_node_id.push(id);
          let node = {
            id: id,
            type: "icon-task",
            properties: {
              type: "icon-task",
              taskTitle: item,
              taskContent: taskArr[index + 1].replaceAll("#", ""),
              taskTitleColor: "#6E44C9",
            },
            x: a + x_coordinate,
            y: that.y_coordinate + 200,
            zIndex: 1002,
          };
          that.lf.graphModel.addNode(node);
          x_coordinate += 300;
          //连线
          if (index > 0) {
            const { transformModel } = this.lf.graphModel;
            transformModel.focusOn(
              node.x,
              node.y,
              window.screen.width,
              window.screen.height
            );
            let x1 =
              that.lf.graphModel.getNodeModelById(pre_node_id).x +
              that.lf.graphModel.getNodeModelById(pre_node_id)._width / 2;
            let x2 =
              that.lf.graphModel.getNodeModelById(id).x -
              that.lf.graphModel.getNodeModelById(id)._width / 2;
            let y1 = that.lf.graphModel.getNodeModelById(pre_node_id).y;
            let y2 = that.lf.graphModel.getNodeModelById(id).y;
            let edgeId = uuidv4();
            let edge = {
              id: edgeId,
              properties: {},
              zIndex: 1,
              type: "pro-line",
              sourceNodeId: pre_node_id,
              targetNodeId: id,
              startPoint: {
                x: x1,
                y: y1,
              },
              endPoint: {
                x: x2,
                y: y2,
              },
            };
            this.lf.graphModel.addEdge(edge);
            newEdges.push(that.lf.graphModel.getEdgeModelById(edgeId).getData());
          } else {
            //主题卡片和任务卡片的连线
            let themeEdgeId = uuidv4();
            let endPointy = find_min_y(that.lf.getNodeModelById(id).anchors).y;
            that.endPointy = endPointy;
            let themeEdge = {
              id: themeEdgeId,
              properties: {},
              zIndex: 1,
              type: "pro-line",
              sourceNodeId: themeId,
              targetNodeId: id,
              startPoint: {
                x: a + 400,
                y: that.startPointy,
              },
              endPoint: {
                x: a + 400,
                y: that.endPointy,
              },
            };
            this.lf.graphModel.addEdge(themeEdge);
            newEdges.push(that.lf.graphModel.getEdgeModelById(themeEdgeId).getData());
          }
          //协同
          newNodes.push(that.lf.graphModel.getNodeModelById(id).getData());
        }
      });
      that.sendUpdate(newNodes, newEdges, "update", 0);
      let newData = {
        nodes: newNodes,
        edges: newEdges,
        backgroundUrl: localStorage.getItem("background"),
      };
      that.add_Operation(newData, "addNode");
      this.lf.focusOn({
        id: themeId,
      });
      loadingInstance.close();
    },
    generateResourse(ai_result, title, themeId, loadingInstance) {
      let that = this;
      let newNodes = [];
      let newEdges = [];
      let replace_x = find_min_y(that.lf.getNodeModelById(themeId).anchors).x;
      let startPointy = find_max_y(that.lf.getNodeModelById(themeId).anchors).y;
      that.y_coordinate = startPointy;
      let a = replace_x - 400;
      let x_coordinate = 400;
      that.startPointy = startPointy;
      const md = new MarkdownIt();
      ai_result = md.render(ai_result);
      // that.y_coordinate += 500;
      let id = uuidv4();
      let node = {
        id: id,
        type: "icon-card",
        properties: {
          type: "icon-card",
          content: ai_result,
          title: title,
          titleColor: "#DE8344",
          isShowTitle: false,
          radio: "content",
          nodeSize: {
            width: 250,
            height: 600,
          },
        },
        x: a + x_coordinate,
        y: that.y_coordinate + 500,
        zIndex: 1002,
      };
      that.lf.graphModel.addNode(node);
      //协同
      newNodes.push(that.lf.graphModel.getNodeModelById(id).getData());
      //主题卡片和任务卡片的连线
      let themeEdgeId = uuidv4();
      let endPointy = find_min_y(that.lf.getNodeModelById(id).anchors).y;
      that.endPointy = endPointy;
      let themeEdge = {
        id: themeEdgeId,
        properties: {},
        zIndex: 1,
        type: "pro-line",
        sourceNodeId: themeId,
        targetNodeId: id,
        startPoint: {
          x: a + 400,
          y: that.startPointy,
        },
        endPoint: {
          x: a + 400,
          y: that.endPointy,
        },
      };
      this.lf.graphModel.addEdge(themeEdge);
      newEdges.push(that.lf.graphModel.getEdgeModelById(themeEdgeId).getData());
      that.sendUpdate(newNodes, newEdges, "update", 0);
      let newData = {
        nodes: newNodes,
        edges: newEdges,
        backgroundUrl: localStorage.getItem("background"),
      };
      that.add_Operation(newData, "addNode");
      this.lf.focusOn({
        id: themeId,
      });
      loadingInstance.close();
    },
    geneMarkdownCard(text) {
      let that = this;
      let newNodes = [];
      let newEdges = [];
      let data = that.lf.getGraphData();
      let max_node = find_max_x(data.nodes);
      let replace_x = find_max_x(that.lf.getNodeModelById(max_node.id).anchors).x;
      that.y_coordinate = 0;
      let a = replace_x - 400;
      let x_coordinate = 400;
      const md = new MarkdownIt({
        html: true,
      });
      text = md.render(text);
      // that.y_coordinate += 500;
      let id = uuidv4();
      let node = {
        id: id,
        type: "icon-markdown",
        properties: {
          type: "icon-markdown",
          aiContent: text,
          topic: this.languageData.markdownCard,
          isShowTitle: false,
          radio: "description",
          nodeSize: {
            width: 260,
            height: 600,
          },
        },
        x: a + x_coordinate + 260,
        y: that.y_coordinate + 500,
        zIndex: 1002,
      };
      that.lf.graphModel.addNode(node);
      //协同
      newNodes.push(that.lf.graphModel.getNodeModelById(id).getData());
      that.sendUpdate(newNodes, newEdges, "update", 0);
      let newData = {
        nodes: newNodes,
        edges: newEdges,
        backgroundUrl: localStorage.getItem("background"),
      };
      that.add_Operation(newData, "addNode");
      this.lf.focusOn({
        id: id,
      });
    },
    clickMax() {
      this.fullscreen = true;
      $("#whiteBoard .el-dialog").css({
        width: "100%",
      });
      $("#whiteBoard .el-dialog__body").css({
        height: "calc(100% - 41px)",
      });
      $("#backgroundIframe").css({
        height: "calc(100%)",
      });
    },
    clickRecovery() {
      this.fullscreen = false;
      $("#whiteBoard .el-dialog").css({
        width: "60%",
      });
      $("#whiteBoard .el-dialog__body").css({
        height: "69%",
      });
      $("#backgroundIframe").css({
        height: "75vh",
      });
    },
    clickMaxNew() {
      this.fullscreen = true;
      $("#background .el-dialog").css({
        width: "100%",
      });
      $("#background .el-dialog__body").css({
        height: "calc(100% - 41px)",
      });
    },
    clickRecoveryNew() {
      this.fullscreen = false;
      $("#background .el-dialog").css({
        width: "30%",
      });
      $("#background .el-dialog__body").css({
        height: "120px",
      });
    },
    focusMax() {
      this.hoverMax = true;
      this.hoverRecovery = false;
    },
    blurMax() {
      this.hoverMax = false;
      this.hoverRecovery = false;
    },
    focusRecovery() {
      this.hoverMax = false;
      this.hoverRecovery = true;
    },
    blurRecovery() {
      this.hoverMax = false;
      this.hoverRecovery = false;
    },
    changeSelectionSelect(val) {
      this.isSelectionSelect = val;
    },
    changeisPromptsList(val) {
      this.isPromptsList = val;
    },
    changePrompts(val) {
      this.prompts = val;
      this.$_setStyle({
        topic: this.prompts,
      });
    },
    handle_dashboard() {
      this.monitorDialogVisible = true;
      this.$bus.emit("doLogin");
    },
    changeIsShowGroup(val) {
      this.isShowGroup = val;
    },
    getcheckboxGroup() {
      this.global_relationship_echarts(this.logData);
    },
    get_select_CSCLDataByID() {
      // let id = this.group.length > 1 ? this.group[0].id : this.$store.state.cid
      let id = this.$store.state.cid;
      let params = "mode=" + id;
      this.$ajax
        .post("https://pbl.cocorobo.cn/api/pbl/select_CSCLDataByID", params)
        .then((res) => {
          console.log(res);
          // let tonytony = res.data[1].filter(item=>{
          //   return item.username == "tonytony";
          // })
          // let niu = res.data[1].filter(item=>{
          //   return item.username == "牛倩楠" && JSON.parse(item.text).type=="addNode";
          // })
          // console.log(tonytony)
          // console.log(niu.length)
          this.$store.commit("set_select_CSCLDataByID", res.data[1]);
        });
    },
    setMenuConfig(lf) {
      let that = this;
      // 重置卡片，线，画布右键菜单
      lf.extension.menu.setMenuConfig({
        nodeMenu:
          that.group.length > 0
            ? [
                {
                  text: that.languageData.Backspace,
                  callback(node) {
                    // console.log(2)
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        that.isDeleteNode = true;
                        let newNodes = [];
                        let newEdges = [];
                        newNodes.push(node);
                        newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                        let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                        if (outgoingEdgeModel.length != 0) {
                          for (let i = 0; i < outgoingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                        if (incomingEdgeModel.length != 0) {
                          for (let i = 0; i < incomingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        that.sendUpdate(newNodes, newEdges, "delete", 0);
                        lf.deleteNode(node.id);
                        that.isDeleteNode = false;
                        let newData = {
                          nodes: newNodes,
                          edges: newEdges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteNode");
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
                {
                  text: that.languageData.clone,
                  callback(node) {
                    that.isAutomatic = true;
                    lf.cloneNode(node.id);
                    const { nodes } = that.lf.getSelectElements();
                    lf.setElementZIndex(nodes[0].id, "top");
                    that.isAutomatic = false;
                    that.lf.clearSelectElements();
                    that.activeNodes = [];
                  },
                },
                {
                  text: that.languageData.distribute_cards,
                  callback(node) {
                    that.sendNodes = [];
                    that.sendNodes.push(node);
                    that.sendEdges = [];
                    that.sendNodes,that.sendEdges = that.getSectionNodesAndEdges(node,lf,that.sendNodes,that.sendEdges)
                    that.showSendDialogVisible = true;
                  },
                },
                {
                  text: that.languageData.top,
                  callback(node) {
                    lf.setElementZIndex(node.id, "top");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.bottom,
                  callback(node) {
                    lf.setElementZIndex(node.id, "bottom");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.forward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex + 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex + 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.backward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex - 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex - 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
              ]
            : [
                {
                  text: that.languageData.Backspace,
                  callback(node) {
                    // console.log(2)
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        that.isDeleteNode = true;
                        let newNodes = [];
                        let newEdges = [];
                        newNodes.push(node);
                        newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                        let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                        if (outgoingEdgeModel.length != 0) {
                          for (let i = 0; i < outgoingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                        if (incomingEdgeModel.length != 0) {
                          for (let i = 0; i < incomingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        that.sendUpdate(newNodes, newEdges, "delete", 0);
                        lf.deleteNode(node.id);
                        that.isDeleteNode = false;
                        let newData = {
                          nodes: newNodes,
                          edges: newEdges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteNode");
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
                {
                  text: that.languageData.clone,
                  callback(node) {
                    that.isAutomatic = true;
                    lf.cloneNode(node.id);
                    const { nodes } = that.lf.getSelectElements();
                    lf.setElementZIndex(nodes[0].id, "top");
                    that.isAutomatic = false;
                    that.lf.clearSelectElements();
                    that.activeNodes = [];
                  },
                },
                {
                  text: that.languageData.top,
                  callback(node) {
                    lf.setElementZIndex(node.id, "top");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.bottom,
                  callback(node) {
                    lf.setElementZIndex(node.id, "bottom");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.forward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex + 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex + 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.backward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex - 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex - 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
              ], // 覆盖默认的节点右键菜单
        edgeMenu: [
          {
            text: that.languageData.delete,
            callback(edge) {
              that.isResizeNode = false;
              that.isDeleteNode = false;
              lf.deleteEdge(edge.id);
              let newEdge = [];
              newEdge.push(edge);
              that.sendUpdate([], newEdge, "delete", 0);
              let newData = {
                nodes: [],
                edges: newEdge,
                backgroundUrl: localStorage.getItem("background"),
              };
              that.add_Operation(newData, "deleteEdge");
            },
          },
        ], // 删除默认的边右键菜单
        graphMenu: [
          // {
          //   text: that.languageData.beautifyAllNew,
          //   callback() {
          //     lf.extension.dagre && lf.extension.dagre.layout({
          //       nodesep: 20,
          //       ranksep: 20,
          //     });
          //   },
          // },
          {
            text: that.languageData.restore_background,
            callback() {
              localStorage.setItem("background", "");
              let newData = that.lf.getGraphData();
              newData.backgroundUrl = "";
              that.initLogicFlow(newData);
              // that.isAutomatic = false
              // that.lf.graphModel.graphDataToModel(newData)
              // that.lf.options.grid = newData.backgroundUrl != "" ? false : true
              // that.lf.options.background = {
              //   backgroundImage: 'url(' + newData.backgroundUrl + ')',
              //   backgroundRepeat: 'no-repeat',
              //   backgroundSize: 'cover',
              //   backgroundColor: '#F2F2F2'
              // };
              // that.lf.graphModel.partial = false
              // that.lf.render(that.lf.getGraphData())
              // that.lf.graphModel.partial = true
              that.sendUpdate([], [], "update", 0);
            },
          },
        ], // 覆盖默认的边右键菜单，与false表现一样
      });
      // 重置选区右键菜单
      lf.extension.menu.setMenuByType({
        type: "lf:defaultSelectionMenu",
        menu:
          that.group.length > 0
            ? [
                {
                  text: that.languageData.delete,
                  callback() {
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        const elements = lf.getSelectElements(true);
                        // lf.clearSelectElements();
                        let newNodes = [];
                        let newEdges = [];
                        if (elements.nodes.length != 0 && elements.edges.length != 0) {
                          that.isDeleteNode = true;
                          elements.nodes.forEach((node) => {
                            newNodes.push(node);
                            lf.deleteNode(node.id);
                          });
                          elements.edges.forEach((edge) => {
                            newEdges.push(edge);
                            lf.deleteEdge(edge.id);
                          });
                          that.sendUpdate(newNodes, newEdges, "delete", 0);
                          that.isDeleteNode = false;
                          let newData = {
                            nodes: newNodes,
                            edges: newEdges,
                            backgroundUrl: localStorage.getItem("background"),
                          };
                          that.add_Operation(newData, "deleteNode");
                        }
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
                {
                  text: that.languageData.send,
                  callback() {
                    const elements = lf.getSelectElements(false);
                    lf.clearSelectElements();
                    that.sendNodes = [];
                    that.sendEdges = [];
                    let nodeIds = [];
                    if (elements.nodes.length != 0) {
                      that.isDeleteNode = true;
                      elements.nodes.forEach((node) => {
                        that.sendNodes.push(node);
                        nodeIds.push(node.id);
                      });
                    }
                    if (elements.edges.length != 0) {
                      elements.edges.forEach((edge) => {
                        if (
                          nodeIds.indexOf(edge.sourceNodeId) != -1 &&
                          nodeIds.indexOf(edge.targetNodeId) != -1
                        ) {
                          that.sendEdges.push(edge);
                        }
                      });
                    }
                    that.showSendDialogVisible = true;
                  },
                },
                // {
                //   text: "选区美化",
                //   callback() {
                //     const elements = lf.getSelectElements(true);
                //     lf.clearSelectElements();
                //     lf.extension.selectDagre && lf.extension.selectDagre.layout({
                //       nodesep: 80,
                //       ranksep: 80,
                //     }, elements);
                //   }
                // }
              ]
            : [
                {
                  text: that.languageData.delete,
                  callback() {
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        const elements = lf.getSelectElements(true);
                        // lf.clearSelectElements();
                        let newNodes = [];
                        let newEdges = [];
                        if (elements.nodes.length != 0 && elements.edges.length != 0) {
                          that.isDeleteNode = true;
                          elements.nodes.forEach((node) => {
                            newNodes.push(node);
                            lf.deleteNode(node.id);
                          });
                          elements.edges.forEach((edge) => {
                            newEdges.push(edge);
                            lf.deleteEdge(edge.id);
                          });
                          that.sendUpdate(newNodes, newEdges, "delete", 0);
                          that.isDeleteNode = false;
                          let newData = {
                            nodes: newNodes,
                            edges: newEdges,
                            backgroundUrl: localStorage.getItem("background"),
                          };
                          that.add_Operation(newData, "deleteNode");
                        }
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
              ],
      });
    },
    setIsSilentMode(val) {
      let that = this;
      that.isSilentMode = val;
      let lf = that.lf;
      let data = lf.getGraphData();
      // if (!val) {
      //   that.setMenuConfig(lf);
      //   lf.render(data);
      // } else {
      //   // 重置右键菜单
      //   lf.extension.menu.setMenuConfig({
      //     nodeMenu: false,
      //     edgeMenu: false,
      //     graphMenu: [],
      //   });
      //   // 重置选区右键菜单
      //   lf.extension.menu.setMenuByType({
      //     type: "lf:defaultSelectionMenu",
      //     menu: [],
      //   });
      //   lf.render(data);
      // }
      destoryApp();
      data.backgroundUrl = localStorage.getItem("background")
      try {
        let nodeIds = [];
        for (let i = 0; i < data.nodes.length; i++) {
          nodeIds.push(data.nodes[i].id);
        }
        let edges = [];
        for (let i = 0; i < data.edges.length; i++) {
          if (
            nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 &&
            nodeIds.indexOf(data.edges[i].targetNodeId) != -1
          ) {
            edges.push(data.edges[i]);
          }
        }
        data.edges = edges;
        this.isAutomatic = false;
        this.lf.history.undos = [];
        this.lf.history.redos = [];
        this.lf.graphModel.graphDataToModel(data);
        this.initLogicFlow(data);
        // this.lf.options.grid = newVal.backgroundUrl != "" ? false : true
        // this.lf.options.background = {
        //   backgroundImage: 'url(' + newVal.backgroundUrl + ')',
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'cover',
        //   backgroundColor: '#F2F2F2'
        // };
        // this.lf.render(newVal)
      } catch {
        this.isAutomatic = false;
        // let data = {
        //   nodes: newVal.nodes,
        //   edges: [],
        //   backgroundUrl: newVal.backgroundUrl
        // }
        // this.lf.graphModel.graphDataToModel(newVal)
        this.initLogicFlow(data);
      }
    },
    setIsSilentModeNew(val) {
      let that = this;
      that.isSilentMode = val;
    },
    setIsShowMode(val) {
      this.isShowMode = val;
    },
    clearIncreasingTrenTime() {
      if (this.IncreasingTrenTime) {
        clearInterval(this.IncreasingTrenTime);
      }
    },
    close_messageDialog(value) {
      this.MessageDialog_flag = value;
    },
    handleCheckAllChange(val) {
      let groupIds = [];
      for (let i = 0; i < this.group.length; i++) {
        if (this.group[i].id != this.active_group_id) {
          groupIds.push(this.group[i].id);
        }
      }
      this.sendRadio = val ? groupIds : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.group.length - 1;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.group.length - 1;
    },
    init_result_map() {
      let that = this;
      that.fake.start();
      that.newAnalyseLoading = true;
      let id = this.group.length > 1 ? this.group[0].id : this.$store.state.cid;
      let params = "mode=" + id;
      that.addNodeCard = [];
      that.updateNodeCard = [];
      that.deleteNodeCard = [];
      that.addEdgesLines = [];
      that.deleteEdgesLines = [];
      that.$nextTick(() => {
        that.$ajax
          .post("https://pbl.cocorobo.cn/api/pbl/select_CSCLDataByID", params)
          .then((res) => {
            this.analyserUserData = res.data[0];
            this.analyserUserData.unshift(that.$store.state.creator);
            this.all_student = res.data[0];
            this.logData = res.data[1];
            let resourceClassObj = [
              { name: this.languageData.picture, value: 0 },
              { name: this.languageData.videoAndAudio, value: 0 },
              { name: this.languageData.text, value: 0 },
              { name: this.languageData.urlAndIframe, value: 0 },
              { name: this.languageData.fileContent, value: 0 },
            ];
            let p_r_d_data = [];
            res.data[1].forEach((item) => {
              let text = JSON.parse(item.text);
              if (text.type == "updateNode") {
                that.updateNodeCard.push(item);
                if (text.data.nodes[0]?.properties) {
                  let properties = text.data.nodes[0].properties;
                  if (properties && properties.radio == "imageList") {
                    resourceClassObj[0].value++;
                  } else if (properties && properties.radio == "content") {
                    resourceClassObj[2].value++;
                  } else if (
                    (properties && properties.radio == "iframeUrl") ||
                    (properties && properties.radio == "embedCode")
                  ) {
                    resourceClassObj[3].value++;
                  } else if (
                    (properties && properties.radio == "videoList") ||
                    (properties && properties.radio == "audioList")
                  ) {
                    resourceClassObj[1].value++;
                  } else if (properties && properties.radio == "fileList") {
                    resourceClassObj[4].value++;
                  }
                }
              } else if (text.type == "addNode") {
                that.addNodeCard.push(item);
                p_r_d_data.push({
                  name: item.name,
                  value: 1,
                });
              } else if (text.type == "deleteNode") {
                that.deleteNodeCard.push(item);
              } else if (text.type == "addEdge") {
                that.addEdgesLines.push(item);
              } else if (text.type == "deleteEdge") {
                that.deleteEdgesLines.push(item);
              }
            });
            //console.log(resourceClassObj)
            this.resourceClassObj = resourceClassObj;
            let p_r_d_data2 = [];
            p_r_d_data.forEach((item) => {
              if (item) {
                p_r_d_data2.push(item);
              }
            });
            for (let i = 0; i < p_r_d_data2.length - 1; i++) {
              for (let j = i + 1; j < p_r_d_data2.length; j++) {
                if (p_r_d_data2[i].name == p_r_d_data2[j].name) {
                  p_r_d_data2[i].value++;
                  p_r_d_data2[j].value++;
                }
              }
            }
            const set = new Set(p_r_d_data2.map(JSON.stringify)); // 将每个对象转换为字符串形式，然后放入Set数据结构中
            const newArr = Array.from(set).map(JSON.parse); // 将Set数据结构转换为数组，并将每个字符串转换为对象
            //that.$store.commit("set_select_CSCLDataByID", newArr);
            // 资源类别
            that.init_p_r_d(resourceClassObj);
            // 贡献度
            that.contribution_degree_echarts(newArr);
            //小组成果排行榜
            that.group_achievement_echarts();
            // 登录频次
            that.entryFrequencyEcharts(res.data[1]);
            // 全局关系图
            that.global_relationship_echarts(res.data[1]);
            // 卡片增加趋势图
            // that.Increasing_trend_echarts(that.addNodeCard)
            // 进度条+关闭弹框
            that.fake.end();
            that.newAnalyseLoading = false;
          });
      });
    },
    //该方法只适用于[12,5,1]或者[12,5,1,'tony']这种二维数组数据，请保证第三项为可加项
    handle_re_arr(data3) {
      let map = new Map();
      let result = [];
      for (let i = 0; i < data3.length; i++) {
        let key = data3[i].toString();
        if (map.has(key)) {
          map.set(key, map.get(key) + 1);
        } else {
          map.set(key, 1);
          result.push(data3[i]);
        }
      }
      const data_lfc = result.map((item) => {
        let key = item.toString();
        item[2] = map.get(key);
        return [...item];
      });
      return data_lfc;
    },
    init_p_r_d(resourceClassObj) {
      //项目成果分布
      const prd = document.getElementById("p_r_d");
      let myChart = echarts.getInstanceByDom(prd);
      if (!myChart) {
        myChart = echarts.init(prd);
      }
      const option = {
        title: {
          text: this.languageData.resourceClass,
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "1%",
          left: "center",
        },
        series: [
          {
            name: this.languageData.resourceClass,
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false, //是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            data: resourceClassObj,
          },
        ],
      };
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myChart.resize();
      };
      EleResize.on(prd, myResourceContributionChartListener);
      option && myChart.setOption(option);
    },
    // 贡献度
    contribution_degree_echarts(data) {
      let data2 = data;
      let yAxis = [];
      let series = [];
      for (let i = 0; i < data2.length - 1; i++) {
        let minIndex = i; //用于存储最小值的下标，排序刚开始时，假设最小值的下标就是选中的基准数据下标
        for (let j = i + 1; j < data2.length; j++) {
          if (data2[j].value > data2[minIndex].value) {
            minIndex = j;
          }
        }
        [data2[i], data2[minIndex]] = [data2[minIndex], data2[i]];
      }
      for (let i = 0; i < data2.length; i++) {
        yAxis.push(data2[i].name);
        series.push(data2[i].value);
      }
      yAxis.reverse();
      series.reverse();
      const top6 = document.getElementById("top6");
      let myChart2 = echarts.getInstanceByDom(top6);
      if (!myChart2) {
        myChart2 = echarts.init(top6);
      }
      const option2 = {
        title: {
          text: this.languageData.top6,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: yAxis,
          axisLabel: {
            interval: 0
          }
        },
        series: [
          {
            type: "bar",
            data: series,
          },
        ],
      };
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myChart2.resize();
      };
      EleResize.on(top6, myResourceContributionChartListener);
      option2 && myChart2.setOption(option2);
    },
    // 小组成果图
    group_achievement_echarts() {
      let groupIcadTheme = [];
      this.groupDatas.length > 0 &&
        this.groupDatas.forEach((item) => {
          let obj = {
            id: item.id,
            name: "",
            value: 0,
          };
          let iconTheme = 0;
          try {
            item.data &&
              item.data.nodes.length > 0 &&
              item.data.nodes.forEach(() => {
                iconTheme++;
              });
          } catch {
            iconTheme = 0;
          }
          this.group.length > 0 &&
            this.group.forEach((x) => {
              if (x.id == item.id) {
                obj.name = x.name;
              }
            });
          obj.value = iconTheme;
          groupIcadTheme.push(obj);
        });
      groupIcadTheme.sort(function (a, b) {
        return a.value - b.value;
      });
      const group_achievement = document.getElementById("group_achievement");
      let myChart_group_achievement = echarts.getInstanceByDom(group_achievement);
      if (!myChart_group_achievement) {
        myChart_group_achievement = echarts.init(group_achievement);
      }
      const option_group_achievement = {
        title: {
          text: this.languageData.group_achievement,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: groupIcadTheme.map((item) => {
            return item.name;
          }),
          axisLabel: {
            // fontSize: 10,
            interval: 0,
          },
        },
        series: [
          {
            data: groupIcadTheme,
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myChart_group_achievement.resize();
      };
      EleResize.on(group_achievement, myResourceContributionChartListener);
      option_group_achievement &&
        myChart_group_achievement.setOption(option_group_achievement);
    },
    // 操作频次图
    entryFrequencyEcharts(data) {
      console.log(data);
      const data3 = data.map((item) => {
        let week = Math.abs(
          new Date(item.create_at).getDay() == 0
            ? 0
            : new Date(item.create_at).getDay() - 7
        );
        let time = new Date(item.create_at).getHours();
        if (JSON.parse(item.text).type == "addNode") {
          this.icfc_data.push([time, week, 1, item.name]);
        }
        return [time, week, 1];
      });
      const data_lfc = this.handle_re_arr(data3);
      //console.log(data_lfc);
      const lfc = document.getElementById("lfc");
      let myChart = echarts.getInstanceByDom(lfc);
      if (!myChart) {
        myChart = echarts.init(lfc);
      }
      const hours = [
        "0AM",
        "1AM",
        "2AM",
        "3AM",
        "4AM",
        "5AM",
        "6AM",
        "7AM",
        "8AM",
        "9AM",
        "10AM",
        "11AM",
        "12AM",
        "1PM",
        "2PM",
        "3PM",
        "4PM",
        "5PM",
        "6PM",
        "7PM",
        "8PM",
        "9PM",
        "10PM",
        "11PM",
      ];
      // prettier-ignore
      const days = [
        this.languageData.Sun,this.languageData.Sat,this.languageData.Fir,this.languageData.Thur,this.languageData.Wed,this.languageData.Tues,this.languageData.Mon, 
      ];
      const option = {
        title: {
          text: this.languageData.ofc,
          left: "center",
        },
        tooltip: {
          position: "top",
        },
        grid: {
          left: "3%",
          height: "70%",
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: hours,
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true,
          },
        },
        visualMap: {
          min: 0,
          max: 50,
          show: false,
          calculable: true,
          orient: "horizontal",
          left: "center",
          bottom: "13%",
          inRange: {
            color: ["whiteSmoke", "#6f88d2"],
          },
        },
        dataZoom: [
          // {
          //     type: 'inside'
          // },
          {
            type: "slider",
            startValue: 7,
            endValue: 20,
          },
        ],
        series: [
          {
            name: this.languageData.ofc,
            type: "heatmap",
            data: data_lfc,
            label: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myChart.resize();
      };
      EleResize.on(lfc, myResourceContributionChartListener);
      option && myChart.setOption(option);
    },
    // 用户数据
    getUserGroup(val) {
      this.groupDatas = val;
    },
    // 全局关系图
    global_relationship_echarts(data) {
      let userColor = ["#5DE2DA", "#FFE434", "#56A3F1", "#FF917C", "#FFE434", "#56A3F1"];
      let globalDataLists = [];
      let addNodeList = [];
      let updateNodeList = [];
      let addEdgesList = [];
      let linksArr = [];
      let deleteNodeList = [];
      data.forEach((item) => {
        let addNodes = JSON.parse(item.text);
        if (addNodes.type == "addNode") {
          let listObj = addNodeList.filter((i) => {
            return i.userid == item.userid;
          });
          if (listObj.length > 0) {
            addNodeList.map((x) => {
              let xObj = x;
              if (xObj.userid == listObj[0].userid) {
                xObj.createArr = xObj.createArr.concat(addNodes.data.nodes);
              }
              return xObj;
            });
          } else {
            item.createArr = addNodes.data.nodes;
            addNodeList.push(item);
          }
        } else if (addNodes.type == "updateNode") {
          let listObj = updateNodeList.filter((i) => {
            return i.userid == item.userid;
          });
          if (listObj.length > 0) {
            updateNodeList.map((x) => {
              let xObj = x;
              if (xObj.userid == listObj[0].userid) {
                // xObj.value = x.value + 1
                xObj.updateNodes = xObj.updateNodes.concat(addNodes.data.nodes);
                // xObj.symbolSize = (xObj.createArr.length / 10)
              }
              return xObj;
            });
          } else {
            item.updateedges = addNodes.data.edges;
            item.updateNodes = addNodes.data.nodes;
            updateNodeList.push(item);
          }
        } else if (addNodes.type == "addEdge") {
          let listObj = addEdgesList.filter((i) => {
            return i.userid == item.userid;
          });
          if (listObj.length > 0) {
            addEdgesList.map((x) => {
              let xObj = x;
              if (xObj.userid == listObj[0].userid) {
                xObj.updateedges = xObj.updateedges.concat(addNodes.data.edges);
              }
              return xObj;
            });
          } else {
            item.updateedges = addNodes.data.edges;
            addEdgesList.push(item);
          }
        } else if (addNodes.type == "deleteNode") {
          let listObj = deleteNodeList.filter((i) => {
            return i.userid == item.userid;
          });
          if (listObj.length > 0) {
            deleteNodeList.map((x) => {
              let xObj = x;
              if (xObj.userid == listObj[0].userid) {
                xObj.updateedges = xObj.updateedges.concat(addNodes.data.nodes);
              }
              return xObj;
            });
          } else {
            item.updateedges = addNodes.data.nodes;
            deleteNodeList.push(item);
          }
        }
      });
      let temp = [];
      for (let i = 0; i < this.group.length; i++) {
        let userObj = this.group[i];
        for (let j = 0; j < userObj.group_member.length; j++) {
          let user = userObj.group_member[j];
          let nodeArr = [];
          let linesArr = [];
          let updateArr = [];
          let deleteArr = [];
          for (let m = 0; m < addNodeList.length; m++) {
            let nodesId = addNodeList[m].createArr.map((x) => x.id);
            if (addNodeList[m].userid == user.userid) {
              nodeArr.push(nodesId);
            }
          }
          if (this.checkboxGroupValue == "edit" || this.checkboxGroupValue == "all") {
            for (let m = 0; m < updateNodeList.length; m++) {
              let nodesId = updateNodeList[m].updateNodes.map((x) => x.id);
              if (updateNodeList[m].userid == user.userid) {
                updateArr.push(nodesId);
              }
            }
          }

          if (
            this.checkboxGroupValue == "studentTip6" ||
            this.checkboxGroupValue == "all"
          ) {
            for (let m = 0; m < addEdgesList.length; m++) {
              let linesId = addEdgesList[m].updateedges.map((x) => x.sourceNodeId);
              if (addEdgesList[m].userid == user.userid) {
                linesArr.push(linesId);
              }
            }
          }

          if (
            this.checkboxGroupValue == "deleteGraps" ||
            this.checkboxGroupValue == "all"
          ) {
            for (let m = 0; m < deleteNodeList.length; m++) {
              let linesId = deleteNodeList[m].updateedges.map((x) => x.id);
              if (deleteNodeList[m].userid == user.userid) {
                deleteArr.push(linesId);
              }
            }
          }
          if (temp.indexOf(userObj.group_member[j].userid) == -1) {
            globalDataLists.push({
              id: userObj.group_member[j].userid,
              name: userObj.group_member[j].username,
              itemStyle: { color: userColor[i] },
              value: 0,
              symbolSize: 20,
              x: 250 * i + Math.random() * 250,
              y: 250 * i - Math.random() * 250,
              nodeArr: nodeArr.flat(),
              linesArr: linesArr.flat(),
              updateArr: updateArr.flat(),
              deleteArr: deleteArr.flat(),
            });
            temp.push(userObj.group_member[j].userid);
          }
        }
      }
      globalDataLists.length > 1 &&
        globalDataLists.forEach((item) => {
          if (item.nodeArr.length > 0) {
            item.nodeArr.forEach((id) => {
              if (this.checkboxGroupValue == "edit" || this.checkboxGroupValue == "all") {
                let widthNum = 0;
                let updateUser = {};
                globalDataLists.forEach((updateitem) => {
                  widthNum = 0;
                  if (item.id != updateitem.id) {
                    updateUser = updateitem;
                    widthNum = updateitem.updateArr.filter((itemid) => itemid == id)
                      .length;
                  }
                  if (widthNum > 0) {
                    let num = widthNum;
                    let b = {
                      // id: item.id,
                      source: updateUser.id,
                      sourceName: updateUser.name,
                      target: item.id,
                      lineStyle: {
                        width: num > 10 ? 10 : num + num / 100,
                        color: "#5772c3",
                        curveness: 0.05,
                      },
                    };
                    linksArr.push(b);
                  }
                });
              }
              if (
                this.checkboxGroupValue == "studentTip6" ||
                this.checkboxGroupValue == "all"
              ) {
                let linesNum = [];
                for (let m = 0; m < addEdgesList.length; m++) {
                  addEdgesList[m].updateedges.map((x) => {
                    if (x.sourceNodeId == id) {
                      globalDataLists.length > 1 &&
                        globalDataLists.forEach((item) => {
                          if (item.nodeArr.length > 0) {
                            item.nodeArr.forEach((id) => {
                              if (x.targetNodeId == id) {
                                linesNum.push(item.id);
                              }
                            });
                          }
                        });
                    }
                  });
                }
                // 卡片连线操作
                if (linesNum.length > 0 && item.id != linesNum[0]) {
                  let num = linesNum.length;
                  let b = {
                    // id: item.id,
                    source: item.id,
                    sourceName: item.name,
                    target: linesNum[0],
                    lineStyle: {
                      width: num > 10 ? 10 : num + num / 100,
                      color: "#97cc7d",
                      curveness: 0.3,
                    },
                  };
                  linksArr.push(b);
                }
              }
            });
          }
        });
      globalDataLists.map((item) => {
        let num =
          item.symbolSize +
          item.nodeArr.length +
          item.linesArr.length +
          item.updateArr.length +
          item.deleteArr.length;
        item.symbolSize = num > 30 ? 30 + num / 100 : num;
        (item.label = {
          show: item.symbolSize > 20 ? true : false,
          position: "inside",
        }),
          (item.value = num > 20 ? num - 20 : 0);
        return item;
      });
      let globalRelationshipDom = document.getElementById("global_relationship");
      let globalRelationshipOption = {
        title: {
          text: this.languageData.global_relationship_echarts,
          left: "left",
        },
        toolbox: {
          feature: {
            myFull: {
              // 全屏
              show: true,
              title: this.languageData.fullScreen,
              icon:
                "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
              onclick: () => {
                if (globalRelationshipDom.requestFullScreen) {
                  // HTML W3C 提议
                  globalRelationshipDom.requestFullScreen();
                } else if (globalRelationshipDom.msRequestFullscreen) {
                  // IE11
                  globalRelationshipDom.msRequestFullScreen();
                } else if (globalRelationshipDom.webkitRequestFullScreen) {
                  // Webkit
                  globalRelationshipDom.webkitRequestFullScreen();
                } else if (globalRelationshipDom.mozRequestFullScreen) {
                  // Firefox
                  globalRelationshipDom.mozRequestFullScreen();
                }
                // 退出全屏
                if (globalRelationshipDom.requestFullScreen) {
                  globalRelationshipDom.exitFullscreen();
                } else if (globalRelationshipDom.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (globalRelationshipDom.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (globalRelationshipDom.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        legend: {
          data: [this.languageData.edit_Card, this.languageData.studentTip6],
        },
        tooltip: {
          // formatter:"{b1}: {c1}"
        },
        series: [
          {
            name: "",
            type: "graph",
            layout: "circular",
            circular: {
              rotateLabel: false,
            },
            edgeSymbol: ["circle", "arrow"],
            data: globalDataLists,
            links: linksArr,
            categories: [
              {
                name: this.languageData.edit_Card,
              },
              {
                name: this.languageData.studentTip6,
              },
            ],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0,
            },
            padding: 30,
          },
        ],
      };
      let myResourceContributionChart = echarts.getInstanceByDom(globalRelationshipDom);
      if (!myResourceContributionChart) {
        myResourceContributionChart = echarts.init(globalRelationshipDom);
      }
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myResourceContributionChart.resize();
      };
      EleResize.on(globalRelationshipDom, myResourceContributionChartListener);
      globalRelationshipOption &&
        myResourceContributionChart.setOption(globalRelationshipOption);
    },
    // 增加趋势图
    Increasing_trend_echarts(data) {
      const getTimeLists = data.map((x) => Number(new Date(x.create_at).getTime()));
      const maxTime = Math.max.apply(Math, getTimeLists);
      const minTime = Math.min.apply(Math, getTimeLists);
      const num = parseInt((maxTime - minTime) / (1000 * 60) / 30);
      let timeList = new Array(num);
      for (let i = 0; i < num; i++) {
        if (i == 0) {
          timeList[0] = minTime;
        } else {
          timeList[i] = timeList[i - 1] + 1000 * 60 * 30;
        }
      }
      let echartsData = [];
      for (let i = 1; i < timeList.length; i++) {
        // console.log("时间：",new Date(data[i].create_at).getTime())
        let obj = {
          value: 100,
          time: new Date(timeList[i - 1]).toLocaleString(),
        };
        for (let j = 0; j < data.length; j++) {
          if (
            new Date(data[j].create_at).getTime() > timeList[i - 1] &&
            new Date(data[j].create_at).getTime() < timeList[i]
          ) {
            obj.value++;
          }
        }
        echartsData.push(obj);
      }
      console.log("echartsData", echartsData);
      let startTime = echartsData[0].time;
      let dataList = [echartsData[0].value];
      let IncreasingTrendDom = document.getElementById("Increasing_trend");
      const treeDataURI =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAA2CAYAAADUOvnEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA5tJREFUeNrcWE1oE0EUnp0kbWyUpCiNYEpCFSpIMdpLRTD15s2ePHixnj00N4/GoyfTg2fbiwdvvagHC1UQ66GQUIQKKgn1UAqSSFua38b3prPJZDs7s5ufKn0w7CaZ2W/fe9/73kyMRqNB3Nrj1zdn4RJ6du9T2u1a2iHYSxjP4d41oOHGQwAIwSUHIyh8/RA8XeiXh0kLGFoaXiTecw/hoTG4ZCSAaFkY0+BpsZceLtiAoV2FkepZSDk5EpppczBvpuuQCqx0YnkYcVVoqQYMyeCG+lFdaGkXeVOFNu4aEBalOBk6sbQrQF7gSdK5JXjuHXuYVIVyr0TZ0FjKDeCs6km7JYMUdrWAUVmZUBtmRnVPK+x6nIR2xomH06R35ggwJPeofWphr/W5UjPIxq8B2bKgE8C4HVHWvg+2gZjXj19PkdFztY7bk9TDCH/g6oafDPpaoMvZIRI5WyMB/0Hv++HkpTKE0kM+A+h20cPAfN4GuRyp9G+LMTW+z8rCLI8b46XO9zRcYZTde/j0AZm8WGb3Y2F9KLlE2nqYkjFLJAsDOl/lea0q55mqxXcL7YBc++bsCPMe8mUyU2ZIpnCoblca6TZA/ga2Co8PGg7UGUlEDd0ueptglbrRZLLE7poti6pCaWUo2pu1oaYI1CF9b9cCZPO3F8ikJQ/rPpQT5YETht26ss+uCIL2Y8vHwJGpA96GI5mjOlaKhowUy6BcNcgIhDviTGWCGFaqEuufWz4pgcbCh+w0gEOyOjTlTtYYlIWPYWKEsLDzOs+nhzaO1KEpd+MXpOoTUgKiNyhdy5aSMPNVqxtSsJFgza5EWA4zKtCJ2OGbLn0JSLu8+SL4G86p1Fpr7ABXdGFF/UTD4rfmFYFw4G9VAJ9SM3aF8l3yok4/J6IV9sDVb36ynmtJ2M5+CwxTYBdKNMBaocKGV2nYgkz6r+cHBP30MzAfi4Sy+BebSoPIOi8PW1PpCCvr/KOD4k9Zu0WSH0Y0+SxJ2awp/nlwKtcGyHOJ8vNHtRJzhPlsHr8MogtlVtwUU0tSM1x58upSKbfJnSKUR07GVMKkDNfXpzpv0RTHy3nZMVx5IOWdZIaPabGFvfpwpjnvfmJHXLaEvZUTseu/TeLc+xgAPhEAb/PbjO6PBaOTf6LQRh/dERde23zxLtOXbaKNhfq2L/1fAOPHDUhOpIf5485h7l+GNHHiSYPKE3Myz9sFxoJuAyazvwIMAItferha5LTqAAAAAElFTkSuQmCC";
      let option = {
        color: ["#e54035"],
        xAxis: {
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          name: startTime,
          nameLocation: "middle",
          nameGap: 40,
          nameTextStyle: {
            color: "green",
            fontSize: 30,
            fontFamily: "Arial",
          },
          min: -2800,
          max: 2800,
        },
        yAxis: {
          data: echartsData.map((x) => x.time),
          show: false,
        },
        grid: {
          top: "center",
          height: 280,
        },
        series: [
          {
            name: "all",
            type: "pictorialBar",
            symbol: "image://" + treeDataURI,
            symbolSize: [10, 55],
            symbolRepeat: true,
            data: dataList,
            // data:echartsData.map(x=>x.value),
            animationEasing: "elasticOut",
          },
        ],
      };

      let myResourceContributionChart = echarts.getInstanceByDom(IncreasingTrendDom);
      if (!myResourceContributionChart) {
        myResourceContributionChart = echarts.init(IncreasingTrendDom);
      }
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myResourceContributionChart.resize();
      };
      EleResize.on(IncreasingTrendDom, myResourceContributionChartListener);
      option && myResourceContributionChart.setOption(option);
      let startNum = 0;
      this.IncreasingTrenTime = setInterval(function () {
        startNum++;
        if (startNum > num) {
          startNum = 0;
          dataList = [echartsData[startNum].value];
        }
        dataList.push(echartsData[startNum].value);
        myResourceContributionChart.setOption({
          xAxis: {
            name: echartsData[startNum].time,
          },
          series: [
            {
              data: dataList,
              // data:echartsData.map(x=>x.value)
            },
          ],
        });
      }, 1000);
    },
    changeRate(val) {
      this.isChangeRate = val;
    },
    /*
      数据分析-学生-选择页码
    */
    selectPage(e) {
      let that = this;
      that.selectStudentPage = e;
      that.get_Operation("student");
    },
    selectPages(e) {
      let that = this;
      that.selectGroupPage = e;
      that.get_Operation("collaborate");
    },
    select_personage(e) {
      let arrFilter = this.all_student.filter((item) => {
        return item.name == e;
      });
      // let loadingInstance = Loading.service({ fullscreen: true, text: this.languageData.analyseTip });
      this.handleStudentData(this.logData, arrFilter);
    },
    select_group(e) {
      // let loadingInstance = Loading.service({ fullscreen: true, text: this.languageData.analyseTip });
      if (e) {
        let group = this.group.filter((item) => {
          return item.name == e;
        });
        this.all_student = group[0].group_member;
        this.handleStudentData(this.logData, group[0].group_member);
      } else {
        let totalPage =
          this.analyserUserData.length % 4 != 0
            ? parseInt(this.analyserUserData.length / 4) + 1
            : this.analyserUserData.length / 4;
        this.selectStudentPageNum = [];
        for (let i = 0; i < totalPage; i++) {
          this.selectStudentPageNum.push("第" + (i + 1) + "页");
        }
        this.handleStudentData(this.logData, this.analyserUserData);
      }
    },
    /*
      数据分析-学生-处理数据
    */
    async handleStudentData(data, userList) {
      let that = this;
      that.fake.start();
      document.getElementById("pane-student").style.height = "100%";
      that.personageLoading = true;
      that.selectStudentList = [];
      let allData = []; //整理后每个学生的数据
      for (let i = 0; i < userList.length; i++) {
        let speechesTimes = await that.getChatTimes(
          userList[i].groupCid ? userList[i].groupCid : "",
          userList[i].userid
        );
        let obj = {
          userId: userList[i].userid,
          createCardTimes: 0,
          editCardTotalTimes: 0,
          createResourceCardTimes: 0,
          likesTimes: 0,
          speechesTimes: speechesTimes,
          createEdgeTimes: 0,
          editOthersCardTimes: 0,
          createImageResourceCardTimes: 0,
          createVideoResourceCardTimes: 0,
          createIframeResourceCardTimes: 0,
          createVoiceResourceCardTimes: 0,
          createFileResourceCardTimes: 0,
          addNodes: [],
          updateNodes: [],
          addEdges: [],
        };
        for (let j = 0; j < data.length; j++) {
          let textData = JSON.parse(data[j].text);
          if (userList[i].userid == data[j].userid) {
            if (textData.type == "addNode") {
              obj.createCardTimes = obj.createCardTimes + 1;
              obj.addNodes = obj.addNodes.concat(textData.data.nodes);
            } else if (textData.type == "updateNode") {
              obj.editCardTotalTimes = obj.editCardTotalTimes + 1;
              obj.updateNodes = obj.updateNodes.concat(textData.data.nodes);
              for (let k = 0; k < textData.data.nodes.length; k++) {
                if (
                  textData.data.nodes[k].type == "icon-card" &&
                  textData.data.nodes[k].properties.radio &&
                  textData.data.nodes[k].properties.radio != "content"
                ) {
                  obj.createResourceCardTimes = obj.createResourceCardTimes + 1;
                  if (textData.data.nodes[k].properties.radio == "imageList") {
                    obj.createImageResourceCardTimes =
                      obj.createImageResourceCardTimes + 1;
                  }
                  if (
                    textData.data.nodes[k].properties.radio == "iframeUrl" ||
                    textData.data.nodes[k].properties.radio == "embedCode"
                  ) {
                    obj.createIframeResourceCardTimes =
                      obj.createIframeResourceCardTimes + 1;
                  }
                  if (textData.data.nodes[k].properties.radio == "videoList") {
                    obj.createVideoResourceCardTimes =
                      obj.createVideoResourceCardTimes + 1;
                  }
                  if (textData.data.nodes[k].properties.radio == "audioList") {
                    obj.createVoiceResourceCardTimes =
                      obj.createVoiceResourceCardTimes + 1;
                  }
                  if (textData.data.nodes[k].properties.radio == "fileList") {
                    obj.createFileResourceCardTimes = obj.createFileResourceCardTimes + 1;
                  }
                }
              }
            } else if (textData.type == "addEdge") {
              obj.createEdgeTimes = obj.createEdgeTimes + 1;
              obj.addEdges = obj.addEdges.concat(textData.data.nodes);
            }
          }
        }
        allData.push(obj);
      }
      let icfc_data = this.handle_re_arr(this.icfc_data);
      for (let i = 0; i < allData.length; i++) {
        for (let j = 0; j < allData[i].updateNodes.length; j++) {
          let updateData = allData[i].updateNodes[j];
          for (let m = 0; m < allData[i].addNodes.length; m++) {
            let addData = allData[i].addNodes[m];
            for (let a = 0; a < allData.length; a++) {
              if (a != i) {
                for (let n = 0; n < addData.length; n++) {
                  if (updateData.id == addData.id) {
                    allData[i].editOthersCardTimes = allData[i].editOthersCardTimes + 1;
                    break;
                  }
                }
              }
            }
          }
        }
      }
      for (let j = 0; j < that.selectStudentPageNum.length; j++) {
        if (that.selectStudentPageNum[j] == that.selectStudentPage) {
          if ((j + 1) * 4 <= userList.length) {
            for (let i = j * 4; i < (j + 1) * 4; i++) {
              that.selectStudentList.push(userList[i]);
              that.$nextTick(() => {
                for (let p = 0; p < allData.length; p++) {
                  if (allData[p].userId == userList[i].userid) {
                    // 个人图像
                    that.radarChartDomEcharts(allData[p], userList[i].userid);
                    // 资源贡献
                    that.resourceContributionChartDomEcharts(
                      allData[p],
                      userList[i].userid
                    );
                    // 个人概况
                    that.columnarChartDomEcharts(allData[p], userList[i].userid);
                    //个人创建频次
                    that.icfcDomEcharts(userList[i], icfc_data);
                    break;
                  }
                }
              });
            }
          } else {
            for (let i = j * 4; i < userList.length; i++) {
              that.selectStudentList.push(userList[i]);
              that.$nextTick(() => {
                // 资源贡献
                for (let p = 0; p < allData.length; p++) {
                  if (allData[p].userId == userList[i].userid) {
                    // 个人画像
                    that.radarChartDomEcharts(allData[p], userList[i].userid);
                    // 资源贡献
                    that.resourceContributionChartDomEcharts(
                      allData[p],
                      userList[i].userid
                    );
                    // 个人概况
                    that.columnarChartDomEcharts(allData[p], userList[i].userid);
                    //个人创建频次
                    that.icfcDomEcharts(userList[i], icfc_data);
                    break;
                  }
                }
              });
            }
          }
          break;
        }
      }
      that.$nextTick(() => {
        // 进度条+关闭弹框
        that.fake.end();
        document.getElementById("pane-student").style.height = "";
        that.personageLoading = false;
      });
    },
    // 个人图像
    radarChartDomEcharts(data, id) {
      let radarChartDom = document.getElementById("radar_" + id);
      let radarOption = {
        color: ["#56A3F1", "#FFE434", "#56A3F1", "#FF917C", "#FFE434", "#56A3F1"],
        title: [
          {
            text: "",
          },
        ],
        toolbox: {
          feature: {
            myFull: {
              // 全屏
              show: true,
              title: this.languageData.fullScreen,
              icon:
                "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
              onclick: () => {
                // 全屏查看
                if (radarChartDom.requestFullScreen) {
                  // HTML W3C 提议
                  radarChartDom.requestFullScreen();
                } else if (radarChartDom.msRequestFullscreen) {
                  // IE11
                  radarChartDom.msRequestFullScreen();
                } else if (radarChartDom.webkitRequestFullScreen) {
                  // Webkit
                  radarChartDom.webkitRequestFullScreen();
                } else if (radarChartDom.mozRequestFullScreen) {
                  // Firefox
                  radarChartDom.mozRequestFullScreen();
                }
                // 退出全屏
                if (radarChartDom.requestFullScreen) {
                  radarChartDom.exitFullscreen();
                } else if (radarChartDom.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (radarChartDom.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (radarChartDom.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        legend: {},
        radar: [
          {
            indicator: [
              { name: this.languageData.studentTip1 },
              { name: this.languageData.studentTip2 },
              { name: this.languageData.studentTip3 },
              { name: this.languageData.studentTip4 },
              { name: this.languageData.studentTip5 },
              { name: this.languageData.studentTip6 },
            ],
            axisName: {
              // formatter: '{value}',
              color: "#428BD4",
            },
            axisLine: {
              lineStyle: {
                color: "rgba(211, 253, 250, 0.8)",
              },
            },
            radius: 60,
          },
        ],
        series: [
          {
            type: "radar",
            emphasis: {
              lineStyle: {
                width: 2,
                color: "#56A3F1",
              },
            },
            data: [
              {
                value: [15, 80, 300, 4, 10, 20],
                name: "",
              },
            ],
          },
        ],
      };
      radarOption.series[0].data[0].value = [
        data.createCardTimes,
        data.createResourceCardTimes,
        data.editCardTotalTimes,
        data.speechesTimes,
        data.likesTimes,
        data.createEdgeTimes,
      ];
      let myRadarChart = echarts.getInstanceByDom(radarChartDom);
      if (!myRadarChart) {
        myRadarChart = echarts.init(radarChartDom, null, {
          renderer: "svg",
        });
      }
      // 图表自适应
      let radarChartListener = function () {
        myRadarChart.resize();
      };
      EleResize.on(radarChartDom, radarChartListener);
      radarOption && myRadarChart.setOption(radarOption);
    },
    // 资源贡献
    resourceContributionChartDomEcharts(data, id) {
      let resourceContributionChartDom = document.getElementById(
        "resource_contribution_" + id
      );
      let that = this;
      let resourceContributionOption = {
        toolbox: {
          feature: {
            myFull: {
              // 全屏
              show: true,
              title: that.languageData.fullScreen,
              icon:
                "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
              onclick: () => {
                // 全屏查看
                if (resourceContributionChartDom.requestFullScreen) {
                  // HTML W3C 提议
                  resourceContributionChartDom.requestFullScreen();
                } else if (resourceContributionChartDom.msRequestFullscreen) {
                  // IE11
                  resourceContributionChartDom.msRequestFullScreen();
                } else if (resourceContributionChartDom.webkitRequestFullScreen) {
                  // Webkit
                  resourceContributionChartDom.webkitRequestFullScreen();
                } else if (resourceContributionChartDom.mozRequestFullScreen) {
                  // Firefox
                  resourceContributionChartDom.mozRequestFullScreen();
                }
                // 退出全屏
                if (resourceContributionChartDom.requestFullScreen) {
                  resourceContributionChartDom.exitFullscreen();
                } else if (resourceContributionChartDom.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (resourceContributionChartDom.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (resourceContributionChartDom.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: [
            that.languageData.picture,
            "iframe",
            that.languageData.video,
            that.languageData.voice,
            that.languageData.file,
          ],
        },
        yAxis: {
          type: "value",
          name: that.languageData.studentTip8,
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            data: [
              data.createImageResourceCardTimes,
              data.createIframeResourceCardTimes,
              data.createVideoResourceCardTimes,
              data.createVoiceResourceCardTimes,
              data.createFileResourceCardTimes,
            ],
            type: "bar",
          },
        ],
      };
      let myResourceContributionChart = echarts.getInstanceByDom(
        resourceContributionChartDom
      );
      if (!myResourceContributionChart) {
        myResourceContributionChart = echarts.init(resourceContributionChartDom, null, {
          renderer: "svg",
        });
      }
      // 图表自适应
      let myResourceContributionChartListener = function () {
        myResourceContributionChart.resize();
      };
      EleResize.on(resourceContributionChartDom, myResourceContributionChartListener);
      resourceContributionOption &&
        myResourceContributionChart.setOption(resourceContributionOption);
    },
    // 行为概况
    columnarChartDomEcharts(data, id) {
      let columnarChartDom = document.getElementById("columnar_" + id);
      let columnarOption = {
        toolbox: {
          feature: {
            myFull: {
              // 全屏
              show: true,
              title: this.languageData.fullScreen,
              icon:
                "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
              onclick: () => {
                // 全屏查看
                if (columnarChartDom.requestFullScreen) {
                  // HTML W3C 提议
                  columnarChartDom.requestFullScreen();
                } else if (columnarChartDom.msRequestFullscreen) {
                  // IE11
                  columnarChartDom.msRequestFullScreen();
                } else if (columnarChartDom.webkitRequestFullScreen) {
                  // Webkit
                  columnarChartDom.webkitRequestFullScreen();
                } else if (columnarChartDom.mozRequestFullScreen) {
                  // Firefox
                  columnarChartDom.mozRequestFullScreen();
                }
                // 退出全屏
                if (columnarChartDom.requestFullScreen) {
                  columnarChartDom.exitFullscreen();
                } else if (columnarChartDom.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (columnarChartDom.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (columnarChartDom.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [
              this.languageData.studentTip1,
              this.languageData.studentTip2,
              this.languageData.studentTip3,
              this.languageData.studentTip6,
              this.languageData.studentTip7,
            ],
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              fontSize: 10,
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.languageData.times,
            axisLine: {
              show: true,
            },
          },
        ],
        series: [
          {
            name: this.languageData.times,
            type: "bar",
            barWidth: "60%",
            data: [
              data.createCardTimes,
              data.createResourceCardTimes,
              data.editCardTotalTimes,
              data.createEdgeTimes,
              data.editOthersCardTimes,
            ],
          },
        ],
      };
      let myColumnarChart = echarts.getInstanceByDom(columnarChartDom);
      if (!myColumnarChart) {
        myColumnarChart = echarts.init(columnarChartDom, null, {
          renderer: "svg",
        });
      }
      // 图表自适应
      let columnarChartListener = function () {
        myColumnarChart.resize();
      };
      EleResize.on(columnarChartDom, columnarChartListener);
      columnarOption && myColumnarChart.setOption(columnarOption);
    },
    //个人创建频次
    icfcDomEcharts(user, icfc_data) {
      let icfcDom = document.getElementById("icfc_" + user.userid);

      let icfc_data_series = [];
      icfc_data.forEach((item) => {
        if (item[3] == user.name) {
          icfc_data_series.push([item[0], item[1], item[2]]);
        }
      });
      const hours = [
        "0AM",
        "1AM",
        "2AM",
        "3AM",
        "4AM",
        "5AM",
        "6AM",
        "7AM",
        "8AM",
        "9AM",
        "10AM",
        "11AM",
        "12AM",
        "1PM",
        "2PM",
        "3PM",
        "4PM",
        "5PM",
        "6PM",
        "7PM",
        "8PM",
        "9PM",
        "10PM",
        "11PM",
      ];
      // prettier-ignore
      const days = [this.languageData.Sun,this.languageData.Sat,this.languageData.Fir,this.languageData.Thur,this.languageData.Wed,this.languageData.Tues,this.languageData.Mon,];
      const icfcOption = {
        tooltip: {
          position: "top",
        },
        grid: {
          left: "3%",
          height: "70%",
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: hours,
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: "category",
          data: days,
          splitArea: {
            show: true,
          },
        },
        visualMap: {
          min: 0,
          max: 10,
          calculable: true,
          show: false,
          orient: "horizontal",
          left: "center",
          bottom: "1%",
          inRange: {
            color: ["whiteSmoke", "#6f88d2"],
          },
        },
        dataZoom: [
          {
            type: "slider",
            startValue: 10,
            endValue: 20,
          },
        ],
        series: [
          {
            name: this.languageData.icfc,
            type: "heatmap",
            data: icfc_data_series,
            label: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      let myIcfcChart = echarts.getInstanceByDom(icfcDom);
      if (!myIcfcChart) {
        myIcfcChart = echarts.init(icfcDom);
      }
      // 个人创建频次，图表自适应
      let IcfcChartListener = function () {
        myIcfcChart.resize();
      };
      EleResize.on(icfcDom, IcfcChartListener);
      icfcOption && myIcfcChart.setOption(icfcOption);
    },
    /*
      数据分析-协作-处理数据
    */
    handleCollaborateData(data, userList, group) {
      let that = this;
      let allData = [];
      this.fake.start();
      this.groupLoading = true;
      that.selectStudentList = [];
      for (let j = 0; j < that.selectGroupPageNum.length; j++) {
        if (that.selectGroupPageNum[j] == that.selectGroupPage) {
          if ((j + 1) * 4 <= group.length) {
            for (let i = j * 4; i < (j + 1) * 4; i++) {
              let obj = group[i];
              obj.allName = group[i].group_member
                .map((x) => x.username)
                .join()
                .replaceAll(",", "、");
              that.selectStudentList.push(obj);
              allData.push({
                groupId: group[i].id,
                groupName: group[i].name,
                shareData: [],
              });
            }
          } else {
            for (let i = j * 4; i < group.length; i++) {
              let obj = group[i];
              obj.allName = group[i].group_member
                .map((x) => x.username)
                .join()
                .replaceAll(",", "、");
              that.selectStudentList.push(obj);
              allData.push({
                groupId: group[i].id,
                groupName: group[i].name,
                shareData: [],
              });
            }
          }
          for (let m = 0; m < userList.length; m++) {
            for (let k = 0; k < allData.length; k++) {
              if (userList[m].groupCid == allData[k].groupId) {
                allData[k].shareData.push({
                  id: userList[m].userid,
                  name: userList[m].name,
                  createCardTimes: 0,
                });
                break;
              }
            }
          }
          allData.forEach((item) => {
            item.shareData.unshift({
              id: that.group[0].creator.userid,
              name: that.group[0].creator.username,
              createCardTimes: 0,
            });
          });
          for (let m = 0; m < data.length; m++) {
            for (let n = 0; n < allData.length; n++) {
              for (let k = 0; k < allData[n].shareData.length; k++) {
                if (
                  allData[n].shareData[k].id == data[m].userid &&
                  JSON.parse(data[m].text).type == "addNode" &&
                  data[m].cid == allData[n].groupId
                ) {
                  allData[n].shareData[k].createCardTimes =
                    allData[n].shareData[k].createCardTimes + 1;
                  break;
                }
              }
            }
          }
          //创建者删除0的数据
          allData.forEach((item) => {
            if (item.shareData[0].createCardTimes == 0) {
              item.shareData.shift();
            }
          });
          console.log(allData);
        }
      }
      that.$nextTick(() => {
        for (let n = 0; n < allData.length; n++) {
          // 协作关系处理
          let grapArr = [];
          let addNodeList = [];
          let updateNodeList = [];
          let addEdgesList = [];
          let linksArr = [];
          let deleteNodeList = [];
          // let updateUserData = []
          // 资源类别处理
          let resourceClassObj = {
            img: 0,
            video: 0,
            content: 0,
            url: 0,
            doc: 0,
          };
          for (let i = 0; i < data.length; i++) {
            let addNodes = JSON.parse(data[i].text);
            let item = data[i];
            if (addNodes.type == "addNode") {
              let listObj = addNodeList.filter((i) => {
                return i.userid == item.userid;
              });
              if (listObj.length > 0) {
                addNodeList.map((x) => {
                  let xObj = x;
                  if (xObj.userid == listObj[0].userid) {
                    xObj.createArr = xObj.createArr.concat(addNodes.data.nodes);
                  }
                  return xObj;
                });
              } else {
                item.createArr = addNodes.data.nodes;
                addNodeList.push(item);
              }
            } else if (addNodes.type == "updateNode") {
              if (addNodes.data.nodes[0]?.properties) {
                if (allData[n].groupId == item.cid) {
                  let properties = addNodes.data.nodes[0].properties;
                  if (properties && properties.radio == "imageList") {
                    resourceClassObj.img++;
                  } else if (properties && properties.radio == "content") {
                    resourceClassObj.content++;
                  } else if (
                    (properties && properties.radio == "iframeUrl") ||
                    (properties && properties.radio == "embedCode")
                  ) {
                    resourceClassObj.url++;
                  } else if (
                    (properties && properties.radio == "videoList") ||
                    (properties && properties.radio == "audioList")
                  ) {
                    resourceClassObj.video++;
                  } else if (properties && properties.radio == "fileList") {
                    resourceClassObj.doc++;
                  }
                }
              }
              let listObj = updateNodeList.filter((i) => {
                return i.userid == item.userid;
              });
              if (listObj.length > 0) {
                updateNodeList.map((x) => {
                  let xObj = x;
                  if (xObj.userid == listObj[0].userid) {
                    xObj.updateNodes = xObj.updateNodes.concat(addNodes.data.nodes);
                  }
                  return xObj;
                });
              } else {
                item.updateedges = addNodes.data.edges;
                item.updateNodes = addNodes.data.nodes;
                updateNodeList.push(item);
              }
            } else if (addNodes.type == "addEdge") {
              let listObj = addEdgesList.filter((i) => {
                return i.userid == item.userid;
              });
              if (listObj.length > 0) {
                addEdgesList.map((x) => {
                  let xObj = x;
                  if (xObj.userid == listObj[0].userid) {
                    xObj.updateedges = xObj.updateedges.concat(addNodes.data.edges);
                  }
                  return xObj;
                });
              } else {
                item.updateedges = addNodes.data.edges;
                addEdgesList.push(item);
              }
            } else if (addNodes.type == "deleteNode") {
              let listObj = deleteNodeList.filter((i) => {
                return i.userid == item.userid;
              });
              if (listObj.length > 0) {
                deleteNodeList.map((x) => {
                  let xObj = x;
                  if (xObj.userid == listObj[0].userid) {
                    xObj.updateedges = xObj.updateedges.concat(addNodes.data.nodes);
                  }
                  return xObj;
                });
              } else {
                item.updateedges = addNodes.data.nodes;
                deleteNodeList.push(item);
              }
            }
          }
          let userObj = allData[n];
          for (let j = 0; j < userObj.shareData.length; j++) {
            let user = userObj.shareData[j];
            let nodeArr = [];
            let linesArr = [];
            let updateArr = [];
            let deleteArr = [];
            for (let m = 0; m < addNodeList.length; m++) {
              let nodesId = addNodeList[m].createArr.map((x) => x.id);
              if (addNodeList[m].userid == user.id) {
                nodeArr.push(nodesId);
              }
            }
            if (this.checkboxGroupValue == "edit" || this.checkboxGroupValue == "all") {
              for (let m = 0; m < updateNodeList.length; m++) {
                let nodesId = updateNodeList[m].updateNodes.map((x) => x.id);
                if (updateNodeList[m].userid == user.id) {
                  updateArr.push(nodesId);
                }
              }
            }

            if (
              this.checkboxGroupValue == "studentTip6" ||
              this.checkboxGroupValue == "all"
            ) {
              for (let m = 0; m < addEdgesList.length; m++) {
                let linesId = addEdgesList[m].updateedges.map((x) => x.sourceNodeId);
                if (addEdgesList[m].userid == user.id) {
                  linesArr.push(linesId);
                }
              }
            }

            if (
              this.checkboxGroupValue == "deleteGraps" ||
              this.checkboxGroupValue == "all"
            ) {
              for (let m = 0; m < deleteNodeList.length; m++) {
                let linesId = deleteNodeList[m].updateedges.map((x) => x.id);
                if (deleteNodeList[m].userid == user.id) {
                  deleteArr.push(linesId);
                }
              }
            }
            grapArr.push({
              id: user.id,
              name: user.name,
              // itemStyle:{color:userColor[n]},
              value: 0,
              symbolSize: 20,
              nodeArr: nodeArr.flat(),
              linesArr: linesArr.flat(),
              updateArr: updateArr.flat(),
              deleteArr: deleteArr.flat(),
            });
          }
          grapArr.length > 1 &&
            grapArr.forEach((item) => {
              if (item.nodeArr.length > 0) {
                item.nodeArr.forEach((id) => {
                  let widthNum = 0;
                  let updateUser = {};
                  grapArr.forEach((updateitem) => {
                    widthNum = 0;
                    if (item.id != updateitem.id) {
                      updateUser = updateitem;
                      widthNum = updateitem.updateArr.reduce((count, itemid) => {
                        if (itemid == id) {
                          count++;
                        }
                        return count;
                      }, widthNum);
                    }
                    if (widthNum > 0) {
                      let num = widthNum;
                      let b = {
                        // id: item.id,
                        source: updateUser.id,
                        // sourceName:item.name,
                        target: item.id,
                        lineStyle: {
                          width: num > 10 ? 10 : num + num / 100,
                          color: "#5772c3",
                          curveness: 0.05,
                        },
                      };
                      linksArr.push(b);
                    }
                  });
                  let linesNum = [];
                  for (let m = 0; m < addEdgesList.length; m++) {
                    addEdgesList[m].updateedges.map((x) => {
                      if (x.sourceNodeId == id) {
                        grapArr.length > 1 &&
                          grapArr.forEach((item) => {
                            if (item.nodeArr.length > 0) {
                              item.nodeArr.forEach((id) => {
                                if (x.targetNodeId == id) {
                                  linesNum.push(item.id);
                                }
                              });
                            }
                          });
                      }
                    });
                  }
                  // 卡片连线操作
                  if (linesNum.length > 0 && item.id != linesNum[0]) {
                    let num = linesNum.length;
                    let b = {
                      // id: item.id,
                      source: item.id,
                      sourceName: item.name,
                      target: linesNum[0],
                      lineStyle: {
                        width: num > 10 ? 10 : num + num / 100,
                        color: "#97cc7d",
                        curveness: 0.3,
                      },
                    };
                    linksArr.push(b);
                  }
                });
              }
            });
          grapArr.map((item) => {
            let num =
              item.symbolSize +
              item.nodeArr.length +
              item.linesArr.length +
              item.updateArr.length +
              item.deleteArr.length;
            item.symbolSize = num > 30 ? 30 + num / 100 : num;
            (item.label = {
              show: item.symbolSize > 20 ? true : false,
              position: "inside",
            }),
              (item.value = num > 20 ? num - 20 : 0);
            return item;
          });
          let heatData = [];
          let resultArr = [];
          for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 7; j++) {
              resultArr.push([i, j, 0]);
            }
          }
          for (let j = 0; j < data.length; j++) {
            //console.log("resultArr",new Date(data[j].create_at).getHours(),new Date(data[j].create_at).getDay())
            for (let i = 0; i < grapArr.length; i++) {
              if (data[j].userid == grapArr[i].id) {
                resultArr.map((x) => {
                  if (
                    x[0] == new Date(data[j].create_at).getHours() &&
                    x[1] == new Date(data[j].create_at).getDay()
                  ) {
                    x[2]++;
                  }
                  return x;
                });
              }
            }
          }
          // console.log(allData[n]);
          const result = {};
          // 计算每个元素的重复次数
          for (let i = 0; i < heatData.length; i++) {
            const element = heatData[i];
            if (result[element]) {
              result[element] += 1;
            } else {
              result[element] = 1;
            }
          }
          // updateUserData.map(x => {
          //   for (let d = 0; d < x.data.nodes.length; d++) {
          //     let a = x.data.nodes[d]
          //     if (a.properties && a.properties.radio == "imageList") {
          //       resourceClassObj.img = resourceClassObj.img + 1
          //     } else if (a.properties && a.properties.radio == "content") {
          //       resourceClassObj.content = resourceClassObj.content + 1
          //     } else if (a.properties && a.properties.radio == "iframeUrl" || a.properties && a.properties.radio == "embedCode") {
          //       resourceClassObj.url = resourceClassObj.url + 1
          //     } else if (a.properties && a.properties.radio == "videoList" || a.properties && a.properties.radio == "audioList") {
          //       resourceClassObj.url = resourceClassObj.url + 1
          //     } else if (a.properties && a.properties.radio == "fileList") {
          //       resourceClassObj.doc = resourceClassObj.doc + 1
          //     }
          //   }
          // })
          that.$nextTick(() => {
            //贡献度
            let pieShareGroupDom = document.getElementById(
              "pie_share_group_" + allData[n].groupId
            );
            let myChart = echarts.getInstanceByDom(pieShareGroupDom);
            if (!myChart) {
              myChart = echarts.init(pieShareGroupDom);
            }
            let option = {
              toolbox: {
                feature: {
                  myFull: {
                    // 全屏
                    show: true,
                    title: that.languageData.fullScreen,
                    icon:
                      "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
                    onclick: () => {
                      // 全屏查看
                      if (pieShareGroupDom.requestFullScreen) {
                        // HTML W3C 提议
                        pieShareGroupDom.requestFullScreen();
                      } else if (pieShareGroupDom.msRequestFullscreen) {
                        // IE11
                        pieShareGroupDom.msRequestFullScreen();
                      } else if (pieShareGroupDom.webkitRequestFullScreen) {
                        // Webkit
                        pieShareGroupDom.webkitRequestFullScreen();
                      } else if (pieShareGroupDom.mozRequestFullScreen) {
                        // Firefox
                        pieShareGroupDom.mozRequestFullScreen();
                      }
                      // 退出全屏
                      if (pieShareGroupDom.requestFullScreen) {
                        pieShareGroupDom.exitFullscreen();
                      } else if (pieShareGroupDom.msRequestFullScreen) {
                        document.msExitFullscreen();
                      } else if (pieShareGroupDom.webkitRequestFullScreen) {
                        document.webkitCancelFullScreen();
                      } else if (pieShareGroupDom.mozRequestFullScreen) {
                        document.mozCancelFullScreen();
                      }
                    },
                  },
                },
              },
              tooltip: {
                trigger: "item",
                formatter: "{b} : {c} ({d}%)",
              },
              legend: {
                top: "bottom",
              },
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: [40, 100],
                  center: ["50%", "50%"],
                  roseType: "area",
                  itemStyle: {
                    borderRadius: 8,
                  },
                  data: [],
                },
              ],
            };
            for (let m = 0; m < allData[n].shareData.length; m++) {
              option.series[0].data.push({
                value: allData[n].shareData[m].createCardTimes,
                name: allData[n].shareData[m].name,
              });
            }
            // 图表自适应
            let pieShareGroupChartListener = function () {
              myChart.resize();
            };
            EleResize.on(pieShareGroupDom, pieShareGroupChartListener);
            option && myChart.setOption(option);
            //删除创建者
            if (allData[n].shareData[0]?.id == that.group[0].creator.userid) {
              allData[n].shareData.shift();
            }
            let resourcerelationalGraphDom = document.getElementById(
              "relational_graph_" + allData[n].groupId
            );
            let resourcerelationalGraph = {
              title: {
                text: "",
                top: "bottom",
                left: "right",
              },
              toolbox: {
                feature: {
                  myFull: {
                    // 全屏
                    show: true,
                    title: that.languageData.fullScreen,
                    icon:
                      "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
                    onclick: () => {
                      // 全屏查看
                      if (resourcerelationalGraphDom.requestFullScreen) {
                        // HTML W3C 提议
                        resourcerelationalGraphDom.requestFullScreen();
                      } else if (resourcerelationalGraphDom.msRequestFullscreen) {
                        // IE11
                        resourcerelationalGraphDom.msRequestFullScreen();
                      } else if (resourcerelationalGraphDom.webkitRequestFullScreen) {
                        // Webkit
                        resourcerelationalGraphDom.webkitRequestFullScreen();
                      } else if (resourcerelationalGraphDom.mozRequestFullScreen) {
                        // Firefox
                        resourcerelationalGraphDom.mozRequestFullScreen();
                      }
                      // 退出全屏
                      if (resourcerelationalGraphDom.requestFullScreen) {
                        resourcerelationalGraphDom.exitFullscreen();
                      } else if (resourcerelationalGraphDom.msRequestFullScreen) {
                        document.msExitFullscreen();
                      } else if (resourcerelationalGraphDom.webkitRequestFullScreen) {
                        document.webkitCancelFullScreen();
                      } else if (resourcerelationalGraphDom.mozRequestFullScreen) {
                        document.mozCancelFullScreen();
                      }
                    },
                  },
                },
              },
              legend: {
                data: [that.languageData.edit_Card, that.languageData.studentTip6],
              },
              tooltip: {
                // formatter:"{b1}: {c1}"
              },
              series: [
                {
                  name: "",
                  type: "graph",
                  layout: "circular",
                  circular: {
                    rotateLabel: false,
                  },
                  edgeSymbol: ["circle", "arrow"],
                  data: grapArr,
                  links: linksArr,
                  categories: [
                    {
                      name: this.languageData.edit_Card,
                    },
                    {
                      name: this.languageData.studentTip6,
                    },
                  ],
                  lineStyle: {
                    opacity: 0.9,
                    width: 2,
                    curveness: 0,
                  },
                  padding: 30,
                },
              ],
            };
            let myResourceContributionChart = echarts.getInstanceByDom(
              resourcerelationalGraphDom
            );
            if (!myResourceContributionChart) {
              myResourceContributionChart = echarts.init(resourcerelationalGraphDom);
            }
            // 图表自适应
            let myResourceContributionChartListener = function () {
              myResourceContributionChart.resize();
            };
            EleResize.on(resourcerelationalGraphDom, myResourceContributionChartListener);
            resourcerelationalGraph &&
              myResourceContributionChart.setOption(resourcerelationalGraph);

            let resourcerelationalHearhDom = document.getElementById(
              "heat_" + allData[n].groupId
            );
            //活跃度热力图
            let resourcerelationalHear = {
              tooltip: {
                position: "top",
              },
              title: {
                text: "",
                top: "bottom",
                left: "right",
              },
              toolbox: {
                position: "top",
                feature: {
                  myFull: {
                    // 全屏
                    show: true,
                    title: that.languageData.fullScreen,
                    icon:
                      "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
                    onclick: () => {
                      // 全屏查看
                      if (resourcerelationalHearhDom.requestFullScreen) {
                        // HTML W3C 提议
                        resourcerelationalHearhDom.requestFullScreen();
                      } else if (resourcerelationalHearhDom.msRequestFullscreen) {
                        // IE11
                        resourcerelationalHearhDom.msRequestFullScreen();
                      } else if (resourcerelationalHearhDom.webkitRequestFullScreen) {
                        // Webkit
                        resourcerelationalHearhDom.webkitRequestFullScreen();
                      } else if (resourcerelationalHearhDom.mozRequestFullScreen) {
                        // Firefox
                        resourcerelationalHearhDom.mozRequestFullScreen();
                      }
                      // 退出全屏
                      if (resourcerelationalHearhDom.requestFullScreen) {
                        resourcerelationalHearhDom.exitFullscreen();
                      } else if (resourcerelationalHearhDom.msRequestFullScreen) {
                        document.msExitFullscreen();
                      } else if (resourcerelationalHearhDom.webkitRequestFullScreen) {
                        document.webkitCancelFullScreen();
                      } else if (resourcerelationalHearhDom.mozRequestFullScreen) {
                        document.mozCancelFullScreen();
                      }
                    },
                  },
                },
              },
              grid: {
                left: "3%",
                containLabel: true,
              },
              legend: {},
              xAxis: {
                type: "category",
                data: [
                  "0AM",
                  "1AM",
                  "2AM",
                  "3AM",
                  "4AM",
                  "5AM",
                  "6AM",
                  "7AM",
                  "8AM",
                  "9AM",
                  "10AM",
                  "11AM",
                  "12AM",
                  "1PM",
                  "2PM",
                  "3PM",
                  "4PM",
                  "5PM",
                  "6PM",
                  "7PM",
                  "8PM",
                  "9PM",
                  "10PM",
                  "11PM",
                ],
                splitArea: {
                  show: true,
                },
              },
              yAxis: {
                type: "category",
                data: [
                  this.languageData.Sun,
                  this.languageData.Sat,
                  this.languageData.Fir,
                  this.languageData.Thur,
                  this.languageData.Wed,
                  this.languageData.Tues,
                  this.languageData.Mon,
                ],
                splitArea: {
                  show: true,
                },
              },
              visualMap: {
                min: 0,
                max: 10,
                calculable: true,
                show: false,
                orient: "horizontal",
                left: "center",
                inRange: {
                  color: ["whiteSmoke", "#6f88d2"],
                },
              },
              dataZoom: [
                {
                  type: "slider",
                  startValue: 10,
                  endValue: 20,
                },
              ],
              series: [
                {
                  name: that.languageData.heatRelations,
                  type: "heatmap",
                  data: resultArr.map((x) => {
                    x[1] = Math.abs(x[1] == 0 ? 0 : x[1] - 7);
                    if (x[2] == 0) {
                      x[2] = "-";
                    }
                    return x;
                  }),
                  label: {
                    show: true,
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            };
            let myResourceContributionChartHear = echarts.getInstanceByDom(
              resourcerelationalHearhDom
            );
            if (!myResourceContributionChartHear) {
              myResourceContributionChartHear = echarts.init(resourcerelationalHearhDom);
            }
            // 图表自适应
            let myResourceContributionChartListenerHear = function () {
              myResourceContributionChartHear.resize();
            };
            EleResize.on(
              resourcerelationalHearhDom,
              myResourceContributionChartListenerHear
            );
            resourcerelationalHear &&
              myResourceContributionChartHear.setOption(resourcerelationalHear);
            that.resourceClass(resourceClassObj, allData[n].groupId);
            that.handle_character();
          });
        }
      });
      that.$nextTick(() => {
        that.fake.end();
        that.groupLoading = false;
      });
    },
    // 资源类别图
    resourceClass(data, id) {
      let resourceData = [];
      for (const key in data) {
        let obj = {
          name: key,
          value: data[key],
        };
        if (key == "img") {
          obj.name = this.languageData.image;
        } else if (key == "video") {
          obj.name = this.languageData.videoAndAudio;
        } else if (key == "content") {
          obj.name = this.languageData.content;
        } else if (key == "url") {
          obj.name = this.languageData.urlAndIframe;
        } else if (key == "doc") {
          obj.name = this.languageData.fileContent;
        }
        resourceData.push(obj);
      }
      //console.log("resourceData",resourceData)
      let resourceClassDom = document.getElementById("resource_class_group_" + id);
      //console.log("resourceClassDom",resourceClassDom)
      let myChart = echarts.getInstanceByDom(resourceClassDom);
      if (!myChart) {
        myChart = echarts.init(resourceClassDom);
      }
      let option = {
        tooltip: {
          trigger: "item",
          feature: {
            myFull: {
              // 全屏
              show: true,
              title: this.languageData.fullScreen,
              icon:
                "path://M641.750109 384.100028l205.227128-204.519-0.704035 115.89966c-0.282433 9.611915 7.489578 18.09103 17.101493 17.808598l12.297071 0c9.611915-0.283456 17.667382-5.936199 17.808598-15.689331l0.565888-172.57752c0-0.14224 0.282433-9.187243 0.282433-9.187243 0.14224-4.804423-0.99056-9.187243-4.100388-12.297071-3.109828-3.109828-7.347339-5.086855-12.297071-4.946662l-8.763594 0.14224c-0.141216 0-0.278339 0-0.420579 0.14224L697.581696 98.166787c-9.611915 0.283456-17.667382 8.200776-17.808598 17.950837l0 12.297071c1.416256 11.44875 10.458189 18.092054 20.070104 17.808598l112.789832 0.283456-204.66124 203.814965c-9.329483 9.329483-9.329483 24.449855 0 33.778314 9.329483 9.470699 24.452925 9.470699 33.782408 0L641.750109 384.100028zM383.095141 576.889893 177.726797 780.705881l0.707105-115.338888c0.283456-9.607822-7.492648-18.086937-17.104563-17.808598l-13.001105 0c-9.611915 0.283456-17.667382 5.937223-17.808598 15.690354l-0.565888 172.718737c0 0.14224-0.282433 9.187243-0.282433 9.187243-0.14224 4.808516 0.99056 9.187243 4.096295 12.297071 3.109828 3.109828 7.351432 5.086855 12.297071 4.946662l8.762571-0.14224c0.14224 0 0.283456 0 0.425695-0.14224l171.873486 0.708128c9.607822-0.283456 17.667382-8.196683 17.808598-17.950837L344.93503 832.575226c-1.415232-11.44875-10.461259-18.092054-20.074198-17.808598L212.069977 814.483172 416.59 610.671277c9.329483-9.329483 9.329483-24.453948 0-33.782408C407.40685 567.41817 392.424624 567.41817 383.095141 576.889893L383.095141 576.889893zM894.047276 835.967486l-0.424672-172.718737c-0.283456-9.612938-8.200776-15.406898-17.809621-15.690354l-12.296047 0c-9.612938-0.278339-17.243733 8.200776-17.105586 17.808598l0.708128 115.903753L641.750109 576.889893c-9.329483-9.329483-24.452925-9.329483-33.782408 0-9.325389 9.328459-9.325389 24.452925 0 33.782408L812.490795 814.483172l-112.789832 0.283456c-9.611915-0.283456-18.515702 6.502088-20.073174 17.808598l0 12.297071c0.282433 9.611915 8.200776 17.667382 17.808598 17.950837l171.166381-0.708128c0.141216 0 0.282433 0.14224 0.424672 0.14224l8.763594 0.14224c4.803399 0.141216 9.187243-1.694595 12.296047-4.946662 3.109828-3.109828 4.238534-7.488555 4.097318-12.297071 0 0-0.14224-9.046027-0.14224-9.187243L894.047276 835.968509zM212.216309 146.506748l112.789832-0.283456c9.607822 0.283456 18.512632-6.502088 20.070104-17.808598L345.076246 116.116601c-0.283456-9.611915-8.196683-17.667382-17.808598-17.950837l-172.011632 0.708128c-0.14224 0-0.283456-0.14224-0.425695-0.14224l-8.761548-0.14224c-4.808516-0.141216-9.187243 1.694595-12.297071 4.946662-3.109828 3.109828-4.242627 7.488555-4.096295 12.297071 0 0 0.282433 9.046027 0.282433 9.187243l0.420579 172.718737c0.14224 9.608845 8.200776 15.406898 17.808598 15.686261l13.005198 0c9.611915 0.282433 17.242709-8.196683 17.10047-17.808598l-0.564865-115.334795 205.231221 203.958228c9.324366 9.329483 24.448832 9.329483 33.777291 0 9.329483-9.329483 9.329483-24.452925 0-33.782408L212.216309 146.506748 212.216309 146.506748zM212.216309 146.506748",
              onclick: () => {
                // 全屏查看
                if (resourceClassDom.requestFullScreen) {
                  // HTML W3C 提议
                  resourceClassDom.requestFullScreen();
                } else if (resourceClassDom.msRequestFullscreen) {
                  // IE11
                  resourceClassDom.msRequestFullScreen();
                } else if (resourceClassDom.webkitRequestFullScreen) {
                  // Webkit
                  resourceClassDom.webkitRequestFullScreen();
                } else if (resourceClassDom.mozRequestFullScreen) {
                  // Firefox
                  resourceClassDom.mozRequestFullScreen();
                }
                // 退出全屏
                if (resourceClassDom.requestFullScreen) {
                  resourceClassDom.exitFullscreen();
                } else if (resourceClassDom.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (resourceClassDom.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (resourceClassDom.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            },
          },
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: resourceData,
          },
        ],
      };
      // 图表自适应
      let resourceClassGroupChartListener = function () {
        myChart.resize();
      };
      EleResize.on(resourceClassDom, resourceClassGroupChartListener);
      option && myChart.setOption(option);
    },
    //角色标签
    handle_character() {
      this.selectStudentList.forEach((group) => {
        const group_member_lenght = group.group_member;
        // const [tip48,tip49,tip50,tip51,tip52,tip53,tip54,tip55,tip56,tip57,tip58,tip59]=[[],[],[],[],[],[],[],[],[],[],[],[]];
        let [
          tip48,
          tip49,
          tip50,
          tip51,
          tip52,
          tip53,
          tip54,
          tip55,
          tip56,
          tip57,
          tip58,
          tip59,
        ] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        group.character.forEach((character) => {
          if (character.name.includes(this.language.tip48)) {
            tip48++;
          }
          if (character.name.includes(this.language.tip49)) {
            tip49++;
          }
          if (character.name.includes(this.language.tip50)) {
            tip50++;
          }
          if (character.name.includes(this.language.tip51)) {
            tip51++;
          }
          if (character.name.includes(this.language.tip52)) {
            tip52++;
          }
          if (character.name.includes(this.language.tip53)) {
            tip53++;
          }
          if (character.name.includes(this.language.tip54)) {
            tip54++;
          }
          if (character.name.includes(this.language.tip55)) {
            tip55++;
          }
          if (character.name.includes(this.language.tip56)) {
            tip56++;
          }
          if (character.name.includes(this.language.tip57)) {
            tip57++;
          }
          if (character.name.includes(this.language.tip58)) {
            tip58++;
          }
          if (character.name.includes(this.language.tip59)) {
            tip59++;
          }
        });
        // console.log(tip52);
        const chartDom = document.getElementById("character_" + group.id);
        let myChart = echarts.getInstanceByDom(chartDom);
        if (!myChart) {
          myChart = echarts.init(chartDom);
        }
        let option;
        option = {
          title: {
            text: group.name,
          },
          tooltip: {
            show: true,
            position: "inside",
          },
          // legend: {
          //   data: [this.language.character],
          // },
          radar: {
            // shape: 'circle',
            indicator: [
              { name: this.language.tip48, max: group_member_lenght },
              { name: this.language.tip49, max: group_member_lenght },
              { name: this.language.tip50, max: group_member_lenght },
              { name: this.language.tip51, max: group_member_lenght },
              { name: this.language.tip52, max: group_member_lenght },
              { name: this.language.tip53, max: group_member_lenght },
              { name: this.language.tip54, max: group_member_lenght },
              { name: this.language.tip55, max: group_member_lenght },
              { name: this.language.tip56, max: group_member_lenght },
              { name: this.language.tip57, max: group_member_lenght },
              { name: this.language.tip58, max: group_member_lenght },
              { name: this.language.tip59, max: group_member_lenght },
            ],
          },
          series: [
            {
              type: "radar",
              tooltip: {
                trigger: "item",
              },
              areaStyle: {},
              data: [
                {
                  value: [
                    tip48,
                    tip49,
                    tip50,
                    tip51,
                    tip52,
                    tip53,
                    tip54,
                    tip55,
                    tip56,
                    tip57,
                    tip58,
                    tip59,
                  ],
                  name: this.language.character,
                },
              ],
            },
          ],
        };
        option && myChart.setOption(option);
      });
    },
    /*
      数据分析-切换tab
    */
    handleClick(tab) {
      let that = this;
      this.select_group_value = null;
      this.select_personage_value = null;
      if (that.IncreasingTrenTime) {
        clearInterval(that.IncreasingTrenTime);
      }
      if (tab.paneName == "student") {
        that.selectStudentPage = "第1页";
        that.get_Operation(tab.paneName);
      }
      if (tab.paneName == "collaborate") {
        that.selectStudentPage = "第1页";
        that.get_Operation(tab.paneName);
      } else if (tab.paneName == "achievement") {
        that.get_Operation(tab.paneName);
      } else if (tab.paneName == "all") {
        that.init_result_map();
      }
    },
    getNewDataAll(data) {
      this.newDataAll = data;
    },
    getClassName(val) {
      this.className = val;
    },
    getGroup(val) {
      this.active_group_id = val;
    },
    close_mygroup(value) {
      this.is_mygroup = !value;
    },
    getcscl(id, loadingInstance) {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "getcscl",
              id,
              "d7300d31-8cf6-38dc-e295-2c71622b4df1",
              "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
            ].join(",")
          : "mode=" +
            [
              "getcscl",
              id,
              window.parent.US.pageId,
              window.parent.US.userInfo.userid,
            ].join(",");
      this.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then((res) => {
          let data = {};
          localStorage.setItem("user", JSON.stringify(res.data[0][0].user));
          that.$store.commit("set_group_member_active", []);
          that.$store.commit("set_group_member_active", res.data[0][0].user);
          try {
            data = JSON.parse(res.data[0][0].data);
          } catch {
            data = res.data[0][0].data;
          }
          if (data.nodes == null) {
            let id = uuidv4();
            data = {
              nodes: [
                {
                  id: id,
                  type: "icon-theme",
                  x: 355,
                  y: 350,
                  properties: {
                    isShowDelete: false,
                    id: id,
                    type: "icon-theme",
                    topic: that.theme != "" ? that.theme : "起始",
                  },
                  zIndex: 1002,
                },
              ],
              edges: [],
              backgroundUrl: bg,
            };
            // localStorage.setItem("data", JSON.stringify({ "nodes": [{ "id": "9f6d7459-d376-4c0c-944b-a6b140085903", "type": "icon-start", "x": 625, "y": 145, "properties": {}, "text": { "x": 405, "y": 180, "value": "起始" }, "zIndex": 1002 }], "edges": [], "backgroundUrl": "img/bg.ccee1c62.png" }))
            let mindinfo = {
              "us.cscl": [
                {
                  sendId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                      : window.parent.US.userInfo.userid, //发送人id
                  receiveId: id, //文件id
                  pageId:
                    window.location.href.indexOf("localhost") != -1 ||
                    window.location.href.indexOf("192.168") != -1
                      ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                      : window.parent.US.pageId,
                  type: "update", //消息类型
                  messageInfo: {
                    nodes: data.nodes,
                    edges: [],
                    backgroundUrl: bg,
                    userName:
                      window.location.href.indexOf("localhost") != -1 ||
                      window.location.href.indexOf("192.168") != -1
                        ? "潘炜桐"
                        : window.parent.US.userInfo.username,
                    userId:
                      window.location.href.indexOf("localhost") != -1 ||
                      window.location.href.indexOf("192.168") != -1
                        ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                        : window.parent.US.userInfo.userid,
                    roomId: id,
                  },
                },
              ],
            };
            let params =
              "mode=" +
              [
                "send",
                encodeURIComponent(encodeURIComponent(JSON.stringify(mindinfo))),
              ].join(",");
            this.$ajax
              .post("https://poll.cocorobo.cn", params)
              .then(() => {
                //console.log(res);
              })
              .catch((err) => {
                console.error(err);
                loadingInstance.close();
                that.$message({
                  message: err,
                  type: "error",
                });
              });
            // localStorage.setItem("data", JSON.stringify(data))
            // localStorage.setItem("background", data.backgroundUrl)
          } else {
            let nodes = data.nodes;
            let edges = data.edges;
            let newNodes = [];
            let newEdges = [];
            for (let i = 0; i < nodes.length; i++) {
              if (nodes[i] !== null && typeof nodes[i] === "object") {
                newNodes.push(nodes[i]);
              }
            }
            for (let i = 0; i < edges.length; i++) {
              if (edges[i] !== null && typeof edges[i] === "object") {
                newEdges.push(edges[i]);
              }
            }
            data.nodes = newNodes;
            data.edges = newEdges;
            // localStorage.setItem("data", JSON.stringify(data))
            // localStorage.setItem("background", data.backgroundUrl)
          }
          let offlineDeleteData = JSON.parse(localStorage.getItem("offlineDeleteData"));
          this.sendUpdate(offlineDeleteData.nodes, offlineDeleteData.edges, "delete", 0);
          if (offlineDeleteData.nodes.length != 0) {
            for (let i = 0; i < offlineDeleteData.nodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (data.nodes[j].id == offlineDeleteData.nodes[i].id) {
                  data.nodes.splice(j, 1);
                  break;
                }
              }
            }
          }
          if (offlineDeleteData.edges.length != 0) {
            for (let i = 0; i < offlineDeleteData.edges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (data.edges[j].id == offlineDeleteData.edges[i].id) {
                  data.edges.splice(j, 1);
                  break;
                }
              }
            }
          }
          let offlineUpdateData = JSON.parse(localStorage.getItem("offlineUpdateData"));
          this.sendUpdate(offlineUpdateData.nodes, offlineUpdateData.edges, "update", 0);
          if (offlineUpdateData.nodes.length != 0) {
            let index = [];
            for (let i = 0; i < offlineUpdateData.nodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (data.nodes[j].id == offlineUpdateData.nodes[i].id) {
                  data.nodes[j] = offlineUpdateData.nodes[i];
                  index.push(i);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < offlineUpdateData.nodes.length; j++) {
                data.nodes.push(offlineUpdateData.nodes[j]);
              }
            } else {
              for (let j = 0; j < offlineUpdateData.nodes.length; j++) {
                for (let i = 0; i < index.length; i++) {
                  if (j != i) {
                    data.nodes.push(offlineUpdateData.nodes[j]);
                  }
                }
              }
            }
          }
          if (offlineUpdateData.edges.length != 0) {
            let index = [];
            for (let i = 0; i < offlineUpdateData.edges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (data.edges[j].id == offlineUpdateData.edges[i].id) {
                  data.edges[j] = offlineUpdateData.edges[i];
                  index.push(i);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < offlineUpdateData.edges.length; j++) {
                data.edges.push(offlineUpdateData.edges[j]);
              }
            } else {
              for (let j = 0; j < offlineUpdateData.edges.length; j++) {
                for (let i = 0; i < index.length; i++) {
                  if (j != i) {
                    data.edges.push(offlineUpdateData.edges[j]);
                  }
                }
              }
            }
          }
          // localStorage.setItem("data", JSON.stringify(data))
          localStorage.setItem("background", data.backgroundUrl);
          that.isAutomatic = false;
          let nodeIds = [];
          for (let i = 0; i < data.nodes.length; i++) {
            nodeIds.push(data.nodes[i].id);
          }
          let edges = [];
          for (let i = 0; i < data.edges.length; i++) {
            if (
              nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 &&
              nodeIds.indexOf(data.edges[i].targetNodeId) != -1
            ) {
              edges.push(data.edges[i]);
            }
          }
          data.edges = edges;
          that.lf.graphModel.graphDataToModel(data);
          that.initLogicFlow(data);
          // that.lf.options.grid = data.backgroundUrl != "" ? false : true
          // that.lf.options.background = {
          //   backgroundImage: 'url(' + data.backgroundUrl + ')',
          //   backgroundRepeat: 'no-repeat',
          //   backgroundSize: 'cover',
          //   backgroundColor: '#F2F2F2'
          // };
          // that.lf.graphModel.partial = false
          // that.lf.render(that.lf.getGraphData())
          // that.lf.graphModel.partial = true
          that.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        })
        .catch((err) => {
          console.error(err);
          that.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    handle_chat_room_switch(value) {
      let that = this;
      value ? (this.chat_room_switch = false) : (this.chat_room_switch = true);
      if (!value) {
        this.$nextTick(() => {
          that.$refs.chatroom.init_badge_number_copy();
        });
      }
      // if (this.chatroom_message_swich_child) {
      //   this.chatroom_message_swich = !value;
      // }
    },
    handle_badge_number(number, swich) {
      this.badge_number = number;
      if (number == 0) {
        this.chatroom_message_swich = true;
      } else {
        this.chatroom_message_swich = false;
      }
      this.chatroom_message_swich_child = swich;
    },
    p_card(id) {
      this.lf.focusOn({
        id: id,
      });
    },
    handleClose() {
      this.newTab = !this.newTab;
      this.isBackgroundNew = false;
      this.isBackground = true;
    },
    handleCloseNew() {
      this.newTab = !this.newTab;
      this.isBackground = false;
    },
    handleMapClose() {
      this.showMapDialogVisible = false;
      this.showList = [];
    },
    handleCameraClose() {
      this.showCameraDialog = false;
      this.showList = [];
    },
    focusClose() {
      this.hoverClose = true;
    },
    blurClose() {
      this.hoverClose = false;
    },
    handleSendClose() {
      this.sendRadio = [];
      this.checkAll = false;
      this.isIndeterminate = true;
      this.showSendDialogVisible = false;
    },
    /*
      分发卡片
    */
    selectGroup() {
      let that = this;
      let oldData = {};
      if (that.sendRadio.length != 0) {
        let loadingInstance = Loading.service({ fullscreen: true });
        let sendData = [];
        for (let i = 0; i < that.sendRadio.length; i++) {
          let params =
            window.location.href.indexOf("localhost") != -1 ||
            window.location.href.indexOf("192.168") != -1
              ? "mode=" +
                [
                  "getcscldata",
                  that.sendRadio[i],
                  "d7300d31-8cf6-38dc-e295-2c71622b4df1",
                  "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
                ].join(",")
              : "mode=" +
                [
                  "getcscldata",
                  that.sendRadio[i],
                  window.parent.US.pageId,
                  window.parent.US.userInfo.userid,
                ].join(",");
          that.$ajax.post("https://poll.cocorobo.cn", params).then((res) => {
            let data = {};
            try {
              data = JSON.parse(res.data[0][0].data);
            } catch {
              data = res.data[0][0].data;
            }
            let background = data.backgroundUrl;
            oldData.nodes = that.sendNodes;
            oldData.edges = that.sendEdges;
            oldData.backgroundUrl = background;
            let newData = replaceAllCardId(oldData);
            let newDataAll = newData;
            if (data.nodes && data.nodes.length != 0) {
              let max_node = find_max_x(data.nodes);
              let min_node = find_min_x(newDataAll.nodes);
              let min_node_x = min_node.x;
              let replace_x = max_node.x + 132.5;
              let a = 232.5;
              if (min_node.properties.nodeSize && min_node.properties.nodeSize.width) {
                a = min_node.properties.nodeSize.width / 2;
              }
              // else if (min_node.properties.width) {
              //   a = min_node.properties.width / 2
              // }
              newDataAll = replace_all_x(newDataAll, replace_x, min_node_x, a);
            }
            sendData.push({
              sendId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                  : window.parent.US.userInfo.userid, //发送人id
              receiveId: that.sendRadio[i], //文件id
              pageId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                  : window.parent.US.pageId,
              type: "update", //消息类型
              messageInfo: {
                nodes: newDataAll.nodes,
                edges: newDataAll.edges,
                backgroundUrl: newDataAll.backgroundUrl,
                userName:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "潘炜桐"
                    : window.parent.US.userInfo.username,
                userId:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                    : window.parent.US.userInfo.userid,
              },
            });
            if (i == that.sendRadio.length - 1) {
              console.log(sendData);
              let mindinfo = {
                "us.cscl": sendData,
              };
              let sendParams =
                "mode=" +
                [
                  "send",
                  encodeURIComponent(encodeURIComponent(JSON.stringify(mindinfo))),
                ].join(",");
              that.$ajax
                .post("https://poll.cocorobo.cn", sendParams)
                .then(() => {
                  //console.log(res);
                  that.$nextTick(() => {
                    // 以服务的方式调用的 Loading 需要异步关闭
                    loadingInstance.close();
                  });
                  that.$message({
                    type: "success",
                    message: that.languageData.sendSuccess,
                  });
                  that.sendRadio = [];
                  that.checkAll = false;
                  that.isIndeterminate = true;
                  that.showSendDialogVisible = false;
                })
                .catch((err) => {
                  console.error(err);
                });
            }
          });
        }
      } else {
        that.$message({
          type: "warning",
          message: that.languageData.notSend,
        });
      }
    },
    changeLinetype(val) {
      this.linetype = val;
    },
    top_menu_icon_mouseover() {
      this.top_menu = !this.top_menu;
    },
    top_menu_mouseover() {
      this.top_menu = false;
      clearTimeout(localStorage.top_menu);
    },
    top_menu_mouseleave() {
      localStorage.top_menu = setTimeout(() => {
        if (this.isFullscreen) {
          this.top_menu = !this.top_menu;
        }
      }, 3000);
    },
    user_group_mouseover() {
      this.user_group_flag = !this.user_group_flag;
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //2,再将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date(); // 文件最后的修改日期
      theBlob.name = fileName; // 文件名
      return new File([theBlob], fileName, {
        type: theBlob.type,
        lastModified: Date.now(),
      });
    },
    uploadImage(fileParams, loadingInstance) {
      // console.log(fileParams.file)
      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      if (fileParams) {
        var params = {
          Key: fileParams.name,
          ContentType: fileParams.type,
          Body: fileParams,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket.upload(params, options).send(function (err, data) {
          if (err) {
            console.log(err);
          } else {
            _this.newTab = !_this.newTab;
            _this.isAnalyse = false;
            _this.isBackgroundNew = false;
            _this.isBackground = false;
            _this.newBackground = data.Location;
            localStorage.setItem("background", _this.newBackground);
            let newData = {};
            // newData.backgroundUrl = _this.newBackground
            if (localStorage.getItem("data")) {
              const d = localStorage.getItem("data");
              if (d) {
                newData = JSON.parse(d);
                newData.backgroundUrl = _this.newBackground;
              }
            }
            // _this.initLogicFlow(newData)
            // _this.isAutomatic = false
            // _this.lf.graphModel.graphDataToModel(newData)
            // _this.lf.options.grid = _this.newBackground != "" ? false : true
            // _this.lf.options.background = {
            //   backgroundImage: 'url(' + _this.newBackground + ')',
            //   backgroundRepeat: 'no-repeat',
            //   backgroundSize: 'cover',
            //   backgroundColor: '#F2F2F2'
            // };
            // _this.lf.graphModel.partial = false
            // _this.lf.render(_this.lf.getGraphData())
            // _this.lf.graphModel.partial = true
            _this.initLogicFlow(newData);
            // _this.lf.graphModel.partial = true
            _this.sendUpdate([], [], "update", 0);
            _this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          }
        });
      }
    },
    doFilter() {
      const _all_nodes = this.$refs.seeksRelationGraph.getInstance().getNodes();
      const _all_links = this.$refs.seeksRelationGraph.getInstance().getLinks();
      _all_nodes.forEach((thisNode) => {
        let _isHideThisLine = false;
        if (this.checked_isParticipate !== "") {
          if (
            thisNode.data["isParticipate"] !== this.checked_isParticipate &&
            thisNode.data["type"] == "task"
          ) {
            _isHideThisLine = true;
          }
        }
        thisNode.opacity = _isHideThisLine ? 0 : 1;
      });
      _all_links.forEach((thisLink) => {
        // thisLink.relations.forEach(thisLine => {
        //   if (this.rel_checkList.indexOf(thisLine.data['type']) === -1) {
        //     if (!thisLine.isHide) {
        //       thisLine.isHide = true;
        //       console.log('Hide line:', thisLine);
        //     }
        //   } else {
        //     if (thisLine.isHide) {
        //       thisLine.isHide = false;
        //       console.log('Show line:', thisLine);
        //     }
        //   }
        // });
        // thisNode.opacity = _isShowThisNode ? 1 : 0.1
        thisLink.relations.forEach((thisLine) => {
          let _isHideThisLine = true;
          if (this.checked_isParticipate !== "") {
            if (
              thisLine.data["isParticipate"] !== this.checked_isParticipate &&
              thisLine.data["type"] == "task"
            ) {
              _isHideThisLine = false;
            }
          }
          thisLine.isHide = _isHideThisLine ? false : true;
        });
      });
      this.$refs.seeksRelationGraph.getInstance().dataUpdated();
    },
    getSectionNodesAndEdges(node,lf,newNodes,newEdges) {
      let newNode = lf.getNodeModelById(node.id);
      if(newNode.isGroup) {
        const nodeIds = newNode.children
        nodeIds.forEach(item => {
          let model = lf.getNodeModelById(item);
          newNodes.push(model.getData())
          let outgoingEdgeModel = lf.getNodeOutgoingEdge(model.getData().id);
          if (outgoingEdgeModel.length != 0) {
            for (let i = 0; i < outgoingEdgeModel.length; i++) {
              let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
              newEdges.push(edge.getData());
            }
          }
          let incomingEdgeModel = lf.getNodeIncomingEdge(model.getData().id);
          if (incomingEdgeModel.length != 0) {
            for (let i = 0; i < incomingEdgeModel.length; i++) {
              let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
              newEdges.push(edge.getData());
            }
          }
        })
      }
      return newNodes,newEdges
    },
    initLogicFlow(data) {
      const that = this;
      // 引入框选插件
      LogicFlow.use(SelectionSelect);
      LogicFlow.use(Snapshot);
      LogicFlow.use(DynamicGroup);
      LogicFlow.use(DndPanel);
      LogicFlow.use(BpmnElement);
      LogicFlow.use(MiniMap);
      LogicFlow.use(Menu);
      LogicFlow.use(Dagre);
      LogicFlow.use(SelectDagre);
      // LogicFlow.use(ProximityConnect);
      // LogicFlow.use(Highlight);
      const backGround = data.backgroundUrl;
      this.backgroundImage = backGround;
      const lf = new LogicFlow({
        container: this.$refs.diagram,
        overlapMode: 1,
        autoExpand: false,
        allowResize: true,
        metaKeyMultipleSelected: true,
        pluginsOptions: {
          MiniMap: {
            showEdge: false,
            isShowHeader: false,
            isShowCloseIcon: false,
            leftPosition: "83%",
            topPosition: "7%",
            rightPosition: undefined,
            bottomPosition: undefined,
            headerTitle: this.languageData.minimap,
          },
          // proximityConnect:{
          //   reverseDirection: false
          // }
        },
        keyboard: {
          enabled: true,
          shortcuts:
            that.group.length > 0
              ? [
                  {
                    keys: ["Backspace", "Delete"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      lf.clearSelectElements();
                      if (
                        elements.nodes.length != 0 &&
                        elements.edges.length == 0 &&
                        this.isKeyBoardDelete
                      ) {
                        // console.log(1)
                        that
                          .$confirm(that.languageData.tip18, that.languageData.tip2, {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          })
                          .then(() => {
                            let newNodes = [];
                            let newEdges = [];
                            elements.nodes.forEach((node) => {
                              that.isDeleteNode = true;
                              newNodes.push(node);
                              newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                              let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                              if (outgoingEdgeModel.length != 0) {
                                for (let i = 0; i < outgoingEdgeModel.length; i++) {
                                  let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                                  newEdges.push(edge.getData());
                                }
                              }
                              let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                              if (incomingEdgeModel.length != 0) {
                                for (let i = 0; i < incomingEdgeModel.length; i++) {
                                  let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                                  newEdges.push(edge.getData());
                                }
                              }
                              lf.deleteNode(node.id);
                              that.isDeleteNode = false;
                            });
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          })
                          .catch(() => {
                            // this.$message({
                            //   type: 'info',
                            //   message: '已取消删除'
                            // });
                          });
                      }
                      if (
                        elements.edges.length != 0 &&
                        elements.nodes.length == 0 &&
                        this.isKeyBoardDelete
                      ) {
                        elements.edges.forEach((edge) => {
                          that.isResizeNode = false;
                          that.isDeleteNode = false;
                          lf.deleteEdge(edge.id);
                        });
                        that.sendUpdate([], elements.edges, "delete", 0);
                        let newData = {
                          nodes: [],
                          edges: elements.edges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteEdge");
                      }
                      if (
                        elements.edges.length != 0 &&
                        elements.nodes.length != 0 &&
                        this.isKeyBoardDelete
                      ) {
                        that
                          .$confirm(that.languageData.tip18, that.languageData.tip2, {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          })
                          .then(() => {
                            let newNodes = [];
                            let newEdges = [];
                            that.isDeleteNode = true;
                            if (elements.nodes.length != 0) {
                              elements.nodes.forEach((node) => {
                                newNodes.push(node);
                                newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                                lf.deleteNode(node.id);
                              });
                            }
                            if (elements.edges.length != 0) {
                              elements.edges.forEach((edge) => {
                                newEdges.push(edge);
                                lf.deleteEdge(edge.id);
                              });
                            }
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            that.isDeleteNode = false;
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          })
                          .catch(() => {
                            // this.$message({
                            //   type: 'info',
                            //   message: '已取消删除'
                            // });
                          });
                      }
                    },
                  },
                  {
                    keys: ["Ctrl+Shift+]", "Cmd+Shift+]"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        lf.setElementZIndex(node.id, "top");
                        let nodeModel = lf.getNodeModelById(node.id);
                        let data = nodeModel.getData();
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+Shift+[", "Cmd+Shift+["],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        lf.setElementZIndex(node.id, "bottom");
                        let nodeModel = lf.getNodeModelById(node.id);
                        let data = nodeModel.getData();
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+X", "Cmd+X"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        let nodeModel = lf.getNodeModelById(node.id);
                        nodeModel.setZIndex(nodeModel.zIndex + 1);
                        let data = nodeModel.getData();
                        data.zIndex = nodeModel.zIndex + 1;
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+B", "Cmd+B"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        let nodeModel = lf.getNodeModelById(node.id);
                        nodeModel.setZIndex(nodeModel.zIndex - 1);
                        let data = nodeModel.getData();
                        data.zIndex = nodeModel.zIndex - 1;
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+V", "Cmd+V"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        that.isAutomatic = true;
                        lf.cloneNode(node.id);
                        let { nodes } = that.lf.getSelectElements();
                        lf.setElementZIndex(nodes[0].id, "top");
                        that.isAutomatic = false;
                      });
                      lf.clearSelectElements();
                      that.activeNodes = [];
                    },
                  },
                  {
                    keys: ["Right"],
                    callback: () => {
                      if (that.isProjection) {
                        that.$_next_projection();
                      }
                    },
                  },
                  {
                    keys: ["Left"],
                    callback: () => {
                      if (that.isProjection) {
                        that.$_previous_projection();
                      }
                    },
                  },
                  {
                    keys: ["Ctrl+Q", "Cmd+Q"],
                    callback: () => {
                      const elements = lf.getSelectElements(false);
                      lf.clearSelectElements();
                      that.sendNodes = [];
                      that.sendEdges = [];
                      let nodeIds = [];
                      if (elements.nodes.length != 0) {
                        that.isDeleteNode = true;
                        elements.nodes.forEach((node) => {
                          that.sendNodes.push(node);
                          nodeIds.push(node.id);
                          that.sendNodes,that.sendEdges = that.getSectionNodesAndEdges(node,lf,that.sendNodes,that.sendEdges)
                        });
                      }
                      if (elements.edges.length != 0) {
                        elements.edges.forEach((edge) => {
                          if (
                            nodeIds.indexOf(edge.sourceNodeId) != -1 &&
                            nodeIds.indexOf(edge.targetNodeId) != -1
                          ) {
                            that.sendEdges.push(edge);
                          }
                        });
                      }
                      that.showSendDialogVisible = true;
                    },
                  },
                  {
                    keys: ["Ctrl+M", "Cmd+M"],
                    callback() {
                      lf.extension.dagre &&
                        lf.extension.dagre.layout({
                          nodesep: 20,
                          ranksep: 20,
                        });
                    },
                  },
                ]
              : [
                  {
                    keys: ["Backspace", "Delete"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      lf.clearSelectElements();
                      if (
                        elements.nodes.length != 0 &&
                        elements.edges.length == 0 &&
                        this.isKeyBoardDelete
                      ) {
                        // console.log(1)
                        that
                          .$confirm(that.languageData.tip18, that.languageData.tip2, {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          })
                          .then(() => {
                            let newNodes = [];
                            let newEdges = [];
                            elements.nodes.forEach((node) => {
                              that.isDeleteNode = true;
                              newNodes.push(node);
                              newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                              let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                              if (outgoingEdgeModel.length != 0) {
                                for (let i = 0; i < outgoingEdgeModel.length; i++) {
                                  let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                                  newEdges.push(edge.getData());
                                }
                              }
                              let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                              if (incomingEdgeModel.length != 0) {
                                for (let i = 0; i < incomingEdgeModel.length; i++) {
                                  let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                                  newEdges.push(edge.getData());
                                }
                              }
                              lf.deleteNode(node.id);
                              that.isDeleteNode = false;
                            });
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          })
                          .catch(() => {
                            // this.$message({
                            //   type: 'info',
                            //   message: '已取消删除'
                            // });
                          });
                      }
                      if (
                        elements.edges.length != 0 &&
                        elements.nodes.length == 0 &&
                        this.isKeyBoardDelete
                      ) {
                        elements.edges.forEach((edge) => {
                          that.isResizeNode = false;
                          that.isDeleteNode = false;
                          lf.deleteEdge(edge.id);
                        });
                        that.sendUpdate([], elements.edges, "delete", 0);
                        let newData = {
                          nodes: [],
                          edges: elements.edges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteEdge");
                      }
                      if (
                        elements.edges.length != 0 &&
                        elements.nodes.length != 0 &&
                        this.isKeyBoardDelete
                      ) {
                        that
                          .$confirm(that.languageData.tip18, that.languageData.tip2, {
                            confirmButtonText: that.languageData.confirm,
                            cancelButtonText: that.languageData.cancel,
                            type: "warning",
                          })
                          .then(() => {
                            let newNodes = [];
                            let newEdges = [];
                            that.isDeleteNode = true;
                            if (elements.nodes.length != 0) {
                              elements.nodes.forEach((node) => {
                                newNodes.push(node);
                                newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                                lf.deleteNode(node.id);
                              });
                            }
                            if (elements.edges.length != 0) {
                              elements.edges.forEach((edge) => {
                                newEdges.push(edge);
                                lf.deleteEdge(edge.id);
                              });
                            }
                            that.sendUpdate(newNodes, newEdges, "delete", 0);
                            that.isDeleteNode = false;
                            let newData = {
                              nodes: newNodes,
                              edges: newEdges,
                              backgroundUrl: localStorage.getItem("background"),
                            };
                            that.add_Operation(newData, "deleteNode");
                          })
                          .catch(() => {
                            // this.$message({
                            //   type: 'info',
                            //   message: '已取消删除'
                            // });
                          });
                      }
                    },
                  },
                  {
                    keys: ["Ctrl+Shift+]", "Cmd+Shift+]"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        lf.setElementZIndex(node.id, "top");
                        let nodeModel = lf.getNodeModelById(node.id);
                        let data = nodeModel.getData();
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+Shift+[", "Cmd+Shift+["],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        lf.setElementZIndex(node.id, "bottom");
                        let nodeModel = lf.getNodeModelById(node.id);
                        let data = nodeModel.getData();
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+X", "Cmd+X"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        let nodeModel = lf.getNodeModelById(node.id);
                        nodeModel.setZIndex(nodeModel.zIndex + 1);
                        let data = nodeModel.getData();
                        data.zIndex = nodeModel.zIndex + 1;
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+B", "Cmd+B"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let newNodes = [];
                      let newEdges = [];
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        let nodeModel = lf.getNodeModelById(node.id);
                        nodeModel.setZIndex(nodeModel.zIndex - 1);
                        let data = nodeModel.getData();
                        data.zIndex = nodeModel.zIndex - 1;
                        newNodes.push(data);
                      });
                      that.sendUpdate(newNodes, newEdges, "update", 0);
                      // let newData = {
                      //   "nodes": newNodes,
                      //   "edges": [],
                      //   "backgroundUrl": localStorage.getItem("background")
                      // }
                      // that.add_Operation(newData, "updateNodeLevel")
                    },
                  },
                  {
                    keys: ["Ctrl+V", "Cmd+V"],
                    callback: () => {
                      const elements = lf.getSelectElements(true);
                      let is_exist_group = elements.nodes.filter((item) => {
                        return item.type == 'my-group';
                      });
                      if(is_exist_group.length != 0) {
                        that.$message({
                          type: 'warning',
                          message: that.languageData.warnTip
                        });
                        return
                      }
                      elements.nodes.forEach((node) => {
                        that.isAutomatic = true;
                        lf.cloneNode(node.id);
                        let { nodes } = that.lf.getSelectElements();
                        lf.setElementZIndex(nodes[0].id, "top");
                        that.isAutomatic = false;
                      });
                    },
                  },
                  {
                    keys: ["Right"],
                    callback: () => {
                      if (that.isProjection) {
                        that.$_next_projection();
                      }
                    },
                  },
                  {
                    keys: ["Left"],
                    callback: () => {
                      if (that.isProjection) {
                        that.$_previous_projection();
                      }
                    },
                  },
                  {
                    keys: ["Ctrl+M", "Cmd+M"],
                    callback() {
                      lf.extension.dagre &&
                        lf.extension.dagre.layout({
                          nodesep: 20,
                          ranksep: 20,
                        });
                    },
                  },
                ],
        },
        grid: {
          visible: backGround != "" ? false : true,
          size: 20,
          type: "dot",
          config: {
            color: "#ababab",
            thickness: 1,
          },
        },
        // grid: backGround != "" ? false : true,
        partial: true,
        // background: {
        //   backgroundImage: 'url(' + backGround + ')',
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'cover',
        //   backgroundColor: backGround != "" ? '#F2F2F2' : '#FFFFFF'
        // },
        isSilentMode: that.isSilentMode,
        adjustEdgeStartAndEnd: true,
      });
      lf.setTheme({
        baseEdge: { strokeWidth: 1 },
        baseNode: { strokeWidth: 1 },
        nodeText: { overflowMode: "autoWrap", lineHeight: 1.5 },
        edgeText: { overflowMode: "autoWrap", lineHeight: 1.5 },
        // outline: {
        //   fill: "transparent",
        //   stroke: "#007BFF",
        //   strokeDasharray: "3,3",
        //   strokeWidth: 2,
        //   hover: {
        //     stroke: "#007BFF",
        //     strokeWidth: 2,
        //   },
        // }
      });

      // 设置右键菜单
      that.setMenuConfig(lf);
      // 注册自定义元素
      registerCustomElement(lf);
      lf.setDefaultEdgeType("pro-line");

      // let nodeIds = []
      // for (let i = 0; i < data.nodes.length; i++) {
      //   nodeIds.push(data.nodes[i].id)
      // }
      // let edges = []
      // for (let i = 0; i < data.edges.length; i++) {
      //   if (nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 && nodeIds.indexOf(data.edges[i].targetNodeId) != -1) {
      //     edges.push(data.edges[i])
      //   }
      // }
      // data.edges = edges

      try {
        this.isExistError = false;
        lf.render(data);
      } catch {
        this.$message({
          duration: 0,
          showClose: true,
          offset: 40,
          type: "warning",
          message: this.languageData.errorTip,
        });
        this.isExistError = true;
        lf.render(data);
      }

      if (data.nodes && data.nodes.length != 0) {
        let sprites = data.nodes;
        initState(backGround, sprites);
      }

      // for(let i = 0;i < data.nodes.length;i++) {
      //   if(data.nodes[i].type == "icon-theme") {
      //     const { transformModel } = lf.graphModel;
      //     // this.lf.focusOn({
      //     //   id: data.nodes[i].id,
      //     //   // coordinate: {
      //     //   //   x: Math.round(data.nodes[i].x),
      //     //   //   y: Math.round(data.nodes[i].y),
      //     //   // }
      //     // });
      //     transformModel.focusOn(Math.round(data.nodes[i].x),Math.round(data.nodes[i].y),Math.round(window.screen.width), Math.round(window.screen.height))
      //     break
      //   }
      // }

      if (data.edges && data.edges.length != 0) {
        let newEdges = [];
        for (let i = 0; i < data.edges.length; i++) {
          if (data.edges[i].type.indexOf("pro-dashed") != -1) {
            if (data.edges[i].type == "pro-dashed-bezier") {
              lf.graphModel.changeEdgeType(data.edges[i].id, "pro-bezier");
              data.edges[i].type = "pro-bezier";
              newEdges.push(data.edges[i]);
            }
            if (data.edges[i].type == "pro-dashed-curved") {
              lf.graphModel.changeEdgeType(data.edges[i].id, "pro-curved");
              data.edges[i].type = "pro-curved";
              newEdges.push(data.edges[i]);
            }
            if (data.edges[i].type == "pro-dashed-line") {
              lf.graphModel.changeEdgeType(data.edges[i].id, "pro-line");
              data.edges[i].type = "pro-line";
              newEdges.push(data.edges[i]);
            }
            if (data.edges[i].type == "pro-dashed-polyline") {
              lf.graphModel.changeEdgeType(data.edges[i].id, "pro-polyline");
              data.edges[i].type = "pro-polyline";
              newEdges.push(data.edges[i]);
            }
          }
        }
        if (newEdges.length != 0) {
          this.sendUpdate([], newEdges, "update", 0);
        }
      }

      for (let i = 0; i < data.nodes.length; i++) {
        lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
          isShowDelete: false,
        });
      }

      lf.clearSelectElements();
      lf.setZoomMiniSize(0.2);
      lf.setZoomMaxSize(20);

      lf.extension.snapshot.useGlobalRules = false;
      lf.extension.snapshot.customCssRules = `
        .lf-node-text-auto-wrap-content{
          line-height: 1.2;
          background: transparent;
          text-align: center;
          word-break: break-all;
          width: 100%;
        }
        .lf-canvas-overlay {
          background: #ffffff;
        }
        .uml-wrapper {
          background: #FFFFFF;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          box-sizing: border-box;
          position: relative;
          box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 10px 0px rgba(0, 0, 0, 0.05);
          /* box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 10px 1px; */
          /* filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.12)) drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.08)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.05)); */
        }
        .is_show_user {
          display: flex;
          flex-direction: row;
          height: 27px;
          line-height: 27px;
        }
        .el-icon-circle-close {
          font-family: element-icons!important;
          speak: none;
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
          vertical-align: baseline;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        .closeImgTheme {
          font-size: 20px;
          position: absolute;
          top: 3px;
          right: 3px;
          cursor: pointer;
          color: #000000;
        }
        .uml-select-body {
          /* border-top: 1px solid #838382; */
          /* border-bottom: 1px solid #838382; */
          padding: 0px 20px 5px 20px;
          font-size: 14px;
          font-family: SimSun;
          font-weight: bold;
          text-align: center;
          /* font-family: "Microsoft YaHei"; */
          word-break: break-all;
          text-overflow: ellipsis;
          /* display: -webkit-box; */
          /* -webkit-box-orient: vertical; */
          /* -webkit-line-clamp: 5; */
          overflow: hidden;
          word-wrap: break-word;
          height: 70%;
        }
        .el-input {
          position: relative;
          font-size: 14px;
          display: inline-block;
        }
        .uml-head {
          text-align: center;
          line-height: 30px;
          font-size: 16px;
          font-weight: 700;
          font-family: SimSun;
          color: #fff;
          border-top-left-radius: 7px;
          border-top-right-radius: 7px;
        }
      `;

      // lf.extension.miniMap.setOption({
      //   showEdge: false,
      //   isShowHeader: false,
      //   isShowCloseIcon: false,
      //   leftPosition: "83%",
      //   topPosition: "7%",
      //   rightPosition: undefined,
      //   bottomPosition: undefined,
      //   headerTitle: this.languageData.minimap,
      // })

      this.lf = lf;
      window.lf = lf;
      // this.$nextTick(() => {
      //   const d = this.lf.getGraphData()
      //   let _this = this;
      //   for (let i = 0; i < d.nodes.length; i++) {
      //     if (d.nodes[i].type == "my-group") {
      //       $("#fold_" + d.nodes[i].id).on("click", function (e) {
      //         e.stopPropagation();
      //         const groupModel = lf.getNodeModelById(d.nodes[i].id);
      //         groupModel.foldGroup(!groupModel.isFolded);
      //         _this.$_setStyle({
      //           isAlFolded: !groupModel.isFolded
      //         })
      //       })
      //     }
      //   }
      // })
      // 监听选中选区,点击节点,点击画布
      this.lf.on("selection:selected,node:click,blank:click", ({ e }) => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { nodes, edges } = this.lf.getSelectElements();
            console.log(nodes, edges);
            this.isKeyBoardDelete = true;
            if (nodes.length != 0) {
              // this.$set(this, 'activeNodes', nodes)
              this.activeEdges = [];
              this.activeNodes = [];
              // this.$_getProperty()
              localStorage.setItem("type", nodes[0].type);
              let data = this.lf.getGraphData();
              for (let i = 0; i < data.nodes.length; i++) {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  isShowDelete: false,
                });
              }
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: true,
                currentUserName: this.user.userName
              });
            }
            // if (this.activeNodes.length != 0) {
            //   localStorage.setItem("type", this.activeNodes[0].type);
            //   // const edgeData = this.lf.graphModel.getNodeIncomingEdge(this.activeNodes[0].id)
            //   // let arr = [];
            //   // for (let i = 0; i < edgeData.length; i++) {
            //   //   arr.push({ "id": edgeData[i].sourceNodeId, "route": edgeData[i].properties.route })
            //   // }
            //   // localStorage.setItem("edges", JSON.stringify(arr))
            //   let data = this.lf.getGraphData()
            //   for (let i = 0; i < data.nodes.length; i++) {
            //     this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
            //       isShowDelete: false
            //     });
            //   }
            //   this.lf.graphModel.getNodeModelById(this.activeNodes[0].id).setProperties({
            //     isShowDelete: true
            //   });
            //   // if (this.activeNodes[0].properties.width && this.activeNodes[0].properties.height) {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //     width: this.activeNodes[0].properties.width,
            //   //     height: this.activeNodes[0].properties.height
            //   //   })
            //   // }
            //   // if (this.activeNodes[0].properties.nodeSize && this.activeNodes[0].properties.nodeSize.width && this.activeNodes[0].properties.nodeSize.height) {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //     width: this.activeNodes[0].properties.nodeSize.width,
            //   //     height: this.activeNodes[0].properties.nodeSize.height
            //   //   })
            //   // }
            //   // else {
            //   //   this.$_setStyle({
            //   //     id: this.activeNodes[0].id,
            //   //     type: this.activeNodes[0].type,
            //   //   })
            //   // }
            //   // this.iconList = this.activeNodes[0].properties.iconList
            //   // this.imageList = this.activeNodes[0].properties.imageList
            //   // this.videoList = this.activeNodes[0].properties.videoList
            //   // this.audioList = this.activeNodes[0].properties.audioList
            //   // this.fileList = this.activeNodes[0].properties.fileList
            // }
            else {
              if (this.newDataAll.nodes != null) {
                this.$confirm(this.languageData.tip24, this.languageData.tip2, {
                  confirmButtonText: this.languageData.confirm,
                  cancelButtonText: this.languageData.cancel,
                  type: "warning",
                })
                  .then(() => {
                    let x = e.clientX;
                    let y = e.clientY;
                    let position = this.lf.graphModel.getPointByClient({
                      x,
                      y,
                    });
                    //console.log(position.canvasOverlayPosition)
                    let data = this.lf.getGraphData();
                    let newDataAll = this.newDataAll;
                    if (data.nodes && data.nodes.length != 0) {
                      let max_node_old = find_max_x(data.nodes);
                      let min_node_old = find_min_x(data.nodes);
                      if (position.canvasOverlayPosition.x >= max_node_old.x + 132.5) {
                        let min_node = find_min_x(newDataAll.nodes);
                        let min_node_x = min_node.x;
                        let replace_x = parseInt(position.canvasOverlayPosition.x);
                        let a = 132.5;
                        if (
                          min_node.properties.nodeSize &&
                          min_node.properties.nodeSize.width
                        ) {
                          a = min_node.properties.nodeSize.width / 2;
                        }
                        // else if (min_node.properties.width) {
                        //   a = min_node.properties.width / 2
                        // }
                        newDataAll = replace_all_x(newDataAll, replace_x, min_node_x, a);
                      } else if (
                        position.canvasOverlayPosition.x <=
                        min_node_old.x - 132.5
                      ) {
                        let max_node = find_max_x(newDataAll.nodes);
                        let max_node_x = max_node.x;
                        let replace_x = parseInt(position.canvasOverlayPosition.x);
                        let a = 132.5;
                        if (
                          max_node.properties.nodeSize &&
                          max_node.properties.nodeSize.width
                        ) {
                          a = max_node.properties.nodeSize.width / 2;
                        }
                        // else if (max_node.properties.width) {
                        //   a = max_node.properties.width / 2
                        // }
                        newDataAll = replace_all_x(newDataAll, replace_x, max_node_x, a);
                      } else if (
                        min_node_old.x - 132.5 <
                        position.canvasOverlayPosition.x <
                        max_node_old.x + 132.5
                      ) {
                        let max_node = find_max_y(newDataAll.nodes);
                        let max_node_y = max_node.y + 132.5;
                        let min_node = find_min_y(data.nodes);
                        let min_node_y = min_node.y - 132.5;
                        let replace_y = min_node_y;
                        let a = 132.5;
                        if (
                          max_node.properties.nodeSize &&
                          max_node.properties.nodeSize.height
                        ) {
                          a = max_node.properties.nodeSize.height / 2;
                        }
                        newDataAll = replace_all_y(newDataAll, replace_y, max_node_y, a);
                      }
                    }
                    let nodes = newDataAll.nodes;
                    let edges = newDataAll.edges;
                    let focusNode = nodes[0];
                    for (let i = 0; i < nodes.length; i++) {
                      if (nodes[i].type == "icon-theme") {
                        focusNode = nodes[i];
                      }
                      data.nodes.push(nodes[i]);
                      // that.lf.graphModel.addNode(res.data.nodes[i]);
                    }
                    for (let i = 0; i < edges.length; i++) {
                      edges[i].zIndex = 1;
                      data.edges.push(edges[i]);
                      // that.lf.graphModel.addEdge(res.data.edges[i]);
                    }
                    data.backgroundUrl = newDataAll.backgroundUrl;
                    localStorage.setItem("background", newDataAll.backgroundUrl);
                    // this.lf.addElements({
                    //   "nodes": nodes,
                    //   "edges": edges
                    // })
                    this.lf.graphModel.graphDataToModel(data);
                    // this.lf.options.grid = data.backgroundUrl != "" ? false : true
                    // this.lf.options.background = {
                    //   backgroundImage: 'url(' + data.backgroundUrl + ')',
                    //   backgroundRepeat: 'no-repeat',
                    //   backgroundSize: 'cover',
                    //   backgroundColor: '#F2F2F2'
                    // };
                    console.log(data);
                    let newData = {
                      nodes: nodes,
                      edges: edges,
                      backgroundUrl: data.backgroundUrl,
                    };
                    // this.lf.graphModel.partial = false
                    // this.lf.render(this.lf.getGraphData())
                    // this.lf.graphModel.partial = true
                    this.initLogicFlow(data);
                    this.sendUpdate(newData.nodes, newData.edges, "update", 0);
                    this.add_Operation(newData, "addNode");
                    // that.$parent.lf.extension.dagre && that.$parent.lf.extension.dagre.layout({
                    //   nodesep: 20,
                    //   ranksep: 20,
                    // });
                    this.lf.focusOn({
                      id: focusNode.id,
                    });
                    this.newDataAll = {};
                    $(".lf-drag-able").removeClass(this.className);
                  })
                  .catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: '已取消删除'
                    // });
                    this.newDataAll = {};
                    $(".lf-drag-able").removeClass(this.className);
                  });
              }
              this.isPromptsList = false;
              if (this.isJobReception) {
                this.isHidden = true;
              }
              this.lf.clearSelectElements();
              this.activeEdges = edges;
              this.activeNodes = nodes;
              let data = this.lf.getGraphData();
              for (let i = 0; i < data.nodes.length; i++) {
                // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
                //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                //     width: data.nodes[i].properties.width,
                //     height: data.nodes[i].properties.height,
                //     isShowDelete: false
                //   });
                // }
                if (
                  data.nodes[i].properties.nodeSize &&
                  data.nodes[i].properties.nodeSize.width &&
                  data.nodes[i].properties.nodeSize.height
                ) {
                  this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                    width: data.nodes[i].properties.nodeSize.width,
                    height: data.nodes[i].properties.nodeSize.height,
                    isShowDelete: false,
                  });
                } else {
                  this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                    isShowDelete: false,
                  });
                }
                if (
                  data.nodes[i].type == "icon-theme" ||
                  (data.nodes[i].type == "icon-stage" &&
                    !data.nodes[i].properties.stageContent) ||
                  (data.nodes[i].type == "icon-stage" &&
                    data.nodes[i].properties.stageContent &&
                    data.nodes[i].properties.stageContent == "<p></p>") ||
                  (data.nodes[i].type == "icon-task" &&
                    !data.nodes[i].properties.taskContent) ||
                  (data.nodes[i].type == "icon-task" &&
                    data.nodes[i].properties.taskContent &&
                    data.nodes[i].properties.taskContent == "<p></p>") ||
                  (data.nodes[i].type == "icon-homework" &&
                    !data.nodes[i].properties.homeworkContent) ||
                  (data.nodes[i].type == "icon-homework" &&
                    data.nodes[i].properties.homeworkContent &&
                    data.nodes[i].properties.homeworkContent == "<p></p>")
                ) {
                  // $("#input_" + data.nodes[i].id).attr("disabled", true)
                  $("#text_" + data.nodes[i].id).css("display", "block");
                  $("#input_" + data.nodes[i].id).css("display", "none");
                }
              }
              this.isHidden = true;
              this.isShowGroup = false;
              // this.chat_room_switch = false;
            }
          } else {
            this.lf.clearSelectElements();
            let data = this.lf.getGraphData();
            for (let i = 0; i < data.nodes.length; i++) {
              // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
              //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
              //     width: data.nodes[i].properties.width,
              //     height: data.nodes[i].properties.height,
              //     isShowDelete: false
              //   });
              // }
              if (
                data.nodes[i].properties.nodeSize &&
                data.nodes[i].properties.nodeSize.width &&
                data.nodes[i].properties.nodeSize.height
              ) {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  width: data.nodes[i].properties.nodeSize.width,
                  height: data.nodes[i].properties.nodeSize.height,
                  isShowDelete: false,
                });
              } else {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  isShowDelete: false,
                });
              }
            }
          }
        });
      });

      // 监听右键节点
      this.lf.on("node:contextmenu", ({ data, position, e }) => {
        const {
          domOverlayPosition: { x, y },
        } = position;
        const { id } = data;
        const model = this.lf.graphModel.getNodeModelById(id);
        if (!model) return;
        // console.log(data);
        let nodeMenuList =
          that.group.length > 0
            ? [
                {
                  text: that.languageData.Backspace,
                  callback(node) {
                    // console.log(2)
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        that.isDeleteNode = true;
                        let newNodes = [];
                        let newEdges = [];
                        newNodes.push(node);
                        newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                        let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                        if (outgoingEdgeModel.length != 0) {
                          for (let i = 0; i < outgoingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                        if (incomingEdgeModel.length != 0) {
                          for (let i = 0; i < incomingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        that.sendUpdate(newNodes, newEdges, "delete", 0);
                        lf.deleteNode(node.id);
                        that.isDeleteNode = false;
                        let newData = {
                          nodes: newNodes,
                          edges: newEdges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteNode");
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
                {
                  text: that.languageData.clone,
                  callback(node) {
                    that.isAutomatic = true;
                    lf.cloneNode(node.id);
                    const { nodes } = that.lf.getSelectElements();
                    lf.setElementZIndex(nodes[0].id, "top");
                    that.isAutomatic = false;
                    that.lf.clearSelectElements();
                    that.activeNodes = [];
                  },
                },
                {
                  text: that.languageData.distribute_cards,
                  callback(node) {
                    that.sendNodes = [];
                    that.sendNodes.push(node);
                    that.sendEdges = [];
                    that.sendNodes,that.sendEdges = that.getSectionNodesAndEdges(node,lf,that.sendNodes,that.sendEdges)
                    that.showSendDialogVisible = true;
                  },
                },
                {
                  text: that.languageData.top,
                  callback(node) {
                    lf.setElementZIndex(node.id, "top");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.bottom,
                  callback(node) {
                    lf.setElementZIndex(node.id, "bottom");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.forward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex + 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex + 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.backward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex - 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex - 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
              ]
            : [
                {
                  text: that.languageData.Backspace,
                  callback(node) {
                    // console.log(2)
                    that
                      .$confirm(that.languageData.tip18, that.languageData.tip2, {
                        confirmButtonText: that.languageData.confirm,
                        cancelButtonText: that.languageData.cancel,
                        type: "warning",
                      })
                      .then(() => {
                        that.isDeleteNode = true;
                        let newNodes = [];
                        let newEdges = [];
                        newNodes.push(node);
                        newNodes,newEdges = that.getSectionNodesAndEdges(node,lf,newNodes,newEdges)
                        let outgoingEdgeModel = lf.getNodeOutgoingEdge(node.id);
                        if (outgoingEdgeModel.length != 0) {
                          for (let i = 0; i < outgoingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        let incomingEdgeModel = lf.getNodeIncomingEdge(node.id);
                        if (incomingEdgeModel.length != 0) {
                          for (let i = 0; i < incomingEdgeModel.length; i++) {
                            let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                            newEdges.push(edge.getData());
                          }
                        }
                        that.sendUpdate(newNodes, newEdges, "delete", 0);
                        lf.deleteNode(node.id);
                        that.isDeleteNode = false;
                        let newData = {
                          nodes: newNodes,
                          edges: newEdges,
                          backgroundUrl: localStorage.getItem("background"),
                        };
                        that.add_Operation(newData, "deleteNode");
                      })
                      .catch(() => {
                        // this.$message({
                        //   type: 'info',
                        //   message: '已取消删除'
                        // });
                      });
                  },
                },
                {
                  text: that.languageData.clone,
                  callback(node) {
                    that.isAutomatic = true;
                    lf.cloneNode(node.id);
                    const { nodes } = that.lf.getSelectElements();
                    lf.setElementZIndex(nodes[0].id, "top");
                    that.isAutomatic = false;
                    that.lf.clearSelectElements();
                    that.activeNodes = [];
                  },
                },
                {
                  text: that.languageData.top,
                  callback(node) {
                    lf.setElementZIndex(node.id, "top");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.bottom,
                  callback(node) {
                    lf.setElementZIndex(node.id, "bottom");
                    let nodeModel = lf.getNodeModelById(node.id);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.forward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex + 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex + 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
                {
                  text: that.languageData.backward,
                  callback(node) {
                    let nodeModel = lf.getNodeModelById(node.id);
                    nodeModel.setZIndex(nodeModel.zIndex - 1);
                    let data = nodeModel.getData();
                    let newNodes = [];
                    let newEdges = [];
                    data.zIndex = nodeModel.zIndex - 1;
                    newNodes.push(data);
                    that.sendUpdate(newNodes, newEdges, "update", 0);
                    // let newData = {
                    //   "nodes": newNodes,
                    //   "edges": [],
                    //   "backgroundUrl": localStorage.getItem("background")
                    // }
                    // that.add_Operation(newData, "updateNodeLevel")
                  },
                },
              ];
        if (data.type == "icon-theme") {
          nodeMenuList.push({
            text: that.languageData.geneTask,
            callback(node) {
              let loadingInstance = Loading.service({
                fullscreen: true,
                text: that.languageData.geneTasktext,
              });
              that.geneTask(node.properties.topic, node.id, loadingInstance);
            },
          });
        }
        if (data.type == "icon-task") {
          nodeMenuList.push({
            text: that.languageData.geneResourse,
            callback(node) {
              let loadingInstance = Loading.service({
                fullscreen: true,
                text: that.languageData.geneResoursetext,
              });
              that.geneResourse(
                node.properties.taskTitle,
                node.properties.taskContent,
                node.id,
                loadingInstance
              );
            },
          });
        }
        if (data.type == "my-group") {
          nodeMenuList.splice(1,1)
          nodeMenuList.push({
            text: data.properties.isCollapsed == true ? "展开分区" : "收缩分区",
            callback(node) {
              const groupModel = lf.getNodeModelById(node.id);
              groupModel.toggleCollapse(!node.properties.isCollapsed);
              node.properties.isCollapsed = !node.properties.isCollapsed
              that.sendUpdate([node],[],"update",0)
              let newData = {
                nodes: [node],
                edges: [],
                backgroundUrl: localStorage.getItem("background"),
              };
              that.add_Operation(newData, "updateNode");
            },
          });
          for(let i = 0;i < 4;i++) {
            nodeMenuList.splice(nodeMenuList.length-2,1)
          }
        }
        that.lf.extension.menu.showMenu(x, y, nodeMenuList, {
          width: model.width,
          height: model.height,
          clientX: e.clientX,
          clientY: e.clientY,
        });
      });

      // 监听右键连线
      this.lf.on("edge:contextmenu", ({ data, position, e }) => {
        const {
          domOverlayPosition: { x, y },
        } = position;
        const { id } = data;
        const model = this.lf.graphModel.getEdgeModelById(id);
        if (!model) return;
        let menuList = !this.lf.getEditConfig().isSilentMode
          ? [
              {
                text: that.languageData.delete,
                callback(edge) {
                  that.isResizeNode = false;
                  that.isDeleteNode = false;
                  lf.deleteEdge(edge.id);
                  let newEdge = [];
                  newEdge.push(edge);
                  that.sendUpdate([], newEdge, "delete", 0);
                  let newData = {
                    nodes: [],
                    edges: newEdge,
                    backgroundUrl: localStorage.getItem("background"),
                  };
                  that.add_Operation(newData, "deleteEdge");
                },
              },
            ]
          : [];
        this.lf.extension.menu.showMenu(x, y, menuList, {
          width: model.width,
          height: model.height,
          clientX: e.clientX,
          clientY: e.clientY,
        });
      });

      // 监听移动选区
      this.lf.on("selection:drop", () => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { nodes, edges } = this.lf.getSelectElements();
            this.sendUpdate(nodes, edges, "update", 0);
            this.isDeleteNode = false;
          } else {
            this.lf.clearSelectElements();
            let data = this.lf.getGraphData();
            for (let i = 0; i < data.nodes.length; i++) {
              // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
              //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
              //     width: data.nodes[i].properties.width,
              //     height: data.nodes[i].properties.height,
              //     isShowDelete: false
              //   });
              // }
              if (
                data.nodes[i].properties.nodeSize &&
                data.nodes[i].properties.nodeSize.width &&
                data.nodes[i].properties.nodeSize.height
              ) {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  width: data.nodes[i].properties.nodeSize.width,
                  height: data.nodes[i].properties.nodeSize.height,
                  isShowDelete: false,
                });
              } else {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  isShowDelete: false,
                });
              }
            }
          }
        });
      });

      // 监听点击连线
      this.lf.on("edge:click", () => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { edges } = this.lf.getSelectElements();
            this.activeEdges = [];
            const myObject = ref({});
            myObject.value.activeEdges = [];
            myObject.value.activeNodes = [];
            this.activeNodes = [];
            // this.$_getProperty()
            if (edges.length != 0) {
              const data = this.lf.getGraphData();
              localStorage.setItem("type", "");
              localStorage.setItem("sourceNodeId", edges[0].sourceNodeId);
              localStorage.setItem(
                "route",
                edges[0].properties.route ? edges[0].properties.route : ""
              );
              for (var i = 0; i < data.nodes.length; i++) {
                if (
                  data.nodes[i].id == edges[0].sourceNodeId &&
                  data.nodes[i].type == "icon-select"
                ) {
                  // localStorage.setItem("type", edges[0].type);
                  localStorage.setItem(
                    "currentLineData",
                    JSON.stringify(data.nodes[i].properties)
                  );
                  // this.$_setStyle({
                  //   id: edges[0].id,
                  //   type: edges[0].type
                  // })
                  break;
                }
              }
            } else {
              this.lf.clearSelectElements();
              this.activeEdges = [];
              this.activeNodes = [];
            }
          } else {
            this.lf.clearSelectElements();
            this.activeEdges = [];
            this.activeNodes = [];
          }
        });
      });
      // 监听双击节点
      this.lf.on("node:dbclick", ({ e }) => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            this.isHidden = true;
            // this.chat_room_switch = false;
            const { nodes, edges } = this.lf.getSelectElements();
            const myObject = ref({});
            myObject.value.activeNodes = nodes;
            this.activeEdges = edges;
            this.activeNodes = nodes;
            this.$_getProperty();
            this.isShowGroup = false;
            if (e?.type == "click") {
              this.last_node_id = nodes[0].id;
            }
            if (nodes[0].type == "icon-thinking") {
              this.lf.clearSelectElements();
              this.activeNodes = [];
              this.showList = nodes;
              this.showDialogVisible = false;
              this.showThinkingDialogVisible = true;
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: false,
              });
              // let that = this;
              // that.sendUpdate(nodes, [], "update", 1);
              // that.Time = setInterval(function () {
              //   that.sendUpdate(nodes, [], "update", 1);
              // }, 10000);
            } else if (nodes[0].type == "icon-whiteboard") {
              this.lf.clearSelectElements();
              this.activeNodes = [];
              this.showList = nodes;
              this.showDialogVisible = false;
              this.showWhiteboardDialogVisible = true;
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: false,
              });
            } else if (nodes[0].type == "icon-map") {
              this.lf.clearSelectElements();
              this.activeNodes = [];
              this.showList = nodes;
              this.showDialogVisible = false;
              this.showMapDialogVisible = true;
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: false,
              });
            } else if (nodes[0].type == "icon-camera") {
              this.lf.clearSelectElements();
              this.activeNodes = [];
              this.showList = nodes;
              this.showDialogVisible = false;
              this.showCameraDialog = true;
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: false,
              });
            } else if (nodes[0].type == "icon-ai-npc") {
              this.lf.clearSelectElements();
              this.activeNodes = [];
              this.showList = nodes;
              this.showDialogVisible = true;
              that.Show = false;
              this.lf.graphModel.getNodeModelById(nodes[0].id).setProperties({
                isShowDelete: false,
              });
              setTimeout(function () {
                that.Show = true;
              }, 100);
            } else {
              if (this.activeNodes.length != 0) {
                localStorage.setItem("type", this.activeNodes[0].type);
                // const edgeData = this.lf.graphModel.getNodeIncomingEdge(this.activeNodes[0].id)
                // let arr = [];
                // for (let i = 0; i < edgeData.length; i++) {
                //   arr.push({ "id": edgeData[i].sourceNodeId, "route": edgeData[i].properties.route })
                // }
                // localStorage.setItem("edges", JSON.stringify(arr))
                let data = this.lf.getGraphData();
                for (let i = 0; i < data.nodes.length; i++) {
                  this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                    isShowDelete: false,
                  });
                }
                this.lf.graphModel
                  .getNodeModelById(this.activeNodes[0].id)
                  .setProperties({
                    isShowDelete: true,
                  });
                if (
                  this.activeNodes[0].properties.nodeSize &&
                  this.activeNodes[0].properties.nodeSize.width &&
                  this.activeNodes[0].properties.nodeSize.height
                ) {
                  this.$_setStyle({
                    id: this.activeNodes[0].id,
                    type: this.activeNodes[0].type,
                    width: this.activeNodes[0].properties.nodeSize.width,
                    height: this.activeNodes[0].properties.nodeSize.height,
                  });
                } else if (
                  this.activeNodes[0].type == "icon-theme" &&
                  !this.activeNodes[0].properties.backgroundColor
                ) {
                  this.$_setStyle({
                    id: this.activeNodes[0].id,
                    type: this.activeNodes[0].type,
                    backgroundColor: "#3681FC",
                  });
                } else {
                  this.$_setStyle({
                    id: this.activeNodes[0].id,
                    type: this.activeNodes[0].type,
                  });
                }
                this.iconList = this.activeNodes[0].properties.iconList;
                this.imageList = this.activeNodes[0].properties.imageList;
                this.videoList = this.activeNodes[0].properties.videoList;
                this.audioList = this.activeNodes[0].properties.audioList;
                this.fileList = this.activeNodes[0].properties.fileList;
              }
              if (
                this.activeNodes[0].type == "icon-theme" ||
                (this.activeNodes[0].type == "icon-stage" &&
                  !this.activeNodes[0].properties.stageContent) ||
                (this.activeNodes[0].type == "icon-stage" &&
                  this.activeNodes[0].properties.stageContent &&
                  this.activeNodes[0].properties.stageContent == "<p></p>") ||
                (this.activeNodes[0].type == "icon-task" &&
                  !this.activeNodes[0].properties.taskContent) ||
                (this.activeNodes[0].type == "icon-task" &&
                  this.activeNodes[0].properties.taskContent &&
                  this.activeNodes[0].properties.taskContent == "<p></p>") ||
                (this.activeNodes[0].type == "icon-homework" &&
                  !this.activeNodes[0].properties.homeworkContent) ||
                (this.activeNodes[0].type == "icon-homework" &&
                  this.activeNodes[0].properties.homeworkContent &&
                  this.activeNodes[0].properties.homeworkContent == "<p></p>")
              ) {
                $("#text_" + this.activeNodes[0].id).css("display", "none");
                $("#input_" + this.activeNodes[0].id).css("display", "block");
                var sr = document.getElementById("input_" + this.activeNodes[0].id);
                var len = sr.value.length;
                this.setSelectionRange(sr, len, len);
                this.isKeyBoardDelete = false;
              }
            }
          } else {
            this.lf.clearSelectElements();
            let data = this.lf.getGraphData();
            for (let i = 0; i < data.nodes.length; i++) {
              if (
                data.nodes[i].properties.nodeSize &&
                data.nodes[i].properties.nodeSize.width &&
                data.nodes[i].properties.nodeSize.height
              ) {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  width: data.nodes[i].properties.nodeSize.width,
                  height: data.nodes[i].properties.nodeSize.height,
                  isShowDelete: false,
                });
              } else {
                this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                  isShowDelete: false,
                });
              }
            }
          }
        });
      });
      // 监听双击连线
      this.lf.on("edge:dbclick", () => {
        this.$nextTick(() => {
          if (!this.lf.getEditConfig().isSilentMode) {
            const { nodes, edges } = this.lf.getSelectElements();
            this.activeNodes = nodes;
            this.activeEdges = edges;
            const myObject = ref({});
            myObject.value.activeEdges = edges;
            myObject.value.activeNodes = nodes;
            this.$_getProperty();
            if (edges.length != 0) {
              const data = this.lf.getGraphData();
              localStorage.setItem("type", this.activeEdges[0].type);
              // localStorage.setItem("sourceNodeId", edges[0].sourceNodeId)
              // localStorage.setItem("route", edges[0].properties.route ? edges[0].properties.route : '')
              this.$_setStyle({
                id: edges[0].id,
                type: edges[0].type,
                isIconSelect: false,
              });
              for (var i = 0; i < data.nodes.length; i++) {
                if (
                  data.nodes[i].id == edges[0].sourceNodeId &&
                  data.nodes[i].type == "icon-select"
                ) {
                  localStorage.setItem("type", edges[0].type);
                  localStorage.setItem(
                    "currentLineData",
                    JSON.stringify(data.nodes[i].properties)
                  );
                  this.$_setStyle({
                    id: edges[0].id,
                    type: edges[0].type,
                    isIconSelect: true,
                  });
                  break;
                }
              }
            } else {
              this.lf.clearSelectElements();
              this.activeEdges = [];
              this.activeNodes = [];
            }
          } else {
            this.lf.clearSelectElements();
            this.activeEdges = [];
            this.activeNodes = [];
          }
        });
      });
      // 节点删除
      this.lf.on("node:delete", () => {
        if (localStorage.getItem("edges")) {
          let edges = JSON.parse(localStorage.getItem("edges"));
          if (edges.length != 0) {
            for (let i = 0; i < edges.length; i++) {
              let nodeModel = this.lf.getNodeModelById(edges[i].id);
              let nodeData = nodeModel.getData();
              if (edges[i].route) {
                let alSelectOption = nodeData.properties.alSelectOption
                  ? nodeData.properties.alSelectOption
                  : [];
                if (alSelectOption.length != 0) {
                  for (let j = 0; j < alSelectOption.length; j++) {
                    if (edges[i].route == alSelectOption[j]) {
                      alSelectOption.splice(j, 1);
                      break;
                    }
                  }
                  // console.log(edges[i].id, nodeData, alSelectOption)
                  this.lf.getNodeModelById(edges[i].id).setProperties({
                    alSelectOption: alSelectOption,
                  });
                }
              }
            }
          }
        }
        this.$nextTick(() => {
          this.activeNodes = [];
          this.lf.clearSelectElements();
        });
      });
      // 监听添加节点
      this.lf.on("node:add", ({ data }) => {
        this.last_node_id = data.id;
        if (this.isAutomatic) {
          let nodeModel = lf.getNodeModelById(data.id);
          nodeModel.setZIndex(1002);
          data.zIndex = 1002;
          let newNodes = [];
          newNodes.push(data);
          this.sendUpdate(newNodes, [], "update", 0);
          let newData = {
            nodes: newNodes,
            edges: [],
            backgroundUrl: localStorage.getItem("background"),
          };
          this.add_Operation(newData, "addNode");
        }
      });
      this.lf.on("node:dnd-add", ({ data }) => {
        this.last_node_id = data.id;
        let nodeModel = lf.getNodeModelById(data.id);
        if (data.type == "my-group") {
          nodeModel.setZIndex(1001);
          data.zIndex = 1001;
        }
        else {
          nodeModel.setZIndex(1002);
          data.zIndex = 1002;
        }
        let newNodes = [];
        newNodes.push(data);
        this.sendUpdate(newNodes, [], "update", 0);
        let newData = {
          nodes: newNodes,
          edges: [],
          backgroundUrl: localStorage.getItem("background"),
        };
        this.add_Operation(newData, "addNode");
      });
      // 边删除
      this.lf.on("edge:delete", () => {
        // console.log(data)
        // const edgeModel = this.lf.getEdgeModelById(data.id);
        // const edgeData = edgeModel.getData();
        if (localStorage.getItem("sourceNodeId")) {
          let nodeModel = this.lf.getNodeModelById(localStorage.getItem("sourceNodeId"));
          let nodeData = nodeModel.getData();
          let alSelectOption = nodeData.properties.alSelectOption
            ? nodeData.properties.alSelectOption
            : [];
          if (alSelectOption.length != 0) {
            for (let i = 0; i < alSelectOption.length; i++) {
              if (localStorage.getItem("route") == alSelectOption[i]) {
                alSelectOption.splice(i, 1);
                break;
              }
            }
            this.lf.getNodeModelById(localStorage.getItem("sourceNodeId")).setProperties({
              alSelectOption: alSelectOption,
            });
          }
        }
        this.$nextTick(() => {
          this.activeEdges = [];
          this.lf.clearSelectElements();
        });
      });
      // 监听锚点拖动连线
      this.lf.on("anchor:drop", ({ nodeModel, edgeModel }) => {
        // let targetNode = this.lf.getNodeModelById(edgeModel.targetNodeId)
        let newEdges = [];
        let data = edgeModel.getData();
        if (nodeModel.type == "icon-select" && edgeModel.type == "pro-bezier") {
          this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-red-bezier");
          data.type = "pro-red-bezier";
        } else if (nodeModel.type == "icon-select" && edgeModel.type == "pro-curved") {
          this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-red-curved");
          data.type = "pro-red-curved";
        } else if (nodeModel.type == "icon-select" && edgeModel.type == "pro-line") {
          this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-red-line");
          data.type = "pro-red-line";
        } else if (nodeModel.type == "icon-select" && edgeModel.type == "pro-polyline") {
          this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-red-polyline");
          data.type = "pro-red-polyline";
        }
        // else if (nodeModel.type == "icon-task" && edgeModel.type == "pro-bezier" && targetNode.type == "icon-card" || nodeModel.type == "icon-card" && edgeModel.type == "pro-bezier" && targetNode.type == "icon-card") {
        //   this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-dashed-bezier")
        //   data.type = "pro-dashed-bezier"
        // }
        // else if (nodeModel.type == "icon-task" && edgeModel.type == "pro-curved" && targetNode.type == "icon-card" || nodeModel.type == "icon-card" && edgeModel.type == "pro-curved" && targetNode.type == "icon-card") {
        //   this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-dashed-curved")
        //   data.type = "pro-dashed-curved"
        // }
        // else if (nodeModel.type == "icon-task" && edgeModel.type == "pro-line" && targetNode.type == "icon-card" || nodeModel.type == "icon-card" && edgeModel.type == "pro-line" && targetNode.type == "icon-card") {
        //   this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-dashed-line")
        //   data.type = "pro-dashed-line"
        // }
        // else if (nodeModel.type == "icon-task" && edgeModel.type == "pro-polyline" && targetNode.type == "icon-card" || nodeModel.type == "icon-card" && edgeModel.type == "pro-polyline" && targetNode.type == "icon-card") {
        //   this.lf.graphModel.changeEdgeType(edgeModel.id, "pro-dashed-polyline")
        //   data.type = "pro-dashed-polyline"
        // }
        data.zIndex = 1;
        that.lf.graphModel.updateAttributes(data.id, {
          zIndex: 1,
        });
        newEdges.push(data);
        this.sendUpdate([], newEdges, "update", 0);
        let newData = {
          nodes: [],
          edges: newEdges,
          backgroundUrl: localStorage.getItem("background"),
        };
        this.add_Operation(newData, "addEdge");
      });
      // 监听添加连线
      this.lf.on("edge:add", ({ data }) => {
        console.log(data)
        that.lf.graphModel.updateAttributes(data.id, {
          zIndex: 1,
        });
        if (this.isAutomatic) {
          let newEdges = [];
          data.zIndex = 1;
          newEdges.push(data);
          if (!this.isResizeNode) {
            this.sendUpdate([], newEdges, "update", 0);
            let newData = {
              nodes: [],
              edges: newEdges,
              backgroundUrl: localStorage.getItem("background"),
            };
            this.add_Operation(newData, "addEdge");
          }
        }
      });
      // 监听移动节点
      this.lf.on("node:dragstart", ({ data }) => {
        if (document.getElementById("iframeUrl_" + data.id)) {
          document
            .getElementById("iframeUrl_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "none";
        }
        if (document.getElementById("embedCode_" + data.id)) {
          document
            .getElementById("embedCode_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "none";
        }
        if (document.getElementById("video_" + data.id)) {
          document.getElementById("video_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("audio_" + data.id)) {
          document.getElementById("audio_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("myframe_" + data.id)) {
          document.getElementById("myframe_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("svgImage_" + data.id)) {
          document.getElementById("svgImage_" + data.id).style.pointerEvents = "none";
        }
      });
      this.lf.on("node:drop", ({ data }) => {
        this.last_node_id = data.id;
        if (document.getElementById("iframeUrl_" + data.id)) {
          document
            .getElementById("iframeUrl_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
        }
        if (document.getElementById("embedCode_" + data.id)) {
          document
            .getElementById("embedCode_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
        }
        if (document.getElementById("video_" + data.id)) {
          document.getElementById("video_" + data.id).style.pointerEvents = "auto";
        }
        if (document.getElementById("audio_" + data.id)) {
          document.getElementById("audio_" + data.id).style.pointerEvents = "auto";
        }
        if (document.getElementById("myframe_" + data.id)) {
          document.getElementById("myframe_" + data.id).style.pointerEvents = "auto";
        }
        if (document.getElementById("svgImage_" + data.id)) {
          document.getElementById("svgImage_" + data.id).style.pointerEvents = "auto";
        }
        let newNodes = [];
        let newEdges = [];
        this.isDeleteNode = true;
        this.isAutomatic = false;
        function changeData(lf,data,newNodes,newEdges) {
          newNodes.push(data);
          let nodeModel = lf.getNodeModelById(data.id);
          let anchors = nodeModel.anchors;
          let outgoingEdgeModel = lf.getNodeOutgoingEdge(data.id);
          if (outgoingEdgeModel.length != 0) {
            for (let i = 0; i < outgoingEdgeModel.length; i++) {
              for (let j = 0; j < anchors.length; j++) {
                if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
                  let edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                  edge.startPoint.x = anchors[j].x;
                  edge.startPoint.y = anchors[j].y;
                  edge = lf.getEdgeModelById(outgoingEdgeModel[i].id);
                  let edgeData = edge.getData();
                  // edgeData.startPoint.x = anchors[j].x
                  // edgeData.startPoint.y = anchors[j].y
                  // if(edgeData.pointsList) {
                  //   edgeData.pointsList[0] = edgeData.startPoint
                  // }
                  newEdges.push(edgeData);
                  // lf.deleteEdge(edgeData.id)
                  // lf.addEdge(edgeData)
                  break;
                }
              }
            }
          }
          let incomingEdgeModel = lf.getNodeIncomingEdge(data.id);
          if (incomingEdgeModel.length != 0) {
            for (let i = 0; i < incomingEdgeModel.length; i++) {
              for (let j = 0; j < anchors.length; j++) {
                if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
                  let edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                  edge.endPoint.x = anchors[j].x;
                  edge.endPoint.y = anchors[j].y;
                  edge = lf.getEdgeModelById(incomingEdgeModel[i].id);
                  let edgeData = edge.getData();
                  // edgeData.endPoint.x = anchors[j].x
                  // edgeData.endPoint.y = anchors[j].y
                  // if(edgeData.pointsList) {
                  //   edgeData.pointsList[edgeData.pointsList.length - 1] = edgeData.endPoint
                  // }
                  newEdges.push(edgeData);
                  // lf.deleteEdge(edgeData.id)
                  // lf.addEdge(edgeData)
                  break;
                }
              }
            }
          }
          return newNodes,newEdges
        }
        newNodes,newEdges = changeData(this.lf,data,newNodes,newEdges)
        if(this.lf.getNodeModelById(data.id).isGroup) {
          const nodeIds = data.children
          // console.log(nodeIds)
          nodeIds.forEach(item => {
            let model = this.lf.getNodeModelById(item);
            newNodes,newEdges = changeData(this.lf,model.getData(),newNodes,newEdges)
          })
        }
        // console.log(newNodes)
        // console.log(newEdges)
        this.sendUpdate(newNodes, newEdges, "update", 0);
        this.isDeleteNode = false;
        // let newData = {
        //   "nodes": newNodes,
        //   "edges": newEdges,
        //   "backgroundUrl": localStorage.getItem("background")
        // }
        // this.add_Operation(newData, "moveNode")
      });
      // 监听放大缩放节点
      this.lf.on("node:resize", ({ deltaX, deltaY, index, model, preData, data }) => {
        // console.log(data.id)
        if(model.isGroup) {
          const { graphModel } = this.lf
          const { transformWithContainer, isRestrict } = model
          if (!transformWithContainer || isRestrict) {
            // isRestrict限制模式下，当前model resize时不能小于占地面积
            // 由于parent:resize=>child:resize计算复杂，需要根据child:resize的判定结果来递归判断parent能否resize
            // 不符合目前 parent:resize成功后emit事件 -> 触发child:resize 的代码交互模式
            // 因此isRestrict限制模式下不支持联动(parent:resize=>child:resize)
            return
          }
          this.isResizeNode = true;
          if (document.getElementById("svgImage_" + model.id)) {
            document.getElementById("svgImage_" + model.id).style.pointerEvents = "none";
          }
          model.setProperties({
            ...model.properties,
            nodeSize: {
              width: model.properties.width,
              height: model.properties.height
            }
          })

          const { properties } = preData
          const { width: groupWidth, height: groupHeight } = properties || {}
          forEach(Array.from(model.children), (childId) => {
            const child = this.lf.getNodeModelById(childId)
            if (child) {
              // 根据比例去控制缩放dx和dy
              const childDx = (child.width / groupWidth) * deltaX
              const childDy = (child.height / groupHeight) * deltaY

              // child.rotate = model.rotate
              handleResize({
                deltaX: childDx,
                deltaY: childDy,
                index,
                nodeModel: child,
                graphModel,
                cancelCallback: () => {},
              })
            }
          })

          debounce(() => {
            let newNodes = [];
            let nodeModel = graphModel.getNodeModelById(model.id);
            // console.log(nodeModel)
            let nodeData = nodeModel.getData();
            // console.log(nodeData)
            newNodes.push(nodeData);
            let newEdges = [];
            let anchors = nodeModel.anchors;
            let outgoingEdgeModel = graphModel.getNodeOutgoingEdge(model.id);
            for (let i = 0; i < outgoingEdgeModel.length; i++) {
              for (let j = 0; j < anchors.length; j++) {
                if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
                  let edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
                  edge.startPoint.x = anchors[j].x;
                  edge.startPoint.y = anchors[j].y;
                  edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
                  let edgeData = edge.getData();
                  newEdges.push(edgeData);
                  break;
                }
              }
            }
            let incomingEdgeModel = graphModel.getNodeIncomingEdge(model.id);
            for (let i = 0; i < incomingEdgeModel.length; i++) {
              for (let j = 0; j < anchors.length; j++) {
                if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
                  let edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
                  edge.endPoint.x = anchors[j].x;
                  edge.endPoint.y = anchors[j].y;
                  edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
                  let edgeData = edge.getData();
                  newEdges.push(edgeData);
                  break;
                }
              }
            }
            forEach(Array.from(model.children), (childId) => {
              const child = graphModel.getNodeModelById(childId)
              if (child) {
                let nodeData = child.getData();
                // console.log(nodeData)
                newNodes.push(nodeData);
                let anchors = child.anchors;
                let outgoingEdgeModel = graphModel.getNodeOutgoingEdge(childId);
                for (let i = 0; i < outgoingEdgeModel.length; i++) {
                  for (let j = 0; j < anchors.length; j++) {
                    if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
                      let edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
                      edge.startPoint.x = anchors[j].x;
                      edge.startPoint.y = anchors[j].y;
                      edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
                      let edgeData = edge.getData();
                      newEdges.push(edgeData);
                      break;
                    }
                  }
                }
                let incomingEdgeModel = graphModel.getNodeIncomingEdge(childId);
                for (let i = 0; i < incomingEdgeModel.length; i++) {
                  for (let j = 0; j < anchors.length; j++) {
                    if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
                      let edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
                      edge.endPoint.x = anchors[j].x;
                      edge.endPoint.y = anchors[j].y;
                      edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
                      let edgeData = edge.getData();
                      newEdges.push(edgeData);
                      break;
                    }
                  }
                }
              }
            })
            this.sendUpdate(newNodes, newEdges, "update", 0);
            this.isResizeNode = false;
          }, 3000);
          return
        }
        this.last_node_id = data.id;
        if (document.getElementById("iframeUrl_" + data.id)) {
          document
            .getElementById("iframeUrl_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "none";
        }
        if (document.getElementById("embedCode_" + data.id)) {
          document
            .getElementById("embedCode_" + data.id)
            .getElementsByTagName("iframe")[0].style.pointerEvents = "none";
        }
        if (document.getElementById("video_" + data.id)) {
          document.getElementById("video_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("audio_" + data.id)) {
          document.getElementById("audio_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("myframe_" + data.id)) {
          document.getElementById("myframe_" + data.id).style.pointerEvents = "none";
        }
        if (document.getElementById("svgImage_" + data.id)) {
          document.getElementById("svgImage_" + data.id).style.pointerEvents = "none";
        }
        this.isResizeNode = true;
        if (data.width <= 80 || data.height <= 80) {
          this.$_setStyle({
            width: data.width,
            height: data.height,
            iconRadio: true,
            nodeSize: {
              width: data.width,
              height: data.height,
            },
          });
        } else {
          this.$_setStyle({
            width: data.width,
            height: data.height,
            iconRadio: false,
            nodeSize: {
              width: data.width,
              height: data.height,
            },
          });
        }
        debounce(() => {
          if (document.getElementById("iframeUrl_" + data.id)) {
            document
              .getElementById("iframeUrl_" + data.id)
              .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
          }
          if (document.getElementById("embedCode_" + data.id)) {
            document
              .getElementById("embedCode_" + data.id)
              .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
          }
          if (document.getElementById("video_" + data.id)) {
            document.getElementById("video_" + data.id).style.pointerEvents = "auto";
          }
          if (document.getElementById("audio_" + data.id)) {
            document.getElementById("audio_" + data.id).style.pointerEvents = "auto";
          }
          if (document.getElementById("myframe_" + data.id)) {
            document.getElementById("myframe_" + data.id).style.pointerEvents = "auto";
          } 
          if (document.getElementById("svgImage_" + data.id)) {
            document.getElementById("svgImage_" + data.id).style.pointerEvents = "auto";
          }
          let newNodes = [];
          let nodeModel = this.lf.getNodeModelById(data.id);
          let nodeData = nodeModel.getData();
          console.log(nodeData)
          newNodes.push(nodeData);
          let newEdges = [];
          let anchors = nodeModel.anchors;
          let outgoingEdgeModel = this.lf.getNodeOutgoingEdge(data.id);
          for (let i = 0; i < outgoingEdgeModel.length; i++) {
            for (let j = 0; j < anchors.length; j++) {
              if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
                let edge = this.lf.getEdgeModelById(outgoingEdgeModel[i].id);
                edge.startPoint.x = anchors[j].x;
                edge.startPoint.y = anchors[j].y;
                edge = this.lf.getEdgeModelById(outgoingEdgeModel[i].id);
                let edgeData = edge.getData();
                newEdges.push(edgeData);
                // this.lf.deleteEdge(outgoingEdgeModel[i].id)
                // this.lf.addEdge(edgeData)
                break;
              }
            }
          }
          let incomingEdgeModel = this.lf.getNodeIncomingEdge(data.id);
          for (let i = 0; i < incomingEdgeModel.length; i++) {
            for (let j = 0; j < anchors.length; j++) {
              if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
                let edge = this.lf.getEdgeModelById(incomingEdgeModel[i].id);
                edge.endPoint.x = anchors[j].x;
                edge.endPoint.y = anchors[j].y;
                edge = this.lf.getEdgeModelById(incomingEdgeModel[i].id);
                let edgeData = edge.getData();
                newEdges.push(edgeData);
                // this.lf.deleteEdge(incomingEdgeModel[i].id)
                // this.lf.addEdge(edgeData)
                break;
              }
            }
          }
          this.sendUpdate(newNodes, newEdges, "update", 0);
          this.isResizeNode = false;
        }, 3000);
      });
      // 监听放大缩放节点完成
      // this.lf.on("node:mouseleave", ({ data }) => {
      //   let model = this.lf.getNodeModelById(data.id)
      //   // console.log(model)
      //   if(model.isGroup) {
      //     const { graphModel } = this.lf
      //     if (this.isResizeNode) {
      //       if (document.getElementById("svgImage_" + data.id)) {
      //         document.getElementById("svgImage_" + model.id).style.pointerEvents = "auto";
      //       }
      //       let newNodes = [];
      //       let nodeModel = graphModel.getNodeModelById(model.id);
      //       // console.log(nodeModel)
      //       let nodeData = nodeModel.getData();
      //       // console.log(nodeData)
      //       newNodes.push(nodeData);
      //       let newEdges = [];
      //       let anchors = nodeModel.anchors;
      //       let outgoingEdgeModel = graphModel.getNodeOutgoingEdge(model.id);
      //       for (let i = 0; i < outgoingEdgeModel.length; i++) {
      //         for (let j = 0; j < anchors.length; j++) {
      //           if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
      //             let edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
      //             edge.startPoint.x = anchors[j].x;
      //             edge.startPoint.y = anchors[j].y;
      //             edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
      //             let edgeData = edge.getData();
      //             newEdges.push(edgeData);
      //             break;
      //           }
      //         }
      //       }
      //       let incomingEdgeModel = graphModel.getNodeIncomingEdge(model.id);
      //       for (let i = 0; i < incomingEdgeModel.length; i++) {
      //         for (let j = 0; j < anchors.length; j++) {
      //           if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
      //             let edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
      //             edge.endPoint.x = anchors[j].x;
      //             edge.endPoint.y = anchors[j].y;
      //             edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
      //             let edgeData = edge.getData();
      //             newEdges.push(edgeData);
      //             break;
      //           }
      //         }
      //       }
      //       forEach(Array.from(model.children), (childId) => {
      //         const child = graphModel.getNodeModelById(childId)
      //         if (child) {
      //           let nodeData = child.getData();
      //           // console.log(nodeData)
      //           newNodes.push(nodeData);
      //           let anchors = child.anchors;
      //           let outgoingEdgeModel = graphModel.getNodeOutgoingEdge(childId);
      //           for (let i = 0; i < outgoingEdgeModel.length; i++) {
      //             for (let j = 0; j < anchors.length; j++) {
      //               if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
      //                 let edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
      //                 edge.startPoint.x = anchors[j].x;
      //                 edge.startPoint.y = anchors[j].y;
      //                 edge = graphModel.getEdgeModelById(outgoingEdgeModel[i].id);
      //                 let edgeData = edge.getData();
      //                 newEdges.push(edgeData);
      //                 break;
      //               }
      //             }
      //           }
      //           let incomingEdgeModel = graphModel.getNodeIncomingEdge(childId);
      //           for (let i = 0; i < incomingEdgeModel.length; i++) {
      //             for (let j = 0; j < anchors.length; j++) {
      //               if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
      //                 let edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
      //                 edge.endPoint.x = anchors[j].x;
      //                 edge.endPoint.y = anchors[j].y;
      //                 edge = graphModel.getEdgeModelById(incomingEdgeModel[i].id);
      //                 let edgeData = edge.getData();
      //                 newEdges.push(edgeData);
      //                 break;
      //               }
      //             }
      //           }
      //         }
      //       })
      //       this.sendUpdate(newNodes, newEdges, "update", 0);
      //       this.isResizeNode = false;
      //     }
      //     return
      //   }
      //   if (document.getElementById("iframeUrl_" + data.id)) {
      //     document
      //       .getElementById("iframeUrl_" + data.id)
      //       .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
      //   }
      //   if (document.getElementById("embedCode_" + data.id)) {
      //     document
      //       .getElementById("embedCode_" + data.id)
      //       .getElementsByTagName("iframe")[0].style.pointerEvents = "auto";
      //   }
      //   if (document.getElementById("video_" + data.id)) {
      //     document.getElementById("video_" + data.id).style.pointerEvents = "auto";
      //   }
      //   if (document.getElementById("audio_" + data.id)) {
      //     document.getElementById("audio_" + data.id).style.pointerEvents = "auto";
      //   }
      //   if (document.getElementById("myframe_" + data.id)) {
      //     document.getElementById("myframe_" + data.id).style.pointerEvents = "auto";
      //   }
      //   if (document.getElementById("svgImage_" + data.id)) {
      //     document.getElementById("svgImage_" + data.id).style.pointerEvents = "auto";
      //   }
      //   if (this.isResizeNode) {
      //     let newNodes = [];
      //     let nodeModel = this.lf.getNodeModelById(data.id);
      //     let nodeData = nodeModel.getData();
      //     console.log(nodeData)
      //     newNodes.push(nodeData);
      //     let newEdges = [];
      //     let anchors = nodeModel.anchors;
      //     let outgoingEdgeModel = this.lf.getNodeOutgoingEdge(data.id);
      //     for (let i = 0; i < outgoingEdgeModel.length; i++) {
      //       for (let j = 0; j < anchors.length; j++) {
      //         if (outgoingEdgeModel[i].sourceAnchorId == anchors[j].id) {
      //           let edge = this.lf.getEdgeModelById(outgoingEdgeModel[i].id);
      //           edge.startPoint.x = anchors[j].x;
      //           edge.startPoint.y = anchors[j].y;
      //           edge = this.lf.getEdgeModelById(outgoingEdgeModel[i].id);
      //           let edgeData = edge.getData();
      //           newEdges.push(edgeData);
      //           // this.lf.deleteEdge(outgoingEdgeModel[i].id)
      //           // this.lf.addEdge(edgeData)
      //           break;
      //         }
      //       }
      //     }
      //     let incomingEdgeModel = this.lf.getNodeIncomingEdge(data.id);
      //     for (let i = 0; i < incomingEdgeModel.length; i++) {
      //       for (let j = 0; j < anchors.length; j++) {
      //         if (incomingEdgeModel[i].targetAnchorId == anchors[j].id) {
      //           let edge = this.lf.getEdgeModelById(incomingEdgeModel[i].id);
      //           edge.endPoint.x = anchors[j].x;
      //           edge.endPoint.y = anchors[j].y;
      //           edge = this.lf.getEdgeModelById(incomingEdgeModel[i].id);
      //           let edgeData = edge.getData();
      //           newEdges.push(edgeData);
      //           // this.lf.deleteEdge(incomingEdgeModel[i].id)
      //           // this.lf.addEdge(edgeData)
      //           break;
      //         }
      //       }
      //     }
      //     this.sendUpdate(newNodes, newEdges, "update", 0);
      //     this.isResizeNode = false;
      //     // let newData = {
      //     //   "nodes": newNodes,
      //     //   "edges": newEdges,
      //     //   "backgroundUrl": localStorage.getItem("background")
      //     // }
      //     // this.add_Operation(newData, "resizeNode")
      //   }
      // });
      // 监听连线拖拽调整
      this.lf.on("edge:adjust", ({ data }) => {
        let newEdges = [];
        newEdges.push(data);
        this.sendUpdate([], newEdges, "update", 0);
        let newData = {
          nodes: [],
          edges: newEdges,
          backgroundUrl: localStorage.getItem("background"),
        };
        this.add_Operation(newData, "updateEdge");
      });
      // 监听调整连线的起点/终点
      this.lf.on("edge:exchange-node", ({ data }) => {
        this.isDeleteNode = true;
        // console.log(data.newEdge)
        let newEdges = [];
        newEdges.push(data.newEdge);
        setTimeout(() => {
          this.sendUpdate([], newEdges, "update", 0);
          let newData = {
            nodes: [],
            edges: newEdges,
            backgroundUrl: localStorage.getItem("background"),
          };
          this.add_Operation(newData, "updateEdge");
        }, 300);
        this.isDeleteNode = false;
      });
      // 监听鼠标滚轮缩放画布
      this.lf.on("graph:transform", (data) => {
        $(".lf-background").css({
          "transform-origin": "0px 0px",
          transform:
            "matrix(" +
            data.transform.SCALE_X +
            "," +
            data.transform.SKEW_X +
            "," +
            data.transform.SKEW_Y +
            "," +
            data.transform.SCALE_Y +
            "," +
            data.transform.TRANSLATE_X +
            "," +
            data.transform.TRANSLATE_Y +
            ")",
        });
        $(".lf-diagram canvas").css({
          "transform-origin": "0px 0px",
          transform:
            "matrix(" +
            data.transform.SCALE_X +
            "," +
            data.transform.SKEW_X +
            "," +
            data.transform.SKEW_Y +
            "," +
            data.transform.SCALE_Y +
            "," +
            data.transform.TRANSLATE_X +
            "," +
            data.transform.TRANSLATE_Y +
            ")",
        });
        if (data.type == "zoom") {
          if (Math.round(data.transform.SCALE_X * 100) > 400) {
            this.lf.zoom(4);
            this.transformSize = 400;
            // $(".lf-background-area").css("transform","scale(4)")
          } else if (Math.round(data.transform.SCALE_X * 100) < 24) {
            this.lf.zoom(0.24);
            this.transformSize = 24;
            // $(".lf-background-area").css("transform","scale(4)")
          } else {
            this.transformSize = Math.round(data.transform.SCALE_X * 100);
            // $(".lf-background-area").css("transform","scale(" + data.transform.SCALE_X + ")")
          }
        }
      });
      this.lf.on("connection:not-allowed", ({ data, msg }) => {
        console.log(data);
        this.$message({
          type: "info",
          message: msg,
        });
      });
      $(".lf-drag-able").attr("data-marpit-svg", "");
      $(".modification-overlay").attr("data-marpit-svg", "");
    },
    looseEqual(a, b) {
      if (a === b) {
        //如果是绝对相等就直接返回true
        return true;
      }
      //如果不是绝对相等就哦按的他们是否有相同的形状
      var isObjectA = this.isObject(a);
      var isObjectB = this.isObject(b);
      if (isObjectA && isObjectB) {
        //两个均是对象
        try {
          var isArrayA = Array.isArray(a);
          var isArrayB = Array.isArray(b);
          if (isArrayA && isArrayB) {
            //如果都是数组
            if (a.length === b.length) {
              //如果长度相等
              return a.every(function (e, i) {
                //用every和递归来比对a数组和b数组的每个元素，并返回
                return this.looseEqual(e, b[i]);
              });
            }
            //长度都不等直接返回false
            return false;
          } else if (a instanceof Date && b instanceof Date) {
            //如果是Date 则直接getTime 比较
            return a.getTime() === b.getTime();
          } else if (!isArrayA && !isArrayB) {
            //对象的比较
            //拿到两个对象的key
            var keysA = Object.keys(a);
            var keysB = Object.keys(b);
            if (keysA.length === keysB.length) {
              //如果keys相等
              return keysA.every(function (key) {
                //用every和递归来比对a对象和b对象的每个元素值，并返回
                return this.looseEqual(a[key], b[key]);
              });
            }
            //长度都不等直接返回false
            return false;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      } else if (!isObjectA && !isObjectB) {
        //如果都不是对象则按String来处理
        return String(a) === String(b);
      } else {
        return false;
      }
    },
    isObject(obj) {
      return obj !== null && typeof obj === "object";
    },
    // 获取可以进行设置的属性
    $_getProperty() {
      let properties = {};
      const { nodes, edges } = this.lf.getSelectElements();
      nodes.forEach((node) => {
        properties = { ...properties, ...node.properties };
      });
      edges.forEach((edge) => {
        properties = { ...properties, ...edge.properties };
      });
      this.properties = properties;
      return properties;
    },
    $_dragInNode(type, context) {
      if (this.lf.getEditConfig().isSilentMode) {
        return;
      }
      this.lf.clearSelectElements();
      this.activeNodes = [];
      this.activeEdges = [];
      this.lf.dnd.startDrag({
        type,
        properties: getLfProperties({ type, context }),
      });
    },
    $_addAIAgent(id) {
      this.AIAgentDialogVisible = true;
      this.agentId = id;
    },
    showFile(newVal) {
      console.log(newVal);
      const { nodes } = this.lf.getSelectElements();
      this.showList = nodes;
      this.showDialogVisible = true;
    },
    $_generateNode(type) {
      this.isAutomatic = true;
      let id = uuidv4();
      if (type != "icon-thinking") {
        let node = {
          id: id,
          type: type,
          properties: {},
          x: window.screen.width / 2,
          y: window.screen.height / 2,
          zIndex: 1002,
        };
        this.lf.graphModel.addNode(node);
      } else {
        let node = {
          id: id,
          type: type,
          properties: {
            thinkingContent:
              "https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/e8215fd4-4b4c-4373-ac36-5ea301aefa73.png",
          },
          x: window.screen.width / 2,
          y: window.screen.height / 2,
          zIndex: 1002,
        };
        this.lf.graphModel.addNode(node);
      }
      const { transformModel } = this.lf.graphModel;
      transformModel.focusOn(
        window.screen.width / 2,
        window.screen.height / 2,
        window.screen.width,
        window.screen.height
      );
      this.isAutomatic = false;
    },
    getTransformSize(val) {
      this.transformSize = val;
    },
    openJobReception(val) {
      this.isJobReception = val;
    },
    openAnalyse(val) {
      this.isAnalyse = val;
      if (val) {
        console.log(1111);
        // this.demoname = this.$route.params.demoname;
        // this.showSeeksGraph()
      }
    },
    openNewAnalyse(val) {
      this.isNewAnalyse = val;
      if (val) {
        this.activeName = "all";
        this.init_result_map();
      }
    },
    openBackground(val) {
      this.isBackground = val;
      $("#background .el-dialog").css({
        width: "30%",
      });
    },
    selectFile() {
      $("#FileNew").click();
    },
    uploadFile(e) {
      console.log(e.target.files[0]);
      let loadingInstance = Loading.service({ fullscreen: true });
      var file = e.target.files[0];
      this.uploadImage(file, loadingInstance);
    },
    openBackgroundNew() {
      this.isBackgroundNew = true;
      this.isBackground = false;
      if (document.getElementById("backgroundIframe")) {
        document
          .getElementById("backgroundIframe")
          .contentWindow.h.app.updateScene({ elements: [] });
      }
    },
    getBackground(val) {
      this.backGround = val;
    },
    getBackgroundVal() {
      if (window.location.href.indexOf("cocorobo.cn") != -1) {
        document.domain = "cocorobo.cn";
      } else if (window.location.href.indexOf("cocorobo.hk") != -1) {
        document.domain = "cocorobo.hk";
      } else if (window.location.href.indexOf("cocorobo.com") != -1) {
        document.domain = "cocorobo.com";
      }
      let img = document
        .getElementById("backgroundIframe")
        .contentWindow.h.app.rc.canvas.toDataURL("image/png");
      this.backGround = img;
      this.isBackgroundNew = false;
      this.isBackground = false;
    },
    $_changeNodeFill(color) {
      const { nodes } = this.lf.graphModel.getSelectElements();
      nodes.forEach(({ id }) => {
        this.lf.setProperties(id, {
          fill: color,
        });
      });
    },
    getData(val) {
      this.groupData = val;
    },
    getImageInfo(value) {
      this.imageDialogVisible = value;
    },
    getIconInfo(value) {
      this.iconDialogVisible = value;
    },
    getMonitorInfo(value) {
      this.monitorDialogVisible = value;
    },
    getTitle(value) {
      this.title = value;
    },
    getSourceInfo(value) {
      this.FormworkDialogVisible = value;
    },
    getImportInfo(value) {
      this.importDialogVisible = value;
    },
    getExportInfo(value) {
      this.exportDialogVisible = value;
    },
    getShowInfo(value) {
      this.showDialogVisible = value;
      this.showList = [];
      // window.location.reload()
    },
    getAIAgentInfo(value) {
      this.AIAgentDialogVisible = value;
      this.agentId = "";
    },
    saveAIAgent(value) {
      let that = this;
      that.AIAgentDialogVisible = !value;
      that.refreshAIAgent = value;
      that.agentId = "";
      that.$message({
        type: "success",
        message: that.languageData.tip114,
      });
    },
    setRefreshAIAgent(value) {
      let that = this;
      that.refreshAIAgent = value;
    },
    getShowThinkingInfo(value) {
      clearInterval(this.Time);
      this.showThinkingDialogVisible = value;
      this.showList = [];
    },
    getWhiteboardInfo(value) {
      this.showWhiteboardDialogVisible = value;
      this.showList = [];
    },
    getMapInfo(value) {
      this.showMapDialogVisible = value;
      this.showList = [];
    },
    getCameraInfo(value) {
      this.showCameraDialog = value;
      this.showList = [];
    },
    // clearList(value) {
    //   this.dataList = value;
    // },
    $_setIconList(val) {
      this.iconList = val;
    },
    $_setImageList(val) {
      this.imageList = val;
    },
    $_setVideoList(val) {
      this.videoList = val;
    },
    $_setAudioList(val) {
      this.audioList = val;
    },
    $_setFileList(val) {
      this.fileList = val;
    },
    $_setStyle(item) {
      let oldData = this.lf.getSelectElements();
      let oldNodes = JSON.stringify(oldData.nodes);
      let oldEdges = JSON.stringify(oldData.edges);
      this.activeNodes.forEach(({ id }) => {
        this.lf.setProperties(id, item);
      });
      this.activeEdges.forEach(({ id }) => {
        this.lf.setProperties(id, item);
      });
      let newData = this.lf.getSelectElements();
      let newNodes = JSON.stringify(newData.nodes);
      let newEdges = JSON.stringify(newData.edges);
      if (
        (!this.looseEqual(newNodes, oldNodes) && !this.isResizeNode) ||
        (!this.looseEqual(newEdges, oldEdges) && !this.isResizeNode)
      ) {
        debounce(() => {
          this.sendUpdate(JSON.parse(newNodes), JSON.parse(newEdges), "update", 0);
          let newData = {
            nodes: JSON.parse(newNodes),
            edges: JSON.parse(newEdges),
            backgroundUrl: localStorage.getItem("background"),
          };
          this.add_Operation(newData, "updateNode");
        }, 3000);
      }
      this.$_getProperty();
      // const data = this.lf.getGraphData()
      // localStorage.setItem("data", JSON.stringify(data));
    },
    $_setZIndex(type) {
      this.activeNodes.forEach(({ id }) => {
        this.lf.setElementZIndex(id, type);
      });
      this.activeEdges.forEach(({ id }) => {
        this.lf.setElementZIndex(id, type);
      });
    },
    // loadXmlData(e) {
    //   let loadingInstance = Loading.service({ fullscreen: true });
    //   var file = e.target.files[0];
    //   var reader = new FileReader()
    //   reader.onload = (e) => {
    //     if (e.target) {
    //       var data = e.target.result;
    //       // console.log(data)
    //       if (data) {
    //         data = lfXml2Json(data)
    //       }
    //       // console.log(data)
    //       var _this = this;
    //       setTimeout(function () {
    //         _this.initLogicFlow(data)
    //         _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
    //           loadingInstance.close();
    //         });
    //       }, 3000)
    //     }
    //   }
    //   reader.readAsText(file);
    // },
    sendUpdate(newNodes, newEdges, str, type) {
      let groupNew = this.group;
      let user_index = this.group[0].group_member.findIndex((item) => {
        return item.userid == this.user.userId;
      });
      if (user_index != -1) {
        groupNew[0].group_member[user_index].state = 2;
        this.$store.commit("set_group", []);
        this.$store.commit("set_group", groupNew);
      }
      if (this.network) {
        let mindinfo = {
          "us.cscl": [
            {
              sendId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                  : window.parent.US.userInfo.userid, //发送人id
              receiveId: localStorage.getItem("roomId"), //文件id
              pageId:
                window.location.href.indexOf("localhost") != -1 ||
                window.location.href.indexOf("192.168") != -1
                  ? "d7300d31-8cf6-38dc-e295-2c71622b4df1"
                  : window.parent.US.pageId,
              type: str, //消息类型
              messageInfo: {
                nodes: newNodes,
                edges: newEdges,
                backgroundUrl: localStorage.getItem("background"),
                userName:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "潘炜桐"
                    : window.parent.US.userInfo.username,
                userId:
                  window.location.href.indexOf("localhost") != -1 ||
                  window.location.href.indexOf("192.168") != -1
                    ? "1cf9dc4b-d95f-11ea-af4c-52540005ab01"
                    : window.parent.US.userInfo.userid,
                roomId: localStorage.getItem("roomId"),
                type: type,
              },
            },
          ],
        };
        let params =
          "mode=" +
          ["send", encodeURIComponent(encodeURIComponent(JSON.stringify(mindinfo)))].join(
            ","
          );
        this.$ajax
          .post("https://poll.cocorobo.cn", params)
          .then(() => {
            //console.log(res);
          })
          .catch((err) => {
            console.error(err);
            if (str == "update") {
              let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
              let index = [];
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  for (let j = 0; j < data.nodes.length; j++) {
                    if (newNodes[i].id == data.nodes[j].id) {
                      data.nodes[j] = newNodes[i];
                      index.push(j);
                      break;
                    }
                  }
                }
                if (index.length == 0) {
                  for (let j = 0; j < newNodes.length; j++) {
                    data.nodes.push(newNodes[j]);
                  }
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  for (let j = 0; j < data.edges.length; j++) {
                    if (newEdges[i].id == data.edges[j].id) {
                      data.edges[j] = newEdges[i];
                      index.push(j);
                      break;
                    }
                  }
                }
                if (index.length == 0) {
                  for (let j = 0; j < newEdges.length; j++) {
                    data.edges.push(newEdges[j]);
                  }
                }
              }
              if (data.backgroundUrl != localStorage.getItem("background")) {
                data.backgroundUrl = localStorage.getItem("background");
              }
              localStorage.setItem("offlineUpdateData", JSON.stringify(data));
            }
            if (str == "delete") {
              let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  for (let j = 0; j < data.nodes.length; j++) {
                    if (newNodes[i].id == data.nodes[j].id) {
                      data.nodes.splice(j, 1);
                      break;
                    }
                  }
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  for (let j = 0; j < data.edges.length; j++) {
                    if (newEdges[i].id == data.edges[j].id) {
                      data.edges.splice(j, 1);
                      break;
                    }
                  }
                }
              }
              localStorage.setItem("offlineUpdateData", JSON.stringify(data));
              let offlineDeleteData = JSON.parse(
                localStorage.getItem("offlineDeleteData")
              );
              if (newNodes.length != 0) {
                for (let i = 0; i < newNodes.length; i++) {
                  offlineDeleteData.nodes.push(newNodes[i]);
                }
              }
              if (newEdges.length != 0) {
                for (let i = 0; i < newEdges.length; i++) {
                  offlineDeleteData.edges.push(newEdges[i]);
                }
              }
              localStorage.setItem(
                "offlineDeleteData",
                JSON.stringify(offlineDeleteData)
              );
            }
          });
      } else {
        if (str == "update") {
          let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
          let index = [];
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (newNodes[i].id == data.nodes[j].id) {
                  data.nodes[j] = newNodes[i];
                  index.push(j);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < newNodes.length; j++) {
                data.nodes.push(newNodes[j]);
              }
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (newEdges[i].id == data.edges[j].id) {
                  data.edges[j] = newEdges[i];
                  index.push(j);
                  break;
                }
              }
            }
            if (index.length == 0) {
              for (let j = 0; j < newEdges.length; j++) {
                data.edges.push(newEdges[j]);
              }
            }
          }
          if (data.backgroundUrl != localStorage.getItem("background")) {
            data.backgroundUrl = localStorage.getItem("background");
          }
          localStorage.setItem("offlineUpdateData", JSON.stringify(data));
        }
        if (str == "delete") {
          let data = JSON.parse(localStorage.getItem("offlineUpdateData"));
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              for (let j = 0; j < data.nodes.length; j++) {
                if (newNodes[i].id == data.nodes[j].id) {
                  data.nodes.splice(j, 1);
                  break;
                }
              }
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              for (let j = 0; j < data.edges.length; j++) {
                if (newEdges[i].id == data.edges[j].id) {
                  data.edges.splice(j, 1);
                  break;
                }
              }
            }
          }
          localStorage.setItem("offlineUpdateData", JSON.stringify(data));
          let offlineDeleteData = JSON.parse(localStorage.getItem("offlineDeleteData"));
          if (newNodes.length != 0) {
            for (let i = 0; i < newNodes.length; i++) {
              offlineDeleteData.nodes.push(newNodes[i]);
            }
          }
          if (newEdges.length != 0) {
            for (let i = 0; i < newEdges.length; i++) {
              offlineDeleteData.edges.push(newEdges[i]);
            }
          }
          localStorage.setItem("offlineDeleteData", JSON.stringify(offlineDeleteData));
        }
      }
    },
    /*
      数据-添加修改日志
    */
    add_Operation(data, str) {
      let newData = {
        type: str,
        data: data,
      };
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
              localStorage.getItem("roomId"),
              "cscl",
              encodeURIComponent(encodeURIComponent(JSON.stringify(newData))),
            ].join(",")
          : "mode=" +
            [
              window.parent.US.userInfo.userid,
              localStorage.getItem("roomId"),
              "cscl",
              encodeURIComponent(encodeURIComponent(JSON.stringify(newData))),
            ].join(",");
      that.$ajax
        .post("https://pbl.cocorobo.cn/api/pbl/add_OperationCSCL", params)
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    /*
      数据-获取修改日志
    */
    get_Operation(type) {
      let that = this;
      if (
        window.location.href.indexOf("?cid=") != -1 &&
        window.location.href.indexOf("&gid=") != -1
      ) {
        if (type == "student") {
          let totalPage =
            that.analyserUserData.length % 4 != 0
              ? parseInt(that.analyserUserData.length / 4) + 1
              : that.analyserUserData.length / 4;
          that.selectStudentPageNum = [];
          for (let i = 0; i < totalPage; i++) {
            that.selectStudentPageNum.push("第" + (i + 1) + "页");
          }
          that.handleStudentData(that.logData, that.analyserUserData);
        }
        if (type == "collaborate") {
          let group = [];
          for (let i = 0; i < that.group.length; i++) {
            if (that.group[i].name != "我的小组") {
              group.push(that.group[i]);
            }
          }
          let totalPage =
            group.length % 4 != 0 ? parseInt(group.length / 4) + 1 : group.length / 4;
          that.selectGroupPageNum = [];
          for (let i = 0; i < totalPage; i++) {
            that.selectGroupPageNum.push("第" + (i + 1) + "页");
          }
          that.handleCollaborateData(that.logData, that.analyserUserData, group);
        } else if (type == "achievement") {
          that.projectOutcomeEcharts(that.logData, that.group);
        }
      }
    },
    // 项目成果图
    projectOutcomeEcharts(userData, group) {
      this.projectOutcomeEchartsLoading = true;

      this.fake.start();
      this.groupDatas.length > 0 &&
        this.groupDatas.map((x) => {
          let obj = x;
          for (let i = 0; i < group.length; i++) {
            if (x.id == group[i].id) {
              obj.name = group[i].name;
              obj.user = group[i];
            }
          }
          return obj;
        });
      let addNodes = [];
      let linksArr = [];
      let dataLists = [];
      for (let m = 0; m < userData.length; m++) {
        let nodeData = JSON.parse(userData[m].text);
        if (nodeData.type == "addNode") {
          addNodes.push(userData[m]);
        }
      }
      for (let i = 0; i < this.groupDatas.length; i++) {
        let iconCardNum = 0;
        dataLists[i] = [];
        dataLists[i][0] = {
          id: this.groupDatas[i].id,
          type: "icon-card",
          symbolSize: 1,
          x: 50,
          y: 50,
          name: this.groupDatas[i].name,
          color: "#60416A",
          borderColor: "#60416A",
        };
        if (
          this.groupDatas[i].data &&
          this.groupDatas[i].data.nodes &&
          this.groupDatas[i].data.nodes.length > 0
        ) {
          this.groupDatas[i].data.nodes.map((x) => {
            if (x.type == "icon-card") {
              iconCardNum++;
              let obj = {
                id: x.id,
                symbolSize: iconCardNum,
                width:
                  50 + iconCardNum * 5 > 150
                    ? (50 + iconCardNum * 5) / 10 + 150
                    : 50 + iconCardNum * 5,
                height:
                  50 + iconCardNum * 5 > 150
                    ? (50 + iconCardNum * 5) / 10 + 150
                    : 50 + iconCardNum * 5,
                text: this.groupDatas[i].name,
                type: "icon-card",
                color: "#60416A",
                borderColor: "#60416A",
              };
              dataLists[i][0] = obj;
            } else if (x.type == "icon-theme" && x.properties.topic) {
              let obj = {
                id: x.id,
                symbolSize: 0,
                width: 80,
                height: 80,
                text: x.properties.topic,
                type: "icon-theme",
                color: "#8CBBD7",
                borderColor: "#8CBBD7",
              };
              dataLists[i].push(obj);
            }
            return x;
          });
        }
        if (
          this.groupDatas[i].data &&
          this.groupDatas[i].data.edges &&
          this.groupDatas[i].data.edges.length > 0
        ) {
          for (let j = 0; j < this.groupDatas[i].data.edges.length; j++) {
            for (let m = 0; m < dataLists[i].length; m++) {
              if (
                dataLists[i][m].id == this.groupDatas[i].data.edges[j].sourceNodeId ||
                dataLists[i][m].id == this.groupDatas[i].data.edges[j].targetNodeId
              ) {
                dataLists[i][m].symbolSize = dataLists[i][m].symbolSize + 1;
              }
            }
          }
        }

        let usrobj = this.groupDatas[i].user;
        if (usrobj && usrobj.group_member) {
          for (let j = 0; j < usrobj.group_member.length; j++) {
            let s =
              dataLists[i].length > 0 &&
              dataLists[i].filter((x) => x.type == "icon-theme" && x.symbolSize > 0);
            if (this.groupDatas[i].id == usrobj.id && s.length > 0) {
              let o = {
                id: this.groupDatas[i].user.group_member[j].userid,
                symbolSize: 0,
                width: 50,
                height: 50,
                text: this.groupDatas[i].user.group_member[j].name,
                color: "#56A3F1",
                borderColor: "#56A3F1",
                type: "user",
              };
              dataLists[i].push(o);
            }
          }
        }

        dataLists[i].map((x) => {
          if (x.type && x.type != "icon-card" && x.symbolSize != 0) {
            let obj = {
              id: x.id,
              from: dataLists[i][0].id,
              to: x.id,
            };
            linksArr.push(obj);
          }
        });
        for (let m = 0; m < addNodes.length; m++) {
          let textData = JSON.parse(addNodes[m].text);
          for (let a = 0; a < dataLists[i].length; a++) {
            if (addNodes[m].userid == dataLists[i][a].id) {
              dataLists[i][a].symbolSize = dataLists[i][a].symbolSize + 1;
            }
            if (dataLists[i][a].type == "icon-theme" && dataLists[i][a].symbolSize != 0) {
              for (let c = 0; c < textData.data.nodes.length; c++) {
                if (dataLists[i][a].id == textData.data.nodes[c].id) {
                  let obj = {
                    id: addNodes[m].userid,
                    from: dataLists[i][a].id,
                    to: addNodes[m].userid,
                  };
                  linksArr.push(obj);
                }
              }
            }
          }
        }
      }
      let nodeData = dataLists.flat();
      dataLists = nodeData.filter((x) => x.symbolSize != 0);
      dataLists.unshift({
        text: this.theme,
        id: "mm",
        width: 150,
        height: 150,
        color: "#22314F",
        borderColor: "#22314F",
      });
      let aa = [];
      dataLists.length > 0 &&
        dataLists.map((x) => {
          let o = x;
          for (let i = 0; i < userData.length; i++) {
            if (o.id == userData[i].userid) {
              let num = o.symbolSize + 1;
              o.symbolSize = num;
              let a = num > 150 ? num / 100 : num;
              o.width = 50 + a;
              o.height = 50 + a;
            }
          }
          if (x.type == "icon-card") {
            let obj = {
              id: x.id,
              from: "mm",
              to: x.id,
            };
            linksArr.unshift(obj);
          }
          return o;
        });
      dataLists.map((x) => {
        for (let m = 0; m < linksArr.length; m++) {
          if (x.id == linksArr[m].id || x.id == linksArr[m].from) {
            aa.push(x);
          }
        }
      });
      this.showSeeksGraph(aa, linksArr);
    },
    async getChatTimes(groupId, userId) {
      let that = this;
      let speechesTimes = 0;
      await that.$ajax
        .post("https://gpt.cocorobo.cn/get_user_chat_times", {
          groupId: groupId,
          userId: userId,
        })
        .then(function (response) {
          // console.log(response,groupId,userId)
          speechesTimes = response.data.FunctionResponse[0].count;
        })
        .catch(function (error) {
          console.log(error);
          speechesTimes = 0;
        });
      return speechesTimes;
    },
    loadJsonData(e) {
      let loadingInstance = Loading.service({ fullscreen: true });
      var file = e.target.files[0];
      var reader = new FileReader();
      this.sendUpdate([], [], "clean", 0);
      this.add_Operation({}, "clean");
      // this.lf.clearData();
      reader.onload = (e) => {
        if (e.target) {
          var data = e.target.result;
          if (data) {
            data = JSON.parse(data);
          }
          var _this = this;
          setTimeout(function () {
            // _this.initLogicFlow(data)
            localStorage.setItem("background", data.backgroundUrl);
            // _this.isAutomatic = true
            // localStorage.setItem("data", JSON.stringify(data))
            // _this.lf.graphModel.background = {
            //   backgroundImage: 'url(' + data.backgroundUrl + ')',
            //   backgroundRepeat: 'no-repeat',
            //   backgroundSize: 'cover',
            //   backgroundColor: '#F2F2F2'
            // }
            _this.isAutomatic = false;
            let nodeIds = [];
            for (let i = 0; i < data.nodes.length; i++) {
              nodeIds.push(data.nodes[i].id);
            }
            let edges = [];
            for (let i = 0; i < data.edges.length; i++) {
              if (
                nodeIds.indexOf(data.edges[i].sourceNodeId) != -1 &&
                nodeIds.indexOf(data.edges[i].targetNodeId) != -1
              ) {
                edges.push(data.edges[i]);
              }
            }
            data.edges = edges;
            // _this.sendUpdate(data.nodes, data.edges, "update", 0)
            // _this.lf.graphModel.graphDataToModel(data)
            _this.initLogicFlow(data);
            // _this.lf.options.grid = data.backgroundUrl != "" ? false : true
            // _this.lf.options.background = {
            //   backgroundImage: 'url(' + data.backgroundUrl + ')',
            //   backgroundRepeat: 'no-repeat',
            //   backgroundSize: 'cover',
            //   backgroundColor: '#F2F2F2'
            // };
            // _this.lf.graphModel.partial = false
            // _this.lf.render(_this.lf.getGraphData())
            // _this.lf.graphModel.partial = true
            _this.sendUpdate(data.nodes, data.edges, "update", 0);
            let newData = {
              nodes: data.nodes,
              edges: data.edges,
              backgroundUrl: localStorage.getItem("background"),
            };
            _this.add_Operation(newData, "addNode");
            $("#JsonFile").val("");
            // window.location.reload()
            _this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          }, 3000);
        }
      };
      reader.readAsText(file);
    },
    handleCommand(command) {
      if (command == "a") {
        localStorage.removeItem("username");
        localStorage.setItem("login", 0);
        this.$emit("login", 0);
      }
    },
    $_loginout() {
      let that = this;
      let params =
        window.location.href.indexOf("localhost") != -1 ||
        window.location.href.indexOf("192.168") != -1
          ? "mode=" +
            [
              "quitcscl",
              encodeURIComponent(
                encodeURIComponent(
                  JSON.stringify({
                    docId: localStorage.getItem("roomId"),
                    pageId: "d7300d31-8cf6-38dc-e295-2c71622b4df1",
                    userId: "1cf9dc4b-d95f-11ea-af4c-52540005ab01",
                    type: "cscl",
                  })
                )
              ),
            ].join(",")
          : "mode=" +
            [
              "quitcscl",
              encodeURIComponent(
                encodeURIComponent(
                  JSON.stringify({
                    docId: localStorage.getItem("roomId"),
                    pageId: top.US.pageId,
                    userId: top.US.userInfo.userid,
                    type: "cscl",
                  })
                )
              ),
            ].join(",");
      this.$ajax
        .post("https://poll.cocorobo.cn", params)
        .then((res) => {
          // console.log(res.data)
          if (res.data == "quitcscl") {
            localStorage.clear();
            //window.location.reload()
          }
        })
        .catch((err) => {
          console.error(err);
          that.$message({
            message: err,
            type: "error",
          });
        });
    },
    $_saveGraph(value) {
      if (value == 1) {
        // this.lf.extension.snapshot.getSnapshot();
        this.lf.getSnapshot(null, {
          partial: false,
        });
      }
      // else if (value == 2) {
      //   const data = this.lf.getGraphData()
      //   const xml = lfJson2Xml(data)
      //   this.download('logic-flow.xml', xml);
      // }
      else {
        const data = this.lf.getGraphData();
        data.backgroundUrl = localStorage.getItem("background");
        this.download("logic-flow.json", JSON.stringify(data));
      }
    },
    $_importGraph(value) {
      if (value == 1) {
        document.getElementById("XmlFile").click();
      } else {
        document.getElementById("JsonFile").click();
      }
    },
    $_importData() {
      this.importDialogVisible = true;
    },
    $_exportData() {
      this.exportDialogVisible = true;
    },
    download(filename, text) {
      window.sessionStorage.setItem(filename, text);
      const element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    showSeeksGraph(nodes, lines) {
      // let that = this;
      const __graph_json_data = {
        rootId: "a",
        nodes: [
          {
            id: "a",
            text: "如何编演一场《三打白骨精》的皮影戏？",
            width: 150,
            height: 150,
            color: "#22314F",
            borderColor: "#22314F",
          },
          {
            id: "b",
            text: "陈同学",
            width: 100,
            height: 100,
            color: "#60416A",
            borderColor: "#60416A",
          },
          {
            id: "c",
            text: "李同学",
            width: 100,
            height: 100,
            color: "#60416A",
            borderColor: "#60416A",
          },
          {
            id: "d",
            text: "刘同学",
            width: 100,
            height: 100,
            color: "#60416A",
            borderColor: "#60416A",
          },
          {
            id: "e",
            text: "张同学",
            width: 100,
            height: 100,
            color: "#60416A",
            borderColor: "#60416A",
          },
          {
            id: "f",
            text: "王同学",
            width: 100,
            height: 100,
            color: "#60416A",
            borderColor: "#60416A",
          },
          {
            id: "g",
            text: "探索实践",
            width: 80,
            height: 80,
            color: "#8CBBD7",
            borderColor: "#8CBBD7",
            data: { isParticipate: false, type: "task" },
          },
          {
            id: "h",
            text: "准备材料",
            width: 80,
            height: 80,
            color: "#8CBBD7",
            borderColor: "#8CBBD7",
            data: { isParticipate: false, type: "task" },
          },
          {
            id: "i",
            text: "编写剧本",
            width: 80,
            height: 80,
            color: "#8CBBD7",
            borderColor: "#8CBBD7",
            data: { isParticipate: false, type: "task" },
          },
          {
            id: "j",
            text: "调查研究",
            width: 80,
            height: 80,
            color: "#8CBBD7",
            borderColor: "#8CBBD7",
            data: { isParticipate: false, type: "task" },
          },
          {
            id: "k",
            text: "准备材料",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "l",
            text: "调查研究",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "m",
            text: "成立项目团队",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "n",
            text: "成立项目团队",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "o",
            text: "成立项目团队",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "p",
            text: "探索实践",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "q",
            text: "成立项目团队",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "r",
            text: "编写剧本",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
          {
            id: "s",
            text: "成立项目团队",
            width: 80,
            height: 80,
            color: "#AED6F3",
            borderColor: "#AED6F3",
            data: { isParticipate: true, type: "task" },
          },
        ],
        lines: [
          {
            from: "a",
            to: "b",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
          },
          {
            from: "a",
            to: "c",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
          },
          {
            from: "a",
            to: "d",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
          },
          {
            from: "a",
            to: "e",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
          },
          {
            from: "a",
            to: "f",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
          },
          {
            from: "b",
            to: "g",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "d",
            to: "h",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "e",
            to: "i",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "c",
            to: "j",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "b",
            to: "k",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "b",
            to: "l",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "b",
            to: "m",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "c",
            to: "n",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "d",
            to: "o",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "d",
            to: "p",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "e",
            to: "q",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "f",
            to: "r",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },
          {
            from: "f",
            to: "s",
            text: "",
            color: "#000000",
            fontColor: "#000000",
            isHideArrow: true,
            data: { isParticipate: true, type: "task" },
          },

          {
            from: "f",
            to: "i",
            text: "",
            color: "#FF0000",
            fontColor: "#FF0000",
            isHideArrow: true,
            lineShape: 1,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "b",
            to: "j",
            text: "",
            color: "#FF0000",
            fontColor: "#FF0000",
            isHideArrow: true,
            lineShape: 1,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "b",
            to: "h",
            text: "",
            color: "#FF0000",
            fontColor: "#FF0000",
            isHideArrow: true,
            lineShape: 1,
            data: { isParticipate: false, type: "task" },
          },
          {
            from: "d",
            to: "g",
            text: "",
            color: "#FF0000",
            fontColor: "#FF0000",
            isHideArrow: true,
            lineShape: 1,
            data: { isParticipate: false, type: "task" },
          },
        ],
      };

      __graph_json_data.nodes = nodes;
      __graph_json_data.lines = lines;
      this.projectOutcomeEchartsLoading = false;
      this.fake.end();
      // 以上数据中的node和link可以参考"Node节点"和"Link关系"中的参数进行配置
      this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (graphInstance) => {
        // Called when the relation-graph is completed
        // 这些写上当图谱初始化完成后需要执行的代码
        graphInstance.startAutoLayout();
        graphInstance.refresh();
        setTimeout(() => {
          graphInstance.stopAutoLayout();
        }, 2000);
      });
      // that.$refs['result_map_'].setJsonData(__graph_json_data, (graphInstance) => {
      //   // Called when the relation-graph is completed
      //   // 这些写上当图谱初始化完成后需要执行的代码
      //   graphInstance.startAutoLayout();
      //   graphInstance.refresh()
      //   setTimeout(() => {
      //     graphInstance.stopAutoLayout();
      //   }, 2000);
      // })
      // this.group.forEach(item => {

      // })
    },
    onNodeClick(nodeObject) {
      console.log("onNodeClick:", nodeObject);
      const allLinks = this.$refs.seeksRelationGraph.getLinks();
      allLinks.forEach((link) => {
        // 还原所有样式
        link.relations.forEach((line) => {
          if (line.data.orignColor) {
            line.color = line.data.orignColor;
          }
          if (line.data.orignFontColor) {
            line.fontColor = line.data.orignColor;
          }
          if (line.data.orignLineWidth) {
            line.lineWidth = line.data.orignLineWidth;
          }
        });
      });
      // 让与{nodeObject}相关的所有连线高亮
      allLinks
        .filter((link) => link.fromNode === nodeObject || link.toNode === nodeObject)
        .forEach((link) => {
          link.relations.forEach((line) => {
            line.data.orignColor = line.color;
            line.data.orignFontColor = line.fontColor || line.color;
            line.data.orignLineWidth = line.lineWidth || 1;
            line.color = "#ff0000";
            line.fontColor = "#ff0000";
            line.lineWidth = 3;
          });
        });
      // 有时候更改一些属性后，并不能马上同步到视图，这需要以下方法让视图强制根据数据同步到最新
      this.$refs.seeksRelationGraph.getInstance().dataUpdated();
    },
    onLineClick(lineObject) {
      console.log("onLineClick:", lineObject);
      // this.$notify({
      //   title: '点击连线：',
      //   type: 'success',
      //   message: '点击了线:' + linkObject.fromNode.text + ' to ' + linkObject.toNode.text
      // });
    },
    getIsHidden(val) {
      if (!val) {
        this.isShowGroup = false;
        // this.chat_room_switch = false;
        this.activeNodes = [];
      }
      this.isHidden = val;
    },
    handleMouseover() {
      // if(!this.isJobReception) {
      //   this.isHidden = true
      // }
    },
    setSelectionRange(input, selectionStart, selectionEnd) {
      if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(selectionStart, selectionEnd);
      } else if (input.createTextRange) {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveEnd("character", selectionEnd);
        range.moveStart("character", selectionStart);
        range.select();
      }
    },
    changeSelect() {
      this.$nextTick(() => {
        if (!this.lf.getEditConfig().isSilentMode) {
          // this.activeNodes = []
          const { nodes } = this.lf.getSelectElements();
          const myObject = ref({});
          myObject.value.activeNodes = nodes;
          this.activeNodes = nodes;
          this.$_getProperty();
          if (nodes.length != 0) {
            this.last_node_id = nodes[0].id;
          }
          if (this.activeNodes.length != 0) {
            localStorage.setItem("type", this.activeNodes[0].type);
            // const edgeData = this.lf.graphModel.getNodeIncomingEdge(this.activeNodes[0].id)
            // let arr = [];
            // for (let i = 0; i < edgeData.length; i++) {
            //   arr.push({ "id": edgeData[i].sourceNodeId, "route": edgeData[i].properties.route })
            // }
            // localStorage.setItem("edges", JSON.stringify(arr))
            let data = this.lf.getGraphData();
            for (let i = 0; i < data.nodes.length; i++) {
              this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                isShowDelete: false,
              });
            }
            this.lf.graphModel.getNodeModelById(this.activeNodes[0].id).setProperties({
              isShowDelete: true,
            });
            // if (this.activeNodes[0].properties.width && this.activeNodes[0].properties.height) {
            //   this.$_setStyle({
            //     id: this.activeNodes[0].id,
            //     type: this.activeNodes[0].type,
            //     width: this.activeNodes[0].properties.width,
            //     height: this.activeNodes[0].properties.height
            //   })
            // }
            if (
              this.activeNodes[0].properties.nodeSize &&
              this.activeNodes[0].properties.nodeSize.width &&
              this.activeNodes[0].properties.nodeSize.height
            ) {
              this.$_setStyle({
                id: this.activeNodes[0].id,
                type: this.activeNodes[0].type,
                width: this.activeNodes[0].properties.nodeSize.width,
                height: this.activeNodes[0].properties.nodeSize.height,
              });
            } else {
              this.$_setStyle({
                id: this.activeNodes[0].id,
                type: this.activeNodes[0].type,
              });
            }
            this.iconList = this.activeNodes[0].properties.iconList;
            this.imageList = this.activeNodes[0].properties.imageList;
            this.videoList = this.activeNodes[0].properties.videoList;
            this.audioList = this.activeNodes[0].properties.audioList;
            this.fileList = this.activeNodes[0].properties.fileList;
          }
        } else {
          this.lf.clearSelectElements();
          let data = this.lf.getGraphData();
          for (let i = 0; i < data.nodes.length; i++) {
            // if (data.nodes[i].properties.width && data.nodes[i].properties.height) {
            //   this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
            //     width: data.nodes[i].properties.width,
            //     height: data.nodes[i].properties.height,
            //     isShowDelete: false
            //   });
            // }
            if (
              data.nodes[i].properties.nodeSize &&
              data.nodes[i].properties.nodeSize.width &&
              data.nodes[i].properties.nodeSize.height
            ) {
              this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                width: data.nodes[i].properties.nodeSize.width,
                height: data.nodes[i].properties.nodeSize.height,
                isShowDelete: false,
              });
            } else {
              this.lf.graphModel.getNodeModelById(data.nodes[i].id).setProperties({
                isShowDelete: false,
              });
            }
          }
        }
      });
    },
    onBeginDraw() {
      if (!this.lf.getEditConfig().isSilentMode) {
        const drawNodeModels = this.lf.graphModel.nodes.filter(node => node.type === 'draw-node')
        drawNodeModels.map(drawNodeModel => { drawNodeModel.visible = false })
        this.darwPresets = drawNodeModels
        this.isDrawing = true
      }
    },
    onDrawDone(kvNodeProperties) {
      const nodes = this.lf.graphModel.nodes.filter(node=> node.type === 'draw-node')
      nodes.map((node) => {
        this.lf.deleteNode(node.id)
      })
      this.sendUpdate(nodes.map(node => node.getData()), [], "delete", 0);

      const newNodes = []
      kvNodeProperties.map(props => {
        newNodes.push(this.lf.addNode({
          type: 'draw-node',
          ...props.rect,
          properties: {
            ...props,
          }
        }).getData())
      })
      this.sendUpdate(newNodes, [], "update", 0);
      this.isDrawing = false
    }
  },
};
</script>

<style>
.el-badge {
  position: absolute;
  cursor: pointer;
  bottom: 50px;
  right: 10px;
}
.chat_room_div {
  margin-bottom: 50px;
}
.DiagramRBToolbarDiv {
  position: absolute;
  bottom: 20px;
  z-index: 10;
  right: 40px;
}

.rel-map {
  position: relative;
}

.c-mini-toolbar {
  top: 27%;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

.c-mb-child-panel {
  margin-left: 43px !important;
}

.dropdownPop {
  left: 94% !important;
  top: 6% !important;
}

.lf-menu {
  width: auto;
}

#way .el-dialog__wrapper {
  z-index: 100000000 !important;
}

#way .el-dialog {
  margin-top: 0 !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background: none;
  box-shadow: none;
}

#way .el-dialog__header {
  width: calc(100% - 48px);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  background: var(--font-icon-white, #fff);
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-top: 1px solid var(--bg3, #e7e7e7);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  padding: 8px 24px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
}

#way .el-dialog__body {
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  padding: 0;
  background: var(--font-icon-white, #fff);
  padding: 8px 24px;
  width: calc(100% - 48px);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  height: 10%;
}

/* #way .el-dialog__headerbtn {
  top: none;
}

#way i:hover {
  color: #5cb6ff;
} */

#replace {
  position: absolute;
  /* top: 4px; */
  right: 20px;
  /* width: 40px;
  height: 30px; */
  /* background: #FFFFFF; */
  border: none;
}

/* #replace:hover {
  background: #ced4da;
} */

#newAnalyse .el-tabs {
  height: 100%;
}

#newAnalyse .el-tabs__content {
  width: calc(100% - 30px);
  height: 100%;
  background: #ffffff;
  overflow-y: auto;
}

/* #newAnalyse #pane-student {
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  margin-bottom: 30px;
} */

#newAnalyse .user_avatar {
  width: 25px;
  height: 25px;
  position: relative;
  /* padding: 0 2px; */
  white-space: nowrap;
  line-height: 25px;
  margin: 2px;
  text-align: center;
  border-radius: 50%;
  background: #eba23b;
  color: #fff;
  cursor: pointer;
}

#newAnalyse .el-tabs--border-card {
  border: none;
}

#newAnalyse .radar_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 200px; */
  margin-top: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

#newAnalyse .columnar_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 460px; */
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

#newAnalyse .stacked_area_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 460px; */
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}
#newAnalyse .personger_kanban {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 460px; */
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 30px 10px 10px;
  position: relative;
}
#newAnalyse .personger_kanban .personger_user {
  text-align: center;
  margin-bottom: 30px;
}
#newAnalyse .personger_kanban .personger_user span {
  padding: 20px;
  border-radius: 50%;
  background-color: #eba23b;
}
#newAnalyse .personger_kanban .personger_card {
  position: relative;
  width: 90%;
  font-size: 16px;
  margin: 0 auto;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.52), 0 0 6px 0 rgba(0, 0, 0, 0.14);
  border-radius: 5px;
  /* min-height: 60px; */
}
#newAnalyse .personger_kanban .personger_card h4 {
  padding: 5px;
  margin: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #fff;
}
#newAnalyse .personger_kanban .personger_card div {
  padding: 5px;
  min-height: 50px;
}
#newAnalyse .relational_graph_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 460px; */
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

#newAnalyse .result_map_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

#newAnalyse .pie_share_group_chart {
  border: 1px solid #e4e7ed;
  width: calc(100% - 30px);
  /* height: 460px; */
  margin-top: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  padding: 10px;
}

#newAnalyse .el-input__icon {
  line-height: 1;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: auto;
}

/* #newAnalyse #pane-collaborate {
  width: 100%; 
  height: 100%;
  padding-bottom: 20px; 
} */

#newAnalyse #pane-achievement {
  /* width: 100%; */
  /* height: 100%; */
  padding-bottom: 20px;
}

#sendCard .el-dialog {
  margin-top: 0 !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background: none;
  box-shadow: none;
  padding: 0;
}

#sendCard .el-dialog__header {
  width: calc(100% - 48px);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  background: var(--font-icon-white, #fff);
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-top: 1px solid var(--bg3, #e7e7e7);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  padding: 8px 24px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
}

#sendCard .el-dialog__body {
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  padding: 0;
  background: var(--font-icon-white, #fff);
  padding: 8px 24px;
  width: calc(100% - 48px);
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  height: 15%;
}

#sendCard .el-dialog__footer {
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-top: 1px solid var(--bg3, #e7e7e7);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  padding: 8px 24px;
  background: var(--font-icon-white, #fff);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  width: calc(100% - 48px);
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  box-sizing: unset;
}

#sendCard .close,
#way .close {
  position: absolute;
  top: 0;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

#whiteBoard .el-dialog {
  margin-top: 0 !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background: none;
  box-shadow: none;
  padding: 0;
}

#whiteBoard .el-dialog__wrapper {
  overflow: hidden;
}

#whiteBoard .el-dialog__header {
  width: calc(100% - 48px);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  background: var(--font-icon-white, #fff);
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-top: 1px solid var(--bg3, #e7e7e7);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  padding: 8px 24px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0;
}

#whiteBoard .el-dialog__body {
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  padding: 0;
  /* background: var(--font-icon-white,#fff); */
  padding: 8px 24px;
  width: calc(100% - 48px);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
}

#whiteBoard .close {
  position: absolute;
  top: 0;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

#background .el-dialog {
  margin-top: 0 !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background: none;
  box-shadow: none;
  padding: 0;
}

#background .el-dialog__wrapper {
  overflow: hidden;
}

#background .el-dialog__header {
  width: calc(100% - 48px);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  background: var(--font-icon-white, #fff);
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-top: 1px solid var(--bg3, #e7e7e7);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  padding: 8px 24px;
  height: 23px;
  display: flex;
  justify-content: center;
  margin-right: 0;
}

#background .el-dialog__body {
  border-left: 1px solid var(--bg3, #e7e7e7);
  border-right: 1px solid var(--bg3, #e7e7e7);
  border-bottom: 1px solid var(--bg3, #e7e7e7);
  padding: 0;
  /* background: var(--font-icon-white,#fff); */
  padding: 8px 24px;
  width: calc(100% - 48px);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.0784313725490196);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.0392156862745098);
  box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.050980392156862744);
  height: 120px;
}

#background .close {
  position: absolute;
  top: 0;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

.lf-diagram canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.el-message-box {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}

#pane-collaborate .el-select,
#pane-student .el-select {
  width: 12%;
}
</style>

<style scoped>
.ai_dialogue {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0%;
  left: -30px;
  background: #3681fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 50%, 148% 160%, 100% 0%, 100% 100%, 0 100%, 0 0, 83% 0);
  border-radius: 50%;
}
.MessageDialog {
  position: absolute;
  top: 6vh;
  right: 0;
  left: 0;
  margin-right: auto;
  margin-left: auto;
}
.echarts_item {
  margin-top: 20px;
  border-radius: 5px;
  border: 1px Solid #eaeaea;
  padding: 10px;
  position: relative;
}

.echarts_content {
  width: 27vw;
  height: 550px;
  margin: 0 auto;
  background-color: #fff;
}

.all_item {
  width: 30vw;
  height: 90vh;
}

.resultStyle {
  width: 100%;
  height: 100%;
  /* display: flex;
  flex-direction: row; */
  align-items: center;
  padding: 10px;
  margin-bottom: 20px;
}

.resultStyleDiv {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.top_menu {
  background: #2c2b2b;
  border-radius: 0 0 25% 25%;
  opacity: 0.4;
  position: absolute;
  left: 50%;
  display: flex;
  justify-content: center;
  z-index: 10;
  cursor: pointer;
}

.top_menu i {
  font-size: 36px;
  color: #fff;
}

.user_group_flag {
  position: absolute;
  right: 10vw;
  background: #2c2b2b;
  border-radius: 0 0 25% 25%;
  opacity: 0.4;
  display: flex;
  justify-content: center;
  z-index: 9;
  cursor: pointer;
}

.user_group_flag i {
  font-size: 36px;
  color: #fff;
  margin: 0;
}

.user_group {
  padding: 2px 2px;
  background: #e6e6e6;
  border-radius: 0 0 10px 10px;
  position: absolute;
  right: 2vw;
  display: flex;
  flex-direction: row;
  z-index: 10;
}

.point {
  width: 8px;
  height: 8px;
  position: absolute;
  bottom: 3px;
  right: 2px;
  border-radius: 50%;
  background: #49ace0;
}

.user_group_avatar {
  width: 40px;
  height: 40px;
  position: relative;
  padding: 0 2px;
  white-space: nowrap;
  line-height: 40px;
  margin: 3px;
  text-align: center;
  border-radius: 50%;
  background: #eba23b;
  color: #fff;
  cursor: pointer;
}

.innerbox::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

/* 滚动条 */
.innerbox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

/* 滚动条背景 */
.innerbox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.diagram {
  width: 100%;
  height: 100%;
}

.diagram button {
  box-sizing: border-box;
}

.diagram .diagram-toolbar {
  box-sizing: border-box;
}

.diagram-toolbar {
  /* position: absolute;
  top: 60px;
  left: 40%; */
  height: 40px;
  /* width: 250px; */
  width: 490px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  z-index: 1031;
  background: #ffffff;
  padding-left: 10px;
  padding-right: 10px;
}

.diagram-main {
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 1029;
  overflow: hidden;
}

.diagram-sidebar {
  width: 300px;
  height: 100%;
  border-right: 1px solid #dadce0;
  border-bottom: 1px solid #dadce0;
  padding: 0px;
  /* background: #F0F8FF; */
  z-index: 1032;
}

.diagram-panel {
  background: #fff;
  height: 100%;
  /* position: absolute;
  right: 0px;
  top: 60px; */
  border-left: 1px solid #dadce0;
  z-index: 2000;
}

.diagram-container {
  flex: 1;
  /* z-index:1029; */
  position: relative;
}

/* 由于背景图和gird不对齐，需要css处理一下 */
.diagram :deep() .lf-background {
  left: 0px;
}

.diagram-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
}

.draw-board {
  position: absolute;
  inset: 0;
}

.lf-diagram {
  /* box-shadow: 0px 0px 4px #838284; */
  width: 100%;
  height: 100%;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background: white;
  border-left: 1px solid #e8e8e8;
}

::-webkit-scrollbar-thumb {
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  border-radius: 6px;
  background: #c9c9c9;
}

::-webkit-scrollbar-thumb:hover {
  background: #b5b5b5;
}

.header_bg {
  background-image: url("../assets/header_bg.png");
  background-size: 100% 100%;
  height: 6%;
  line-height: 56.22px;
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 1rem;
  color: rgb(255, 255, 255);
}

.el-icon-arrow-down {
  font-size: 12px;
}

.gropu_all_name {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  white-space: pre;
  text-overflow: ellipsis;
}
.user_class {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* min-width: 375px; */
}
.echarts_item .el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.echarts_item .el-checkbox-group .el-checkbox-button__inner {
  border-radius: 4px;
}
</style>
